import { garantirTracabiliteReception, champsTraceContact } from './tracabilite';
import { calculerCoherence } from './coherenceTresorerie';
// Couche d'accès aux données — MOCKED (localStorage).
// Prête pour Supabase : remplacer chaque fonction par supabase.from('<table>')…
import { publier, aToken, tiersAvecPortail } from './portail';
import { surEcriture, ecrireLocalSeulement, donneesPretes, publierMaintenant } from './store';
import { envoyerCommande, nouvelIdOperation } from './financeCommandes';
import { getBranding } from './branding';
import { getTarifs, tarifTriturationPour } from './tarifs';
import { parametresMinimum, instantaneMinimum, passageHomogene } from './minimumTrituration';
import { getAutoValidation, AUTO_VALIDATION_AUTEUR } from './validation';
import { getCoursDuJour } from './cours';
import { attribuerNumero, numeroAttribue } from './souches';
import { rapprocher } from './matching';
import { clientsDistincts } from './prorataHuile';

// Règle d'attribution de l'huile : exposée ici pour les écrans existants.
export { repartirProrata, cleGroupeHuile, clientsDistincts } from './prorataHuile';

// Tarification 100 % dynamique : chaque réception porte son propre tarif de
// trituration (parcours client) ou son prix de base d'huile (achat fournisseur).

export const PARCOURS = [
  { id: 'client', label: 'Client (Prestation de service / Trituration)', hint: 'L’huile appartient au client' },
  { id: 'fournisseur', label: 'Fournisseur (Achat d’olives)', hint: 'L’huilerie achète les olives' },
];

export const QUALITES = [
  { id: 'extra_vierge', label: 'Extra-Vierge', famille: 'noble' },
  { id: 'vierge', label: 'Vierge', famille: 'noble' },
  { id: 'lampante', label: 'Lampante', famille: 'lampante' },
];

export const MODES_ACHAT = [
  { id: 'fixe', label: 'Prix fixe négocié', hint: 'TND / kg d’olives' },
  { id: 'foss', label: 'Rendement FOSS', hint: 'Rendement fosse × prix de base saisis' },
  { id: 'reel', label: 'Rendement réel', hint: 'Prix de base convenu, rendement après décompteur' },
  { id: 'negocier', label: 'À négocier', hint: 'Cours du jour figé, prix fixé plus tard' },
];

export const DEVENIRS = [
  { id: 'cuve', label: 'Stockage en cuve (compte client)' },
  { id: 'sortie', label: 'Sortie immédiate' },
];

export const STATUTS = ['Sur site', 'En attente', 'Planifié', 'En trituration', 'Trituré', 'Décompté'];

// Base de contacts UNIFIÉE : un même tiers peut avoir des opérations de
// prestation (trituration) et des achats d'olives sur un seul compte courant.
const CONTACTS_SEED = [
  { id: 'c1', nom: 'Ferme Ben Salah', type: 'tiers', region: 'Sfax', tel: '+216 74 220 118', mf: '1054721/A/M/000' },
  { id: 'c2', nom: 'GDA Ouled Chamekh', type: 'tiers', region: 'Mahdia', tel: '+216 73 610 402', mf: '0548812/B/N/000' },
  { id: 'c3', nom: 'Domaine El Kef', type: 'tiers', region: 'Le Kef', tel: '+216 78 201 774' },
  { id: 'c4', nom: 'Coopérative Zitouna', type: 'tiers', region: 'Kairouan', tel: '+216 77 330 991', mf: '0549003/C/P/000' },
  { id: 'c5', nom: 'Slim Trabelsi', type: 'tiers', region: 'Sousse', tel: '+216 73 455 120' },
  { id: 'c6', nom: 'Hédi Mansour', type: 'tiers', region: 'Sfax', tel: '+216 74 901 220' },
  { id: 'c7', nom: 'CHO Company', type: 'industriel', region: 'Sfax', tel: '+216 74 400 100', mf: '0231447/A/M/000' },
  { id: 'c8', nom: 'SOTICI Biomasse', type: 'industriel', region: 'Sousse', tel: '+216 73 220 909', mf: '0771902/D/M/000' },
  { id: 'c9', nom: 'Transport Khemiri', type: 'transporteur', region: 'Mahdia', tel: '+216 73 118 774' },
  { id: 'c10', nom: 'Ali Gharbi', type: 'personnel', region: 'Atelier', tel: '+216 90 112 445', cin: '09112445', cnss: '112445-11', contrat: 'Mensuel', salaireJour: 45, salaireMois: 1100 },
  { id: 'c11', nom: 'Mongi Saïdi', type: 'personnel', region: 'Pesée', tel: '+216 92 664 118', cin: '09664118', cnss: '664118-22', contrat: 'Saisonnier (Shift 12h)', salaireJour: 40, salaireMois: 0 },
];

const CONTACTS_KEY = 'oliva.contacts';
const TYPES_UNIFIES = ['client', 'fournisseur', 'agriculteur'];
// Code contact unique et séquentiel : CT-0001, CT-0002… (une seule fiche par tiers).
export const PREFIXE_CONTACT = 'CT-';
const numeroCode = (c) => Number(String(c.code || '').replace(/\D/g, '')) || 0;
const prochainCode = (rows) => `${PREFIXE_CONTACT}${String(Math.max(0, ...rows.map(numeroCode)) + 1).padStart(4, '0')}`;

// C11 : une lecture n'amorce JAMAIS de données de démonstration, même avant
// hydratation. Les constantes historiques restent disponibles pour leurs imports,
// mais aucun lecteur ne les installe dans le cache ou ne les publie.
const amorcerLocal = () => null;

const attribuerCodes = (rows) => {
  if (rows.every((c) => c.code)) return rows;
  let n = Math.max(0, ...rows.map(numeroCode));
  return rows.map((c) => (c.code ? c : { ...c, code: `${PREFIXE_CONTACT}${String(++n).padStart(4, '0')}` }));
};
const readContacts = () => {
  const raw = localStorage.getItem(CONTACTS_KEY);
  if (!raw) return amorcerLocal(CONTACTS_KEY, attribuerCodes(CONTACTS_SEED)) ?? [];
  let rows = JSON.parse(raw);
  let modifie = false;
  if (rows.some((c) => TYPES_UNIFIES.includes(c.type))) {
    rows = rows.map((c) => (TYPES_UNIFIES.includes(c.type) ? { ...c, type: 'tiers' } : c));
    modifie = true;
  }
  if (rows.some((c) => !c.code)) {
    rows = attribuerCodes(rows);
    modifie = true;
  }
  if (modifie) localStorage.setItem(CONTACTS_KEY, JSON.stringify(rows));
  return rows;
};
const writeContacts = (rows) => localStorage.setItem(CONTACTS_KEY, JSON.stringify(rows));

// Catalogue de formats de conditionnement — paramétrable par l'administrateur.
export const FORMATS_SEED = [
  { id: 'a1', nom: 'Bouteille 1 L', litres: 1, prixEmballage: 1.4, stock: 180 },
  { id: 'a2', nom: 'Bouteille 3 L', litres: 3, prixEmballage: 3.2, stock: 90 },
  { id: 'a3', nom: 'Bouteille 5 L', litres: 5, prixEmballage: 5.1, stock: 60 },
  { id: 'a4', nom: 'Bouteille 10 L', litres: 10, prixEmballage: 9.5, stock: 24 },
  { id: 'a5', nom: 'Bidon métallique 20 L', litres: 20, prixEmballage: 24.0, stock: 12 },
  { id: 'a6', nom: 'Bidon plastique SOT 20 L', litres: 20, prixEmballage: 17.5, stock: 30 },
];

export const UNITES = ['Kg'];

const CUVES_SEED = [
  { id: 'v1', nom: 'B1', famille: 'noble', qualite: 'Extra-Vierge', unite: 'Kg', capacite: 30000, volume: 24800, cmp: 9.42, emplacement: 'Hall Nord', proprietaire: 'huilerie' },
  { id: 'v2', nom: 'B2', famille: 'noble', qualite: 'Extra-Vierge', unite: 'Kg', capacite: 30000, volume: 11200, cmp: 9.88, emplacement: 'Hall Nord', proprietaire: 'huilerie' },
  { id: 'v3', nom: 'P1', famille: 'noble', qualite: 'Vierge', unite: 'Kg', capacite: 25000, volume: 23650, cmp: 8.95, emplacement: 'Hall Sud', proprietaire: 'huilerie' },
  { id: 'v4', nom: 'Pile Abdel Aziz', famille: 'noble', qualite: 'Vierge (compte client)', unite: 'Kg', capacite: 25000, volume: 6400, cmp: 0, emplacement: 'Hall Sud', proprietaire: 'clients' },
  { id: 'l1', nom: 'L1 Lampante', famille: 'lampante', qualite: 'Lampante', unite: 'Kg', capacite: 20000, volume: 13900, cmp: 5.6, emplacement: 'Zone lampante', proprietaire: 'huilerie' },
  { id: 'l2', nom: 'L2 Lampante', famille: 'lampante', qualite: 'Lampante', unite: 'Kg', capacite: 20000, volume: 4750, cmp: 5.35, emplacement: 'Zone lampante', proprietaire: 'huilerie' },
];

const CUVES_KEY = 'oliva.cuves';

// Cuve système virtuelle : destination automatique de l'huile emportée
// immédiatement par le client (aucun stock physique à l'huilerie).
export const CUVE_SORTIE_DIRECTE = {
  id: 'CUVE_SORTIE_DIRECTE',
  nom: 'Sortie directe client',
  famille: 'noble',
  qualite: 'Livraison immédiate',
  unite: 'Kg',
  capacite: 99999999,
  volume: 0,
  cmp: 0,
  emplacement: 'Livraison directe',
  proprietaire: 'clients',
  virtuelle: true,
};

const readCuves = () => {
  const raw = localStorage.getItem(CUVES_KEY);
  if (!raw) return amorcerLocal(CUVES_KEY, [...CUVES_SEED, CUVE_SORTIE_DIRECTE]) ?? [CUVE_SORTIE_DIRECTE];
  let rows = JSON.parse(raw);
  if (!rows.some((c) => c.id === CUVE_SORTIE_DIRECTE.id)) rows = [...rows, CUVE_SORTIE_DIRECTE];
  // Migration : stock physique (volume) vs dette en nature clients (volumeClients).
  if (rows.some((c) => c.volumeClients == null)) {
    rows = rows.map((c) => (c.volumeClients == null ? { ...c, volumeClients: c.proprietaire === 'clients' ? c.volume : 0 } : c));
    localStorage.setItem(CUVES_KEY, JSON.stringify(rows));
  }
  // Migration : part d'huile d'origine REPASSAGE présente dans la cuve (coût matière nul).
  if (rows.some((c) => c.volumeRepassage == null)) {
    rows = rows.map((c) => (c.volumeRepassage == null ? { ...c, volumeRepassage: 0 } : c));
    localStorage.setItem(CUVES_KEY, JSON.stringify(rows));
  }
  return rows;
};
const writeCuves = (rows) => localStorage.setItem(CUVES_KEY, JSON.stringify(rows));

// Stock financier (propriété huilerie) = physique − huile des clients. Peut être négatif (emprunt sur stock client).
export const stockFinancier = (c) => Number(((c.volume || 0) - (c.volumeClients || 0)).toFixed(3));
// Stock issu d'ACHATS : seul porteur d'un coût matière. L'huile récupérée par
// repassage appartient à l'huilerie mais son coût matière est nul (le coût des
// olives est déjà affecté à la première extraction) : elle est donc exclue du
// numérateur comme du dénominateur du CMP Achat pur.
export const stockAchat = (c) => Number(Math.max(0, stockFinancier(c) - (c.volumeRepassage || 0)).toFixed(3));
// Valeur matière d'une cuve : respecte la séparation des origines (jamais volume × CMP).
export const valeurMatiere = (c) => Number((stockAchat(c) * (c.cmp || 0)).toFixed(3));
// CMP Achat pur : calculé sur le stock d'achats uniquement (ni huile client, ni repassage).
const cmpApres = (c, kg, prix) => {
  const F = stockAchat(c);
  if (kg <= 0) return c.cmp || 0;
  if (F <= 0) return Number(prix.toFixed(3));
  return Number(((F * (c.cmp || 0) + kg * prix) / (F + kg)).toFixed(3));
};
// Sortie physique : l'origine repassage part au prorata de sa présence dans la cuve.
export const partRepassage = (c, q) =>
  Number(((c.volume || 0) > 0 ? Math.min(c.volumeRepassage || 0, q * ((c.volumeRepassage || 0) / c.volume)) : 0).toFixed(3));
export const estBlocageFiliere = (err) => /BLOCAGE SÉCURITÉ|Affectation croisée interdite|ROUTAGE INTERDIT/.test(err || '');
const journalOverride = (utilisateur, resume) =>
  tracer({ action: 'Override', entite: 'Cuve', refId: '—', resume: `OVERRIDE ADMIN — ${resume}`, utilisateur });

export const TAUX_GRIGNON_2PHASES = 0.7; // t de grignons humides par t d'olives triturées (2 phases) — coefficient configurable
export const COUT_MATIERE_REPASSAGE = 0; // TND / kg — le coût des olives reste affecté à la première extraction
export const PRIX_VENTE_HUILE = 11.5; // TND / kg — prix de vente comptoir par défaut
export const DENOMINATIONS_HUILE = [
  'Huile d’Olive Extra Vierge',
  'Huile d’Olive Vierge',
  'Huile d’Olive Lampante',
  'Huile d’Olive Biologique',
];
export const PAIEMENT_DIFFERE = 'differe';
export const DENSITE_HUILE = 0.916; // 1 litre d'huile d'olive = 0,916 kg

export const FORMATS_VENTE_OBSOLETE = [];

export const litresVersKg = (litres) => Number(((Number(litres) || 0) * DENSITE_HUILE).toFixed(3));
export const kgVersLitres = (kg) => Number(((Number(kg) || 0) / DENSITE_HUILE).toFixed(3));

const FMT_KEY = 'oliva.formats';
const readFormats = () => {
  const raw = localStorage.getItem(FMT_KEY);
  if (!raw) return amorcerLocal(FMT_KEY, FORMATS_SEED) ?? [];
  return JSON.parse(raw);
};
const writeFormats = (v) => localStorage.setItem(FMT_KEY, JSON.stringify(v));

export async function fetchFormats() {
  return readFormats();
}
// Rôles : cochés manuellement ou déduits de l'historique d'opérations.
export async function fetchContactsRoles() {
  const rows = readContacts();
  const receptions = read();
  return rows.map((c) => {
    const ops = receptions.filter((r) => r.tiersId === c.id);
    const autoClient = ops.some((r) => r.parcours === 'client');
    const autoFournisseur = ops.some((r) => r.parcours === 'fournisseur');
    const estClient = c.estClient ?? autoClient;
    const estFournisseur = c.estFournisseur ?? autoFournisseur;
    return {
      ...c,
      estClient,
      estFournisseur,
      autoClient,
      autoFournisseur,
      nbOperations: ops.length,
      mixte: estClient && estFournisseur,
      estAssocie: Boolean(c.estAssocie),
      categorie:
        c.type === 'personnel'
          ? 'personnel'
          : estClient && estFournisseur ? 'agriculteur' : estClient ? 'client' : estFournisseur ? 'fournisseur' : 'aucun',
      typeTiers: typeTiersDe({ ...c, estClient, estFournisseur }),
    };
  });
}

export async function updateContact(id, patch) {
  const propre = { ...patch };
  if (propre.regionDefault) propre.region = propre.regionDefault;
  ['estClient', 'estFournisseur'].forEach((k) => {
    if (k in propre) propre[k] = Boolean(propre[k]);
  });
  const avant = localStorage.getItem(CONTACTS_KEY);
  const next = readContacts().map((c) => (c.id === id ? { ...c, ...propre } : c));
  writeContacts(next);
  if (Object.prototype.hasOwnProperty.call(propre, 'tarifTriturationPersonnalise')) {
    await publierMaintenant(CONTACTS_KEY, avant);
    return { error: null, contact: readContacts().find((c) => c.id === id) };
  }
  return { error: null, contact: next.find((c) => c.id === id) };
}

// Suppression : refusée si le contact porte des opérations (réceptions, ventes, règlements…).
export async function deleteContact(id) {
  const fin = readFin();
  const lie =
    read().some((r) => r.tiersId === id) ||
    readVentes().some((v) => v.tiersId === id) ||
    fin.reglements.some((x) => x.tiersId === id) ||
    fin.mouvements.some((x) => x.tiersId === id) ||
    readPointages().some((p) => p.tiersId === id) ||
    readAchatsHuile().some((a) => a.tiersId === id) ||
    lireFacturesLibres().some((f) => f.tiersId === id);
  if (lie) return { error: 'Ce contact a des opérations enregistrées : suppression impossible (conservez la fiche pour l’historique).' };
  writeContacts(readContacts().filter((c) => c.id !== id));
  return { error: null };
}

// Import Excel (feuilles « Clients » / « Fournisseurs ») : fusion par nom normalisé,
// les fiches existantes sont enrichies (rôles, téléphone), jamais écrasées.
const normNom = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\./g, ' ').replace(/[^A-Z0-9 ]/g, '').replace(/\s+/g, ' ').trim();
const telPropre = (v) => {
  const d = String(v ?? '').replace(/\D/g, '');
  return d.length === 8 ? `+216 ${d}` : d.length > 8 ? d : '';
};
const titre = (s) => String(s).trim().toLowerCase().replace(/(^|\s)\S/g, (m) => m.toUpperCase());

export async function importerContactsExcel(feuilles) {
  const rows = readContacts();
  const index = new Map(rows.map((c) => [normNom(c.nom), c]));
  let ajoutes = 0, enrichis = 0;
  const fusion = (base) => {
    const cle = normNom(base.nom);
    if (!cle) return;
    const c = index.get(cle);
    if (c) {
      Object.entries(base).forEach(([k, v]) => { if (v && !c[k] && k !== 'id') c[k] = v; });
      c.estClient = Boolean(c.estClient) || base.estClient;
      c.estFournisseur = Boolean(c.estFournisseur) || base.estFournisseur;
      enrichis += 1;
      return;
    }
    index.set(cle, base);
    const ids = new Set(rows.map((c) => c.id));
    let id = base.id, n = 2;
    while (ids.has(id)) id = `${base.id}-${n++}`;
    rows.push({ ...base, id, code: prochainCode(rows) });
    ajoutes += 1;
  };
  const enTete = (ligne) => ligne.map((v) => String(v ?? '').toLowerCase());
  const lireFeuille = (lignes, fournisseur) => {
    const iHead = lignes.findIndex((l) => enTete(l).some((v) => v.includes('raison sociale') || v === 'nom'));
    if (iHead < 0) return;
    const h = enTete(lignes[iHead]);
    const col = (...m) => h.findIndex((v) => m.some((x) => v.includes(x)));
    const iNom = col('raison sociale', 'nom'), iTel = col('tél', 'tel'), iCode = col('code', 'numéro', 'numero');
    const iAdr = col('adresse'), iId = col('identifiant', 'cin'), iType = col('type');
    lignes.slice(iHead + 1).forEach((l) => {
      const nom = l[iNom];
      if (!nom || !String(nom).trim()) return;
      const code = iCode >= 0 ? String(l[iCode] ?? '').trim() : '';
      const ident = iId >= 0 ? String(l[iId] ?? '').replace(/\D/g, '') : '';
      fusion({
        id: `${fournisseur ? 'F' : 'C'}-${code || Math.random().toString(36).slice(2, 8).toUpperCase()}`,
        nom: titre(nom), type: 'tiers', region: '—',
        tel: iTel >= 0 ? telPropre(l[iTel]) : '',
        adresse: iAdr >= 0 ? String(l[iAdr] ?? '').trim() : '', mf: '',
        cin: ident.length === 8 ? ident : '',
        estClient: !fournisseur, estFournisseur: fournisseur,
        ...(fournisseur
          ? { codeFournisseur: code, categorieFournisseur: iType >= 0 ? String(l[iType] ?? '').trim() : '' }
          : { codeClient: code, categorieClient: iType >= 0 ? String(l[iType] ?? '').trim() : '' }),
      });
    });
  };
  Object.entries(feuilles).forEach(([nomFeuille, lignes]) => {
    const n = nomFeuille.toLowerCase();
    if (n.includes('fournisseur')) lireFeuille(lignes, true);
    else if (n.includes('client')) lireFeuille(lignes, false);
  });
  if (!ajoutes && !enrichis) return { error: 'Aucune feuille « Clients » ou « Fournisseurs » exploitable dans ce fichier.' };
  writeContacts(rows);
  return { error: null, ajoutes, enrichis, total: rows.length };
}

export async function fetchArticles() {
  return readFormats();
}

// État « base vide » : données métier effacées, configuration conservée
// (utilisateurs, tarifs, souches, formats, branding, contacts, cuves à 0 kg).
const lireBrut = (cle, defaut) => JSON.parse(localStorage.getItem(cle) ?? 'null') ?? defaut;
export function etatPropre() {
  const fin = readFin();
  const sp = readSp();
  return {
    'oliva.receptions.v3': [],
    'oliva.portail.tokens': {},
    'oliva.cuves': readCuves().map((c) => ({ ...c, volume: 0, cmp: 0 })),
    'oliva.contacts': readContacts(),
    'oliva.finances': { comptes: fin.comptes.map((c) => ({ ...c, initial: 0 })), mouvements: [], reglements: [] },
    'oliva.ventes': [],
    'oliva.sousproduits': {
      epandages: [], grignons: [], noyaux: [], repassages: [],
      stocks: { ...sp.stocks, grignons: 0, noyaux: 0 },
    },
    'oliva.formats': readFormats().map((f) => ({ ...f, stock: 0 })),
    'oliva.emballages': [],
    'oliva.appro_emballages': [],
    'oliva.conditionnements': [],
    'oliva.produits_finis': [],
    'oliva.factures_libres': [],
    'oliva.pointages': [],
    'oliva.operations_coursier': [],
    'oliva.ofs': [],
    'oliva.utilisateurs': lireBrut('oliva.utilisateurs', []),
    'oliva.souches': lireBrut('oliva.souches', {}),
    'oliva.numeros': {},
    'oliva.tarifs': lireBrut('oliva.tarifs', {}),
    'oliva.branding': lireBrut('oliva.branding', {}),
    'oliva.audit': [],
    'oliva.achats_huile': [],
    'oliva.bonus': { volume: 0, noble: 0, lampante: 0, valeur: 0, mouvements: [] },
    'oliva.retraits': [],
    'oliva.rapprochement': [],
  };
}

export async function createFormat({ nom, litres, prixEmballage, stock }) {
  const rows = readFormats();
  const nomPropre = String(nom || '').trim();
  if (!nomPropre) return { error: 'Saisissez la désignation du format.' };
  if (!(Number(litres) > 0)) return { error: 'Saisissez le volume du contenant (litres).' };
  if (rows.some((f) => f.nom.toLowerCase() === nomPropre.toLowerCase()))
    return { error: `Le format « ${nomPropre} » existe déjà.` };
  const row = {
    id: `f${Date.now()}`,
    nom: nomPropre,
    litres: Number(litres),
    prixEmballage: Number(prixEmballage) || 0,
    stock: Number(stock) || 0,
  };
  writeFormats([...rows, row]);
  return { error: null, row };
}

export async function updateFormat(id, patch) {
  const num = (v, def) => (Number.isFinite(Number(v)) && String(v).trim() !== '' ? Number(v) : def);
  const next = readFormats().map((f) =>
    f.id === id
      ? {
          ...f,
          ...patch,
          nom: String(patch.nom ?? f.nom).trim() || f.nom,
          litres: patch.litres !== undefined ? num(patch.litres, f.litres) : f.litres,
          prixEmballage: patch.prixEmballage !== undefined ? num(patch.prixEmballage, f.prixEmballage) : f.prixEmballage,
          stock: patch.stock !== undefined ? num(patch.stock, f.stock) : f.stock,
        }
      : f
  );
  writeFormats(next);
  return { error: null, row: next.find((f) => f.id === id) };
}

export async function deleteFormat(id) {
  const row = readFormats().find((f) => f.id === id);
  if (row?.stock > 0) return { error: `« ${row.nom} » contient encore ${row.stock} unités en stock.` };
  writeFormats(readFormats().filter((f) => f.id !== id));
  return { error: null };
}

// --- Produits finis (SKU = format + dénomination) ---

const PF_KEY = 'oliva.produits_finis';
const readPF = () => JSON.parse(localStorage.getItem(PF_KEY) ?? '[]');
const writePF = (v) => localStorage.setItem(PF_KEY, JSON.stringify(v));

export async function fetchProduitsFinis() {
  return readPF();
}

// Prix de vente unitaire par référence (SKU) — remplace le calcul au kilo pour le détail.
export async function majPrixVenteSku(id, prixVente) {
  const prix = Number(prixVente);
  if (!(prix >= 0)) return { error: 'Saisissez un prix de vente valide.' };
  const rows = readPF();
  if (!rows.some((x) => x.id === id)) return { error: 'Référence introuvable.' };
  writePF(rows.map((x) => (x.id === id ? { ...x, prixVente: Number(prix.toFixed(3)) } : x)));
  return { error: null };
}

const skuId = (formatId, denomination) =>
  `${formatId}-${denomination.normalize('NFD').replace(/[^a-zA-Z]/g, '').toLowerCase().slice(0, 12)}`;

const majSku = ({ formatId, format, denomination, unites, coutUnitaire }) => {
  const rows = readPF();
  const id = skuId(formatId, denomination);
  const existant = rows.find((x) => x.id === id);
  if (existant) {
    const stock = existant.stock + unites;
    const cout =
      unites > 0 && stock > 0
        ? Number(((existant.stock * existant.cout + unites * coutUnitaire) / stock).toFixed(3))
        : existant.cout;
    writePF(rows.map((x) => (x.id === id ? { ...x, stock, cout } : x)));
    return { ...existant, stock, cout };
  }
  const row = {
    id,
    formatId,
    formatNom: format.nom,
    litres: format.litres,
    denomination,
    nom: `${format.nom} — ${denomination}`,
    stock: unites,
    cout: Number((coutUnitaire || 0).toFixed(3)),
    prixVente: Number(((coutUnitaire || 0) * 1.3).toFixed(3)),
    prixEmballage: format.prixEmballage,
  };
  writePF([...rows, row]);
  return row;
}

// --- Approvisionnement en emballages vides (achats consommables) ---

const APPRO_KEY = 'oliva.appro_emballages';
const readAppro = () => JSON.parse(localStorage.getItem(APPRO_KEY) ?? '[]');
const writeAppro = (v) => localStorage.setItem(APPRO_KEY, JSON.stringify(v));

export async function fetchApproEmballages() {
  return readAppro();
}

export async function enregistrerApproEmballages({ date, tiersId, fournisseur, piece, lignes, notes }) {
  const formats = readFormats();
  const detail = (lignes || [])
    .map((l) => ({
      formatId: l.formatId,
      unites: Number(l.unites) || 0,
      prixUnitaire: Number(l.prixUnitaire) || 0,
      format: formats.find((f) => f.id === l.formatId),
    }))
    .filter((l) => l.format && l.unites > 0);
  if (detail.length === 0) return { error: 'Saisissez au moins un format et une quantité reçue.' };
  const nomFournisseur = String(fournisseur || '').trim() || nomTiers(tiersId);
  if (!nomFournisseur || nomFournisseur === '—') return { error: 'Sélectionnez le fournisseur.' };

  writeFormats(
    formats.map((f) => {
      const l = detail.find((x) => x.formatId === f.id);
      return l ? { ...f, stock: f.stock + l.unites } : f;
    })
  );

  const rows = readAppro();
  const row = {
    id: `AE-${rows.reduce((m, r) => Math.max(m, Number(String(r.id).split('-')[1]) || 0), 3000) + 1}`,
    date,
    tiersId: tiersId || null,
    fournisseur: nomFournisseur,
    piece: String(piece || '').trim(),
    notes: String(notes || '').trim(),
    lignes: detail.map((l) => ({
      formatId: l.formatId,
      nom: l.format.nom,
      unites: l.unites,
      prixUnitaire: l.prixUnitaire,
      total: Number((l.unites * l.prixUnitaire).toFixed(3)),
    })),
    total: Number(detail.reduce((s, l) => s + l.unites * l.prixUnitaire, 0).toFixed(3)),
    unites: detail.reduce((s, l) => s + l.unites, 0),
  };
  writeAppro([row, ...rows]);
  return { error: null, row };
}

// --- Conditionnement : soutirage d'une cuve vers des produits finis ---

const COND_KEY = 'oliva.conditionnements';
const readCond = () => JSON.parse(localStorage.getItem(COND_KEY) ?? '[]');
const writeCond = (v) => localStorage.setItem(COND_KEY, JSON.stringify(v));

export async function fetchConditionnements() {
  return readCond();
}

export async function enregistrerConditionnement({ date, cuveId, denomination, lignes }) {
  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === cuveId);
  if (!cuve) return { error: 'Sélectionnez la cuve de départ.' };
  if (!DENOMINATIONS_HUILE.includes(denomination))
    return { error: 'Sélectionnez la qualité / dénomination de l’huile.' };

  const formats = readFormats();
  const detail = (lignes || [])
    .map((l) => ({ ...l, unites: Number(l.unites) || 0, format: formats.find((f) => f.id === l.formatId) }))
    .filter((l) => l.format && l.unites > 0);
  if (detail.length === 0) return { error: 'Saisissez au moins un format et un nombre d’unités.' };

  const litres = Number(detail.reduce((s, l) => s + l.unites * l.format.litres, 0).toFixed(3));
  const kg = litresVersKg(litres);
  if (kg > cuve.volume)
    return { error: `Stock insuffisant dans « ${cuve.nom} » : ${cuve.volume} kg disponibles (besoin ${kg} kg).` };

  const manque = detail.find((l) => l.unites > l.format.stock);
  if (manque)
    return {
      error: `Emballages vides insuffisants : ${manque.format.stock} × ${manque.format.nom} en stock (besoin ${manque.unites}). Enregistrez un bon d’approvisionnement.`,
    };

  const prochainesCuves = (
    cuves.map((c) =>
      c.id === cuve.id
        ? {
            ...c,
            volume: Number((c.volume - kg).toFixed(3)),
            volumeRepassage: Number(Math.max(0, (c.volumeRepassage || 0) - partRepassage(cuve, kg)).toFixed(3)),
          }
        : c
    )
  );
  // 1) huile déduite de la cuve · 2) emballages vides consommés · 3) produits finis créés
  const prochainsFormats = (
    formats.map((f) => {
      const l = detail.find((x) => x.formatId === f.id);
      return l ? { ...f, stock: f.stock - l.unites } : f;
    })
  );
  const produits = readPF();
  const prochainsPF = produits.map(p=>({...p}));
  detail.forEach(l=>{
    const id=skuId(l.formatId,denomination), coutUnitaire=Number((l.format.litres*DENSITE_HUILE*(cuve.cmp||0)+l.format.prixEmballage).toFixed(3));
    const p=prochainsPF.find(x=>x.id===id);
    if(p){ const stock=p.stock+l.unites;p.cout=Number(((p.stock*p.cout+l.unites*coutUnitaire)/stock).toFixed(3));p.stock=stock; }
    else prochainsPF.push({id,formatId:l.formatId,formatNom:l.format.nom,litres:l.format.litres,denomination,nom:`${l.format.nom} — ${denomination}`,stock:l.unites,cout:coutUnitaire,prixVente:Number((coutUnitaire*1.3).toFixed(3)),prixEmballage:l.format.prixEmballage});
  });
  const rows = readCond();
  const row = {
    id: `C-${rows.reduce((m, r) => Math.max(m, Number(String(r.id).split('-')[1]) || 0), 2000) + 1}`,
    date,
    cuveId: cuve.id,
    cuveNom: cuve.nom,
    denomination,
    lignes: detail.map((l) => ({
      formatId: l.formatId,
      nom: l.format.nom,
      unites: l.unites,
      litres: l.format.litres,
      sku: skuId(l.formatId, denomination),
      skuNom: `${l.format.nom} — ${denomination}`,
    })),
    litres,
    kg,
    unites: detail.reduce((s, l) => s + l.unites, 0),
  };
  const res=await envoyerCommande('stock.conditionner',{
    resume:`Conditionnement ${row.id}`,liees:[
      cleLiee(CUVES_KEY,prochainesCuves.filter(c=>c.id===cuve.id).map(c=>opMaj(c.id,{volume:c.volume,volumeRepassage:c.volumeRepassage}))),
      cleLiee(FMT_KEY,prochainsFormats.filter(f=>detail.some(l=>l.formatId===f.id)).map(f=>opMaj(f.id,{stock:f.stock}))),
      cleLiee(PF_KEY,prochainsPF.filter(p=>detail.some(l=>skuId(l.formatId,denomination)===p.id)).map(p=>produits.some(x=>x.id===p.id)?opMaj(p.id,{stock:p.stock,cout:p.cout}):({op:'ajouter_item',item:p}))),
      cleLiee(COND_KEY,[{op:'ajouter_item',item:row}])
    ]});
  if(res.error)return {error:res.error,indetermine:res.indetermine};
  for (const [key,data] of Object.entries(res.stocks_conditionnement || {[CUVES_KEY]:prochainesCuves,[FMT_KEY]:prochainsFormats,[PF_KEY]:prochainsPF,[COND_KEY]:[row,...rows]})) patcherCache(key,()=>data);
  return { error: null, row, cuve: { ...cuve, volume: Number((cuve.volume - kg).toFixed(3)) } };
}

const VENTES_KEY = 'oliva.ventes';
const VENTES_SEED = [
  {
    id: 'V-1001', date: '2026-06-20', client: 'Hédi Mansour', format: 'vrac', cuveNom: 'B1',
    cuveId: 'v1', litres: 0, kg: 50, unites: 0, prixKg: 11.5, emballages: 0, total: 575,
    denomination: 'Huile d’Olive Extra Vierge', paiement: 'Comptant',
  },
  {
    id: 'V-1002', date: '2026-06-20', client: 'Slim Trabelsi', format: 'a3',
    cuveNom: 'P1', cuveId: 'v3', litres: 25, kg: 22.9, unites: 5, prixKg: 11.5, emballages: 25.5, total: 288.85,
    denomination: 'Huile d’Olive Vierge', paiement: 'Comptant',
  },
];

const readVentes = () => {
  const raw = localStorage.getItem(VENTES_KEY);
  if (!raw) return amorcerLocal(VENTES_KEY, VENTES_SEED) ?? [];
  return JSON.parse(raw);
};
const writeVentes = (v) => localStorage.setItem(VENTES_KEY, JSON.stringify(v));

export async function fetchVentes() {
  return readVentes();
}

// Vente comptoir : vrac multi-cuves (kg) ou détail puisé dans les produits finis.
export async function enregistrerVente({ date, client, tiersId, denomination, format, lignesCuves, unites, quantite, prixKg, prixUnitaire, compteId = PAIEMENT_DIFFERE, uniteVrac = 'kg', prixLitre, lotsTracabiliteChoisis }) {
  const prix = Number(prixKg) || PRIX_VENTE_HUILE;
  const nomClient = String(client || '').trim() || nomTiers(tiersId);
  if (!nomClient || nomClient === '—') return { error: 'Sélectionnez le client.' };
  if (!DENOMINATIONS_HUILE.includes(denomination))
    return { error: 'Sélectionnez la dénomination de l’huile.' };
  const differe = compteId === PAIEMENT_DIFFERE;
  if (differe && !tiersId)
    return { error: 'Le paiement différé exige un client enregistré dans les contacts.' };

  const ventes = readVentes();
  const id = `V-${ventes.reduce((m, v) => Math.max(m, Number(String(v.id).split('-')[1]) || 0), 1000) + 1}`;
  let row;
  // AUDIT C02 : plus RIEN n'est écrit avant la confirmation du serveur. Sortie de
  // cuve / de rayon, huile de bonus, vente et encaissement partent dans UNE SEULE
  // commande transactionnelle : tout réussit, ou rien n'existe.
  let patchsCuves = null;
  let patchPF = null;
  let patchBonus = null;

  if (format === 'vrac') {
    const cuves = readCuves();
    // Vente au détail en litres : la quantité saisie est convertie en kg pour la cuve.
    const enLitres = uniteVrac === 'L';
    const pL = Number(prixLitre) || 0;
    if (enLitres && pL <= 0) return { error: 'Saisissez le prix de vente au litre.' };
    const lignes = (lignesCuves || [])
      .map((l) => {
        const q = Number(l.kg) || 0;
        return { cuveId: l.cuveId, litres: enLitres ? q : 0, kg: enLitres ? litresVersKg(q) : q, cuve: cuves.find((c) => c.id === l.cuveId) };
      })
      .filter((l) => l.cuve && l.kg > 0);
    if (lignes.length === 0) return { error: 'Ajoutez au moins une cuve avec une quantité.' };

    const cumul = {};
    lignes.forEach((l) => { cumul[l.cuveId] = (cumul[l.cuveId] || 0) + l.kg; });
    for (const [cuveId, kg] of Object.entries(cumul)) {
      const c = cuves.find((x) => x.id === cuveId);
      if (kg > c.volume)
        return { error: `Stock insuffisant dans « ${c.nom} » : ${c.volume} kg disponibles (demandé ${kg} kg).` };
    }

    const kg = Number(lignes.reduce((s, l) => s + l.kg, 0).toFixed(3));
    const litresVrac = Number(lignes.reduce((s, l) => s + l.litres, 0).toFixed(3));
    // Vente autorisée sur le stock PHYSIQUE ; le stock financier peut devenir négatif
    // (emprunt sur l'huile des clients), valorisé au dernier CMP connu.
    const coutRevient = Number(Object.entries(cumul).reduce((s, [id, k]) => s + k * (cuves.find((c) => c.id === id)?.cmp || 0), 0).toFixed(3));
    const emprunt = Number(Object.entries(cumul).reduce((s, [id, k]) => s + Math.max(0, k - Math.max(0, stockFinancier(cuves.find((c) => c.id === id)))), 0).toFixed(3));
    const volumesAvant = Object.fromEntries(cuves.map((c) => [c.id, c.volume]));
    patchsCuves = Object.fromEntries(
      Object.entries(cumul).map(([cid, q]) => {
        const c = cuves.find((x) => x.id === cid);
        return [
          cid,
          {
            volume: Number((c.volume - q).toFixed(3)),
            volumeRepassage: Number(Math.max(0, (c.volumeRepassage || 0) - partRepassage(c, q)).toFixed(3)),
          },
        ];
      })
    );

    row = {
      id, date, client: nomClient, tiersId: tiersId || null, denomination, coutRevient, empruntStockClient: emprunt,
      paiement: differe ? 'Différé' : 'Comptant',
      compteId: differe ? null : compteId,
      format: 'vrac',
      uniteVrac: enLitres ? 'L' : 'kg',
      cuves: lignes.map((l) => ({ cuveId: l.cuveId, nom: l.cuve.nom, kg: l.kg, litres: l.litres })),
      cuveId: lignes[0].cuveId,
      cuveNom: lignes.map((l) => `${l.cuve.nom} (${enLitres ? `${l.litres} L` : `${l.kg} kg`})`).join(' + '),
      litres: litresVrac,
      kg,
      unites: 0,
      prixKg: enLitres ? Number((pL / DENSITE_HUILE).toFixed(3)) : prix,
      prixLitre: enLitres ? pL : null,
      emballages: 0,
      total: Number((enLitres ? litresVrac * pL : kg * prix).toFixed(3)),
    };
    // Part de bonus réellement vendue, valorisée au prix de vente final exact.
    patchBonus = calculerBonusSurVente({
      vente: { id, date, client: nomClient, denomination },
      cumul,
      volumesAvant,
      prixParKg: kg > 0 ? Number((row.total / kg).toFixed(3)) : 0,
    });
    row.bonusRealise = patchBonus ? { kgBonus: patchBonus.kgBonus, realise: patchBonus.realise } : null;
  } else {
    const pf = readPF();
    const sku = pf.find((x) => x.id === format);
    if (!sku) return { error: 'Sélectionnez un produit fini en rayon.' };
    const n = Number(unites ?? quantite) || 0;
    if (n <= 0) return { error: 'Saisissez le nombre d’unités à vendre.' };
    if (n > sku.stock)
      return { error: `Stock de produits finis insuffisant : ${sku.stock} × ${sku.nom} disponibles. Conditionnez d’abord depuis une cuve.` };

    const litres = Number((n * sku.litres).toFixed(3));
    const kg = litresVersKg(litres);
    // Prix de vente à l'unité (référence) : prioritaire sur le calcul au kilo.
    const pu = Number(prixUnitaire ?? sku.prixVente) || 0;
    if (pu <= 0) return { error: 'Fixez le prix de vente unitaire de cette référence (fiche produit fini).' };
    const emballages = 0;
    patchPF = { id: sku.id, stock: Number((sku.stock - n).toFixed(3)) };

    row = {
      id, date, client: nomClient, tiersId: tiersId || null, denomination: sku.denomination,
      sku: sku.id, skuNom: sku.nom,
      paiement: differe ? 'Différé' : 'Comptant',
      compteId: differe ? null : compteId,
      format,
      cuves: [], cuveId: null, cuveNom: `Rayon — ${sku.nom}`,
      litres, kg, unites: n, prixKg: prix, prixUnitaire: pu, emballages,
      total: Number((n * pu).toFixed(3)),
    };
  }

  row.piece = attribuerNumero('bon_vente', id);
  if (lotsTracabiliteChoisis?.length) row.lotsTracabiliteChoisis = lotsTracabiliteChoisis;

  const liees = [];
  if (patchsCuves)
    liees.push(cleLiee(CUVES_KEY, Object.entries(patchsCuves).map(([cid, champs]) => opMaj(cid, champs))));
  if (patchPF) liees.push(cleLiee(PF_KEY, [opMaj(patchPF.id, { stock: patchPF.stock })]));
  if (patchBonus)
    liees.push(cleLiee(BONUS_KEY, [
      { op: 'fusionner', champs: patchBonus.champs },
      { op: 'ajouter_sous_item', champ: 'mouvements', item: patchBonus.mouvement },
    ]));
  liees.push(cleLiee(VENTES_KEY, [{ op: 'ajouter_item', item: row }]));

  if (!differe && !(row.total > 0))
    return { error: 'Montant de la vente nul : choisissez le paiement différé ou corrigez le prix.' };

  const res = await envoyerCommande(differe ? 'vente.differee' : 'vente.comptoir', {
    resume: `Vente ${row.id} — ${row.client} (${Number(row.total).toFixed(3)} TND, ${differe ? 'différé' : 'comptant'})`,
    ajouts: differe
      ? []
      : [{
          bucket: 'mouvements',
          ligne: {
            date,
            type: 'Alimentation',
            compteId,
            compteCibleId: null,
            categorie: 'Vente comptoir',
            beneficiaire: row.client,
            libelle: `Vente comptoir ${row.id} — ${row.client}`,
            piece: row.piece,
            montant: row.total,
            // Lien IMMUABLE vente ↔ encaissement (audit C09) : plus aucune
            // suppression ni correction par rapprochement de pièce.
            venteId: row.id,
          },
        }],
    liees,
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };

  if (res.vente?.tracabilite) row = res.vente;
  // Confirmé par la base : le cache local adopte le même delta (jamais republié).
  if (patchsCuves) patcherItems(CUVES_KEY, patchsCuves);
  if (patchPF) patcherItems(PF_KEY, { [patchPF.id]: { stock: patchPF.stock } });
  if (patchBonus)
    patcherCache(BONUS_KEY, (b) => ({
      ...b,
      ...patchBonus.champs,
      mouvements: [patchBonus.mouvement, ...(b?.mouvements ?? [])].slice(0, 200),
    }));
  patcherCache(VENTES_KEY, (liste) => [row, ...(Array.isArray(liste) ? liste : [])]);

  return { error: null, row };
}


const SP_KEY = 'oliva.sousproduits';
const SP_SEED = {
  epandages: [
    { id: 'e1', date: '2026-06-19', chauffeur: 'Mongi Saïdi', citernes: 4, destination: 'Parcelle Nord' },
    { id: 'e2', date: '2026-06-20', chauffeur: 'Transport Khemiri', citernes: 3, destination: 'Oliviers Sud' },
  ],
  grignons: [
    { id: 'g1', date: '2026-06-18', acheteur: 'CHO Company', transporteur: 'Transport Khemiri', camions: 3, tonnage: 42, prix: 95, statut: 'Pesé' },
    { id: 'g2', date: '2026-06-20', acheteur: 'CHO Company', transporteur: 'Transport Khemiri', camions: 2, tonnage: null, prix: 95, statut: 'À peser' },
  ],
  noyaux: [
    { id: 'n1', date: '2026-06-17', acheteur: 'SOTICI Biomasse', transporteur: 'Transport Khemiri', matricule: '184 TU 4471', bl: 'BL-2026-118', poids: 24, prix: 180, facture: true },
    { id: 'n2', date: '2026-06-20', acheteur: 'SOTICI Biomasse', transporteur: 'Transport Khemiri', matricule: '92 TU 7730', bl: 'BL-2026-124', poids: 12, prix: 180, facture: false },
  ],
  repassages: [
    { id: 'p1', date: '2026-06-19', grignonsTraites: 28, huileGrignon: 1450, cuveNom: 'L1 Lampante' },
  ],
  stocks: { grignons: 182.5, noyaux: 64.2, prixGrignons: 95, prixNoyaux: 180 },
};

const readSp = () => {
  const raw = localStorage.getItem(SP_KEY);
  if (!raw) return amorcerLocal(SP_KEY, SP_SEED) ?? { epandages: [], grignons: [], noyaux: [], repassages: [], stocks: { grignons: 0, noyaux: 0, prixGrignons: 0, prixNoyaux: 0 } };
  return JSON.parse(raw);
};
const writeSp = (v) => localStorage.setItem(SP_KEY, JSON.stringify(v));
const nextId = (list, p) => `${p}${list.reduce((m, x) => Math.max(m, Number(String(x.id).slice(1)) || 0), 0) + 1}`;

export async function fetchSousProduits() {
  return readSp();
}

export async function ajouterEpandage(payload) {
  const sp = readSp();
  const row = { id: nextId(sp.epandages, 'e'), ...payload };
  writeSp({ ...sp, epandages: [row, ...sp.epandages] });
  return row;
}

export async function ajouterExpeditionGrignons(payload) {
  const sp = readSp();
  const row = { id: nextId(sp.grignons, 'g'), tonnage: null, statut: 'À peser', prix: sp.stocks.prixGrignons, ...payload };
  writeSp({ ...sp, grignons: [row, ...sp.grignons] });
  return row;
}

export async function ajusterTonnageGrignons(id, tonnage) {
  const sp = readSp();
  const t = Number(tonnage) || 0;
  if (t <= 0) return { error: 'Saisissez un tonnage valide.' };
  writeSp({
    ...sp,
    grignons: sp.grignons.map((g) => (g.id === id ? { ...g, tonnage: t, statut: 'Pesé' } : g)),
  });
  return { error: null };
}

export async function facturerGrignons(ids) {
  const sp = readSp();
  writeSp({
    ...sp,
    grignons: sp.grignons.map((g) => (ids.includes(g.id) ? { ...g, statut: 'Facturé' } : g)),
  });
  return { error: null };
}

export async function ajouterLotNoyaux(payload) {
  const sp = readSp();
  const row = { id: nextId(sp.noyaux, 'n'), prix: sp.stocks.prixNoyaux, facture: false, ...payload };
  writeSp({ ...sp, noyaux: [row, ...sp.noyaux] });
  return row;
}

export async function basculerFactureNoyaux(id) {
  const sp = readSp();
  writeSp({ ...sp, noyaux: sp.noyaux.map((n) => (n.id === id ? { ...n, facture: !n.facture } : n)) });
  return { error: null };
}

// Ligne de repassage : l'huile de grignon va OBLIGATOIREMENT en cuve lampante.
// Périodes d'origine en intervalle [DU, AU[ (début inclus, fin exclue), heures
// interprétées en Africa/Tunis. Un OF terminé exactement à 16 h appartient à la
// plage suivante.
const FUSEAU_USINE = '+01:00'; // Africa/Tunis, sans heure d'été

// « 2026-09-18T16:00 » (saisie locale usine) → horodatage non ambigu.
export const horodatageUsine = (valeur) => {
  if (!valeur) return null;
  const t = String(valeur);
  if (/[Zz]|[+-]\d{2}:\d{2}$/.test(t)) return new Date(t).toISOString();
  return new Date(`${t.length === 16 ? `${t}:00` : t}${FUSEAU_USINE}`).toISOString();
};

// Instant de fin de production d'un lot : horodatage réel si disponible, sinon
// la date de trituration seule (précision horaire indisponible).
const finProduction = (r) => {
  if (r.finTriturationLe) return { instant: r.finTriturationLe, precis: true };
  const jour = r.dateTrituration || r.date;
  return jour ? { instant: horodatageUsine(`${jour}T23:59`), precis: false } : { instant: null, precis: false };
};

const LOTS_PRODUITS = ['Trituré', 'Décompté'];

// Production réellement triturée et validée sur [du, au[ — jamais la date de réception,
// chaque lot compté une seule fois, lots annulés exclus.
export function productionPeriodeRepassage(du, auBorne) {
  const debut = horodatageUsine(du);
  const fin = horodatageUsine(auBorne);
  if (!debut || !fin) return { kg: 0, refs: [], lots: 0, precisionHoraire: true, ofs: [] };
  const retenus = read().filter((r) => {
    if (!LOTS_PRODUITS.includes(r.statut) || r.statut === 'Annulé' || r.annuleLe) return false;
    const { instant } = finProduction(r);
    return instant && instant >= debut && instant < fin;
  });
  return {
    kg: Number(retenus.reduce((s, r) => s + decompte(r).poidsNet, 0).toFixed(1)),
    refs: retenus.map((r) => r.id),
    ofs: [...new Set(retenus.map((r) => r.ofId).filter(Boolean))],
    lots: retenus.length,
    // Convention : un OF sans horaire est affecté à sa plage de fin de journée.
    precisionHoraire: retenus.every((r) => finProduction(r).precis),
  };
}

// Compatibilité : tonnage seul sur une période.
export function olivesTritureesPeriode(du, auBorne) {
  return productionPeriodeRepassage(du, auBorne).kg;
}

const repassagesValides = () => readSp().repassages.filter((p) => !p.annuleLe);

// Borne « AU » la plus récente des opérations validées et non annulées : sert au
// préremplissage du « DU » et garantit la continuité des plages.
export function bornePrecedenteRepassage() {
  const bornes = repassagesValides()
    .map((p) => p.periodeFin)
    .filter(Boolean)
    .sort();
  return bornes.length ? bornes[bornes.length - 1] : null;
}

// Compteur de campagne : production validée, corrigée des annulations. Ce n'est ni
// une deuxième entrée physique, ni le stock restant après vente.
export function compteurRepassage() {
  const valides = repassagesValides();
  const kg = Number(valides.reduce((s, p) => s + (Number(p.huileGrignon) || 0), 0).toFixed(3));
  // Rendement cumulé de la campagne : huile de repassage / olives triturées des périodes d'origine retenues.
  const olives = Number(valides.reduce((s, p) => s + (Number(p.olivesOrigine) || 0), 0).toFixed(1));
  return {
    kg,
    olives,
    rendement: olives > 0 ? Number(((kg / olives) * 100).toFixed(2)) : null,
    operations: valides.length,
    annulees: readSp().repassages.length - valides.length,
    coutMatiereUnitaire: COUT_MATIERE_REPASSAGE,
  };
}

// Opérations historiques valorisées au CMP ou amorcées à 4,200 : jamais corrigées
// en silence, présentées pour correction explicite.
export function repassagesAValoriserZero() {
  return readSp()
    .repassages.filter((p) => !p.annuleLe && (Number(p.valeurEntree) > 0 || Number(p.cmpValorisation) > 0) && !p.valorisationCorrigeeLe)
    .map((p) => ({
      id: p.id,
      date: p.date,
      cuveNom: p.cuveNom,
      huileGrignon: p.huileGrignon,
      cmpValorisation: Number(p.cmpValorisation) || 0,
      valeurEntree: Number(p.valeurEntree) || 0,
      correctionProposee: { cmpValorisation: 0, valeurEntree: 0, coutMatiereUnitaire: COUT_MATIERE_REPASSAGE },
    }));
}

// Correction explicite et tracée d'une opération historique : la valeur matière de
// l'entrée passe à 0 et les kilos sont reclassés en origine repassage dans la cuve.
export async function corrigerValorisationRepassage(id, utilisateur) {
  const sp = readSp();
  const p = sp.repassages.find((x) => x.id === id);
  if (!p) return { error: 'Opération de repassage introuvable.' };
  if (p.valorisationCorrigeeLe) return { error: 'Opération déjà corrigée.' };
  const q = Number(p.huileGrignon) || 0;
  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === p.cuveId);
  if (cuve) {
    const dejaCompte = Math.min(q, Math.max(0, stockFinancier(cuve) - (cuve.volumeRepassage || 0)));
    writeCuves(
      cuves.map((c) =>
        c.id === cuve.id ? { ...c, volumeRepassage: Number(((c.volumeRepassage || 0) + dejaCompte).toFixed(3)) } : c
      )
    );
  }
  writeSp({
    ...sp,
    repassages: sp.repassages.map((x) =>
      x.id === id
        ? {
            ...x,
            cmpValorisation: 0,
            valeurEntree: 0,
            coutMatiereUnitaire: COUT_MATIERE_REPASSAGE,
            origine: 'repassage',
            valorisationAncienne: { cmpValorisation: Number(p.cmpValorisation) || 0, valeurEntree: Number(p.valeurEntree) || 0 },
            valorisationCorrigeeLe: new Date().toISOString(),
            valorisationCorrigeePar: utilisateur ?? null,
          }
        : x
    ),
  });
  tracer({
    action: 'Correction',
    entite: 'Repassage',
    refId: id,
    resume: `Valorisation historique annulée : ${fmtTnd(p.valeurEntree)} TND → 0 TND (coût matière nul, origine repassage)`,
    utilisateur,
  });
  return { error: null };
}

const fmtTnd = (v) => Number(Number(v || 0).toFixed(3));

export async function declarerRepassage({
  date,
  huileGrignon,
  cuveId,
  periodeDebut,
  periodeFin,
  coefficientGrignon = TAUX_GRIGNON_2PHASES,
  motifCorrection = null,
  utilisateur,
}) {
  const q = Number(huileGrignon) || 0;
  const du = horodatageUsine(periodeDebut);
  const au = horodatageUsine(periodeFin);
  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === cuveId);

  if (!du || !au) return { error: 'Renseignez la période d’origine des grignons (date et heure).' };
  if (au <= du) return { error: 'La borne « au » doit être postérieure à la borne « du ».' };
  if (!cuve) return { error: 'Sélectionnez une cuve lampante de destination.' };
  if (cuve.famille !== 'lampante')
    return { error: `ROUTAGE INTERDIT : l'huile de grignon ne peut aller que dans une cuve LAMPANTE, pas dans « ${cuve.nom} ».` };
  if (q <= 0) return { error: 'Saisissez le volume d’huile de grignon produit.' };
  if (q > cuve.capacite - cuve.volume)
    return { error: `Capacité insuffisante dans « ${cuve.nom} » : reste ${cuve.capacite - cuve.volume} ${cuve.unite}.` };

  // Période déjà consommée : recouvrement interdit, y compris en cas de saisies simultanées.
  const chevauche = repassagesValides().find((p) => p.periodeDebut && p.periodeFin && du < p.periodeFin && au > p.periodeDebut);
  if (chevauche && !motifCorrection)
    return {
      error: `Période déjà consommée par l’opération ${chevauche.id} (${chevauche.periodeDebut.slice(0, 16).replace('T', ' ')} → ${chevauche.periodeFin
        .slice(0, 16)
        .replace('T', ' ')}) : corrigez la période ou justifiez explicitement la correction.`,
    };

  const production = productionPeriodeRepassage(du, au);
  const coef = Number(coefficientGrignon) > 0 ? Number(coefficientGrignon) : TAUX_GRIGNON_2PHASES;
  const grignonsEstimes = Number(((production.kg * coef) / 1000).toFixed(3));

  // Idempotence : un double clic ou une nouvelle tentative ne produit qu'une seule
  // opération et une seule entrée de stock.
  const cle = `repassage|${du}|${au}|${q}|${cuve.id}`;
  const sp = readSp();
  const deja = sp.repassages.find((p) => p.cleOperation === cle && !p.annuleLe);
  if (deja) return { error: null, cuve, row: deja, dejaEnregistre: true };

  // ENTRÉE À COÛT MATIÈRE NUL : stock physique augmenté, CMP Achat pur intact,
  // aucune dépense, dette fournisseur, sortie de caisse ni recette.
  const nouveauVolume = Number((cuve.volume + q).toFixed(3));
  writeCuves(
    cuves.map((c) =>
      c.id === cuve.id
        ? { ...c, volume: nouveauVolume, volumeRepassage: Number(((c.volumeRepassage || 0) + q).toFixed(3)) }
        : c
    )
  );

  const id = nextId(sp.repassages, 'p');
  const row = {
    id,
    cleOperation: cle,
    date,
    origine: 'repassage',
    periodeDebut: du,
    periodeFin: au,
    // Compatibilité historique (anciennes colonnes date seule).
    dateDebut: du.slice(0, 10),
    dateFin: au.slice(0, 10),
    olivesOrigine: production.kg,
    lotsRetenus: production.refs,
    ofsRetenus: production.ofs,
    precisionHoraire: production.precisionHoraire,
    coefficientGrignon: coef,
    grignonsEstimes,
    grignonsTraites: grignonsEstimes,
    huileGrignon: q,
    rendementOlives: production.kg > 0 ? Number(((q / production.kg) * 100).toFixed(2)) : null,
    cuveNom: cuve.nom,
    cuveId: cuve.id,
    coutMatiereUnitaire: COUT_MATIERE_REPASSAGE,
    cmpValorisation: 0,
    valeurEntree: 0,
    mouvementStock: `MS-${id}-${cuve.id}`,
    motifCorrection: motifCorrection || null,
    auteur: utilisateur ?? null,
    creeLe: new Date().toISOString(),
  };
  writeSp({ ...sp, repassages: [row, ...sp.repassages] });
  tracer({
    action: 'Entrée',
    entite: 'Repassage',
    refId: id,
    resume: `${q} kg d'huile de repassage versés dans ${cuve.nom} — coût matière 0 TND/kg, période ${du.slice(0, 16).replace('T', ' ')} → ${au
      .slice(0, 16)
      .replace('T', ' ')}${motifCorrection ? ` (correction : ${motifCorrection})` : ''}`,
    utilisateur,
  });
  return { error: null, cuve: { ...cuve, volume: nouveauVolume }, row, dejaEnregistre: false };
}

// Annulation d'une opération de repassage : retire les kilos et l'origine, ne crée
// ni valeur ni kilos supplémentaires, et libère la période.
export async function annulerRepassage(id, utilisateur) {
  const sp = readSp();
  const p = sp.repassages.find((x) => x.id === id);
  if (!p) return { error: 'Opération de repassage introuvable.' };
  if (p.annuleLe) return { error: 'Opération déjà annulée.' };
  const q = Number(p.huileGrignon) || 0;
  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === p.cuveId);
  if (cuve && cuve.volume < q)
    return { error: `Annulation impossible : « ${cuve.nom} » ne contient plus que ${cuve.volume} ${cuve.unite}.` };
  if (cuve)
    writeCuves(
      cuves.map((c) =>
        c.id === cuve.id
          ? {
              ...c,
              volume: Number((c.volume - q).toFixed(3)),
              volumeRepassage: Number(Math.max(0, (c.volumeRepassage || 0) - q).toFixed(3)),
            }
          : c
      )
    );
  writeSp({
    ...sp,
    repassages: sp.repassages.map((x) => (x.id === id ? { ...x, annuleLe: new Date().toISOString(), annulePar: utilisateur ?? null } : x)),
  });
  tracer({ action: 'Annulation', entite: 'Repassage', refId: id, resume: `Opération de repassage annulée : ${q} kg retirés de ${p.cuveNom}`, utilisateur });
  return { error: null };
}

export const COMPTES_SEED = [
  { id: 'esp', nom: 'Coffre-fort (Direction)', type: 'Espèces', initial: 12500, dateOuverture: '2026-01-01', decouvertAutorise: false },
  { id: 'chq', nom: 'Caisse (Pont-Bascule)', type: 'Espèces & Chèques', initial: 4800, dateOuverture: '2026-01-01', decouvertAutorise: false },
  { id: 'crs', nom: 'Caisse Coursier (fonds de roulement)', type: 'Espèces', initial: 0, dateOuverture: '2026-01-01', decouvertAutorise: false },
  { id: 'att', nom: 'Banque Attijari', type: 'Banque', banque: 'Attijari', rib: 'TN59 0401 2345 6789 0123 45', initial: 284730.5, dateOuverture: '2026-01-01', decouvertAutorise: true },
  { id: 'bia', nom: 'Banque Biatnet', type: 'Banque', banque: 'Biatnet', rib: 'TN59 0801 9876 5432 1098 76', initial: 96420.75, dateOuverture: '2026-01-01', decouvertAutorise: true },
];

// Règlements de chèques / traites émis la saison précédente : neutres pour les statistiques
// de la nouvelle campagne mais bien réels en trésorerie.
export const CAT_EXERCICE_ANTERIEUR = 'Règlement exercice antérieur';
export const CAT_FRAIS_BANCAIRES = 'Frais bancaires & agios';
export const CAT_IMPOTS_BANCAIRES = 'Impôts & taxes bancaires';

export const CATEGORIES_DEPENSE = [
  'Carburant',
  'Maintenance',
  'Salaires & main-d’œuvre',
  'Emballages',
  'Transport',
  'Électricité & eau',
  'Taxes & administratif',
  CAT_FRAIS_BANCAIRES,
  CAT_IMPOTS_BANCAIRES,
  CAT_EXERCICE_ANTERIEUR,
  'Divers',
];

export const CATEGORIES_TIERS = ['Tiers', 'Personnel', 'Autre'];
export const MODES_PAIEMENT = ['Espèces', 'Chèque', 'Virement'];

// ───────── Dépenses & frais généraux : fiscalité tunisienne (TVA + RS / TEJ) ─────────
export const TYPES_TIERS = [
  { id: 'fournisseur_olives', label: 'Fournisseur Olives', hint: 'Agriculteurs — achats d’olives' },
  { id: 'fournisseur_general', label: 'Fournisseur Général', hint: 'Factures de frais généraux' },
  { id: 'client', label: 'Client', hint: 'Prestation de trituration / achat d’huile' },
];
export const TAUX_TVA = [0, 7, 13, 19];
export const TAUX_RS = [1, 1.5, 3, 5, 10, 15, 20];
export const TIMBRE_FISCAL = 1;
export const MODES_REGLEMENT = [
  { id: 'Espèces', differe: false },
  { id: 'Virement', differe: false },
  { id: 'Chèque', differe: true },
  { id: 'Traite/Effet', differe: true },
];
export const CATEGORIES_FRAIS = [
  'Entretien',
  'Matériel',
  'Honoraires',
  'Carburant',
  'Transport',
  'Électricité & eau',
  'Loyer',
  'Assurances',
  'Taxes & administratif',
  'Divers',
];

// Type de tiers : valeur explicite si saisie, sinon déduite de l'historique métier.
export const typeTiersDe = (c) => {
  if (c?.typeTiers) return c.typeTiers;
  if (c?.type === 'personnel') return null;
  if (c?.type === 'industriel' || c?.type === 'transporteur') return 'fournisseur_general';
  return c?.estFournisseur ? 'fournisseur_olives' : 'client';
};

export async function fetchFournisseursGeneraux() {
  const receptions = read();
  return readContacts()
    .filter((c) => c.type !== 'personnel')
    .map((c) => ({
      ...c,
      estFournisseur: c.estFournisseur ?? receptions.some((r) => r.tiersId === c.id && r.parcours === 'fournisseur'),
    }))
    .filter((c) => typeTiersDe(c) === 'fournisseur_general');
}

const DEP_KEY = 'oliva.depenses';
const readDepenses = () => JSON.parse(localStorage.getItem(DEP_KEY) ?? '[]');
const writeDepenses = (v) => localStorage.setItem(DEP_KEY, JSON.stringify(v));

const enrichirDepense = (d) => {
  const regle = (d.reglements ?? []).reduce((s, r) => s + Number(r.montant), 0);
  const reste = Number((d.netAPayer - regle).toFixed(3));
  return {
    ...d,
    fournisseur: nomTiers(d.tiersId),
    regle: Number(regle.toFixed(3)),
    reste,
    statut: reste <= 0.001 ? (regle > 0 || d.avanceImputee > 0 ? 'Réglée' : 'Réglée') : regle > 0 ? 'Partiellement réglée' : 'À payer',
  };
};

// ───────── Avances fournisseurs (acomptes) ─────────
const AV_KEY = 'oliva.avances';
const readAvances = () => JSON.parse(localStorage.getItem(AV_KEY) ?? '[]');
const writeAvances = (v) => localStorage.setItem(AV_KEY, JSON.stringify(v));

export const soldeAvance = (tiersId, avances = readAvances()) =>
  Number(
    avances
      .filter((a) => a.tiersId === tiersId)
      .reduce((s, a) => s + Number(a.montant) - (a.imputations ?? []).reduce((t, i) => t + Number(i.montant), 0), 0)
      .toFixed(3)
  );

export async function fetchAvances() {
  const av = readAvances();
  return av.map((a) => ({
    ...a,
    fournisseur: nomTiers(a.tiersId),
    impute: Number((a.imputations ?? []).reduce((t, i) => t + Number(i.montant), 0).toFixed(3)),
    reste: Number((Number(a.montant) - (a.imputations ?? []).reduce((t, i) => t + Number(i.montant), 0)).toFixed(3)),
  }));
}

export async function verserAvance({ tiersId, date, montant, mode, piece, compteId, utilisateur }) {
  const m = Number(montant) || 0;
  if (!tiersId) return { error: 'Sélectionnez le fournisseur général.' };
  if (m <= 0) return { error: 'Saisissez le montant de l’avance.' };
  if (!compteId) return { error: 'Choisissez la caisse / banque de décaissement.' };
  if (!MODES_REGLEMENT.some((x) => x.id === mode)) return { error: 'Choisissez le mode de paiement.' };
  const rows = readAvances();
  const numero = `AV-2026-${String(rows.length + 1).padStart(3, '0')}`;
  const row = {
    id: `AV-${Date.now()}`,
    numero,
    tiersId,
    date,
    montant: m,
    mode,
    piece: String(piece || '').trim(),
    compteId,
    mouvementId: '@ajout:0',
    imputations: [],
    par: utilisateur ?? null,
  };
  // La référence de l'avance sert de justificatif dans le journal de trésorerie :
  // le décaissement et le registre des avances sont écrits ensemble (audit C02).
  const res = await envoyerCommande('avance.tiers', {
    resume: `Avance ${numero} — ${nomTiers(tiersId)} (${m.toFixed(3)} TND)`,
    ajouts: [{
      bucket: 'mouvements',
      ligne: {
        date,
        type: 'Dépense',
        compteId,
        categorie: 'Avances fournisseurs',
        libelle: `Avance / acompte — ${nomTiers(tiersId)}${piece ? ` (${mode} ${piece})` : ''}`,
        piece: String(piece || '').trim(),
        justificatifRef: numero,
        justificatifType: 'avance',
        montant: m,
      },
    }],
    liees: [cleLiee(AV_KEY, [{ op: 'ajouter_item', item: row }])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const enregistree = { ...row, mouvementId: res.ids?.[0] ?? null };
  patcherCache(AV_KEY, (liste) => [enregistree, ...(Array.isArray(liste) ? liste : [])]);
  tracer({ action: 'Création', entite: 'Avance', refId: numero, resume: `Avance de ${m} TND versée à ${nomTiers(tiersId)}`, utilisateur });
  return { error: null, row: enregistree };
}

// Imputation automatique des avances disponibles sur une facture.
const imputerAvances = (tiersId, montant, depenseId) => {
  let reste = Number(montant) || 0;
  const rows = readAvances();
  let total = 0;
  const maj = rows.map((a) => {
    if (a.tiersId !== tiersId || reste <= 0.001) return a;
    const dispo = Number(a.montant) - (a.imputations ?? []).reduce((t, i) => t + Number(i.montant), 0);
    if (dispo <= 0.001) return a;
    const pris = Number(Math.min(dispo, reste).toFixed(3));
    reste = Number((reste - pris).toFixed(3));
    total += pris;
    return { ...a, imputations: [...(a.imputations ?? []), { depenseId, montant: pris, le: new Date().toISOString().slice(0, 10) }] };
  });
  if (total > 0) writeAvances(maj);
  return Number(total.toFixed(3));
};

// ───────── Brouillons de factures (OCR en masse, stockage local au poste) ─────────
const BR_KEY = 'oliva.brouillons';
const readBrouillons = () => JSON.parse(localStorage.getItem(BR_KEY) ?? '[]');
const writeBrouillons = (v) => localStorage.setItem(BR_KEY, JSON.stringify(v));

export const fetchBrouillons = () => readBrouillons();
export const supprimerBrouillon = (id) => writeBrouillons(readBrouillons().filter((b) => b.id !== id));
export const ajouterBrouillon = (b) => writeBrouillons([b, ...readBrouillons()]);

// Lecture IA d'un relevé bancaire complet (PDF, Excel, CSV, photo) pour le rapprochement.
export async function analyserReleveComplet(fichier) {
  const body = new FormData();
  body.append('fichier', fichier);
  const r = await fetch(`${API_FIN}/finance/releve-complet`, { method: 'POST', body });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return { error: data.detail || 'Lecture du relevé impossible.' };
  return { error: null, lignes: data.lignes ?? [], compte: data.compte ?? {} };
}

export async function analyserFacture(fichier) {  const body = new FormData();
  body.append('fichier', fichier);
  const r = await fetch(`${API_FIN}/finance/facture`, { method: 'POST', body });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return { error: data.detail || 'Lecture de la facture impossible.' };
  return { error: null, facture: data };
}

// Rattache le fournisseur extrait à un contact existant (par nom ou MF), sinon le crée.
export async function resoudreFournisseurGeneral({ nom, mf, adresse, tel }) {
  const cible = String(nom || '').trim().toLowerCase();
  const contacts = readContacts();
  const trouve =
    (mf && contacts.find((c) => String(c.mf || '').trim() && String(c.mf).trim() === String(mf).trim())) ||
    contacts.find((c) => c.nom.trim().toLowerCase() === cible) ||
    (cible.length > 5 && contacts.find((c) => c.nom.trim().toLowerCase().includes(cible.slice(0, 12))));
  if (trouve) {
    if (typeTiersDe(trouve) !== 'fournisseur_general')
      await updateContact(trouve.id, { typeTiers: 'fournisseur_general' });
    return { tiersId: trouve.id, cree: false, nom: trouve.nom };
  }
  if (!cible) return { error: 'Fournisseur illisible sur le document.' };
  const { error, contact } = await createContact({
    type: 'tiers',
    nom: String(nom).trim(),
    mf: mf || '',
    adresse: adresse || '',
    tel: tel || '',
    typeTiers: 'fournisseur_general',
    estFournisseur: true,
    estClient: false,
  });
  if (error) return { error };
  return { tiersId: contact.id, cree: true, nom: contact.nom };
}

export async function fetchDepenses() {
  return readDepenses().map(enrichirDepense);
}

// Dette fiscale : total des retenues à la source collectées (à reverser au Trésor).
export async function fetchDetteFiscaleRS() {
  const rows = readDepenses();
  return Number(rows.reduce((s, d) => s + Number(d.montantRS || 0), 0).toFixed(3));
}

export async function creerDepense({ date, numeroFacture, tiersId, categorie, montantHT, ventilation, autresTaxes, tauxTVA, timbreFiscal, tauxRS, libelle, fodecMode, saisiPar }) {
  const taxes = Number(autresTaxes) || 0;
  const timbre = Number(timbreFiscal) || 0;
  const rs = Number(tauxRS) || 0;
  // Ventilation multi-TVA : une ligne HT par taux. Saisie simple = une seule ligne.
  const lignes = (Array.isArray(ventilation) && ventilation.length
    ? ventilation
    : [{ ht: montantHT, tauxTVA }]
  )
    .map((l) => ({ libelle: String(l.libelle || '').trim(), ht: Number(l.ht) || 0, tauxTVA: Number(l.tauxTVA) || 0 }))
    .filter((l) => l.ht > 0);
  if (!date) return { error: 'Saisissez la date de la facture.' };
  if (!String(numeroFacture || '').trim()) return { error: 'Le numéro de facture est obligatoire.' };
  if (!tiersId) return { error: 'Sélectionnez le fournisseur général.' };
  if (!categorie) return { error: 'Choisissez la catégorie analytique.' };
  if (!lignes.length) return { error: 'Saisissez au moins une ligne HT.' };
  if (lignes.some((l) => !TAUX_TVA.includes(l.tauxTVA))) return { error: 'Taux de TVA invalide (0, 7, 13 ou 19 %).' };
  if (rs && !TAUX_RS.includes(rs)) return { error: 'Taux de retenue à la source invalide.' };
  const rows = readDepenses();
  if (rows.some((d) => d.tiersId === tiersId && String(d.numeroFacture).trim() === String(numeroFacture).trim()))
    return { error: 'Cette facture est déjà enregistrée pour ce fournisseur.' };

  // Cascade légale tunisienne : HT + autres taxes (FODEC…) = base soumise à TVA,
  // + TVA + timbre fiscal = TTC ; la retenue à la source s'applique sur le TTC.
  const ht = Number(lignes.reduce((s, l) => s + l.ht, 0).toFixed(3));
  // Assiette du FODEC : réparti au prorata du HT, ou porté intégralement sur la ligne
  // au taux le plus élevé selon la présentation réelle de la facture (fodecMode).
  const tauxMax = Math.max(...lignes.map((l) => l.tauxTVA));
  const assiette = (l) =>
    fodecMode === 'tauxmax'
      ? l.ht + (l.tauxTVA === tauxMax ? taxes : 0)
      : l.ht + (ht > 0 ? (taxes * l.ht) / ht : 0);
  const ventilee = lignes.map((l) => ({ ...l, montantTVA: Number(((assiette(l) * l.tauxTVA) / 100).toFixed(3)) }));
  const baseTVA = Number((ht + taxes).toFixed(3));
  const montantTVA = Number(ventilee.reduce((s, l) => s + l.montantTVA, 0).toFixed(3));
  const montantTTC = Number((baseTVA + montantTVA + timbre).toFixed(3));
  const montantRS = Number(((montantTTC * rs) / 100).toFixed(3));
  const num = rows.reduce((m, d) => Math.max(m, Number(String(d.numero).split('-').pop()) || 0), 0) + 1;
  const id = `DEP-${Date.now()}`;
  // Imputation automatique des avances déjà versées à ce fournisseur.
  const avanceImputee = imputerAvances(tiersId, Number((montantTTC - montantRS).toFixed(3)), id);
  const row = {
    id,
    numero: `FG-2026-${String(num).padStart(4, '0')}`,
    date,
    numeroFacture: String(numeroFacture).trim(),
    tiersId,
    categorie,
    libelle: String(libelle || '').trim(),
    montantHT: ht,
    ventilation: ventilee,
    autresTaxes: taxes,
    baseTVA,
    tauxTVA: ventilee.length === 1 ? ventilee[0].tauxTVA : null,
    montantTVA,
    timbreFiscal: timbre,
    montantTTC,
    tauxRS: rs,
    montantRS,
    avanceImputee,
    netAPayer: Number((montantTTC - montantRS - avanceImputee).toFixed(3)),
    reglements: [],
    saisiPar: saisiPar ?? null,
  };
  writeDepenses([row, ...rows]);
  tracer({ action: 'Création', entite: 'Dépense', refId: row.numero, resume: `Facture ${row.numeroFacture} — ${nomTiers(tiersId)} : TTC ${montantTTC} TND, RS ${montantRS} TND`, utilisateur: saisiPar });
  return { error: null, depense: enrichirDepense(row) };
}

export async function supprimerDepense(id, utilisateur) {
  const d = readDepenses().find((x) => x.id === id);
  if (!d) return { error: 'Facture introuvable.' };
  if ((d.reglements ?? []).length) return { error: 'Facture déjà réglée : impossible de la supprimer.' };
  writeDepenses(readDepenses().filter((x) => x.id !== id));
  tracer({ action: 'Suppression', entite: 'Dépense', refId: d.numero, resume: `Facture ${d.numeroFacture} supprimée`, utilisateur });
  return { error: null };
}

// Règlement du net à payer. Espèces / Virement : décaissement immédiat.
// Chèque / Traite : la facture est réglée face au fournisseur mais la banque
// n'est débitée qu'à la confirmation manuelle du décaissement.
export async function reglerDepense(id, { date, mode, piece, echeance, montant, compteId, utilisateur }) {
  const rows = readDepenses();
  const d = rows.find((x) => x.id === id);
  if (!d) return { error: 'Facture introuvable.' };
  const m = Number(montant) || 0;
  const differe = MODES_REGLEMENT.find((x) => x.id === mode)?.differe;
  if (!MODES_REGLEMENT.some((x) => x.id === mode)) return { error: 'Choisissez le mode de règlement.' };
  if (m <= 0) return { error: 'Saisissez le montant du règlement.' };
  const reste = enrichirDepense(d).reste;
  if (m > reste + 0.001) return { error: `Montant supérieur au reste à payer (${reste.toFixed(3)} TND).` };
  if (!compteId) return { error: 'Choisissez la caisse / banque de décaissement.' };
  if (differe) {
    if (!String(piece || '').trim()) return { error: `Le numéro de pièce est obligatoire pour un règlement par ${mode}.` };
    if (!echeance) return { error: `La date d'échéance est obligatoire pour un règlement par ${mode}.` };
  }

  const ligne = {
    id: `RG-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    date,
    mode,
    piece: String(piece || '').trim(),
    echeance: differe ? echeance : null,
    montant: m,
    compteId,
    differe: Boolean(differe),
    decaisse: !differe,
    decaisseLe: differe ? null : date,
    par: utilisateur ?? null,
  };
  if (!differe) {
    const compte = readFin().comptes.find((x) => x.id === compteId);
    if (!compte) return { error: 'Choisissez la caisse / banque de décaissement.' };
  }
  // Décaissement immédiat (s'il y a lieu) ET règlement de la facture dans la même
  // transaction : la branche différée confirme aussi son obligation (audit C02).
  const res = await envoyerCommande('depense.regler', {
    resume: `Règlement facture ${d.numeroFacture} — ${m.toFixed(3)} TND (${mode})`,
    ajouts: differe
      ? []
      : [{
          bucket: 'mouvements',
          ligne: {
            date,
            type: 'Dépense',
            compteId,
            categorie: d.categorie,
            libelle: `${d.categorie} — facture ${d.numeroFacture} (${nomTiers(d.tiersId)})`,
            piece: ligne.piece || d.numeroFacture,
            montant: m,
          },
        }],
    liees: [cleLiee(DEP_KEY, [{ op: 'ajouter_sous_item', id, champ: 'reglements', item: ligne }])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  patcherCache(DEP_KEY, (liste) =>
    liste.map((x) => (x.id === id ? { ...x, reglements: [ligne, ...(x.reglements ?? [])] } : x))
  );
  return { error: null, ligne };
}

export async function marquerDecaisse(depenseId, reglementId, utilisateur) {
  const rows = readDepenses();
  const d = rows.find((x) => x.id === depenseId);
  const l = d?.reglements?.find((x) => x.id === reglementId);
  if (!d || !l) return { error: 'Règlement introuvable.' };
  if (l.decaisse) return { error: 'Ce règlement est déjà décaissé.' };
  const date = new Date().toISOString().slice(0, 10);
  const champs = { decaisse: true, decaisseLe: date, decaissePar: utilisateur ?? null };
  const res = await envoyerCommande('depense.decaisser', {
    resume: `Décaissement ${l.mode} ${l.piece} — ${Number(l.montant).toFixed(3)} TND`,
    ajouts: [{
      bucket: 'mouvements',
      ligne: {
        date,
        type: 'Dépense',
        compteId: l.compteId,
        categorie: d.categorie,
        libelle: `${l.mode} ${l.piece} — facture ${d.numeroFacture} (${nomTiers(d.tiersId)})`,
        piece: l.piece,
        montant: Number(l.montant),
      },
    }],
    liees: [cleLiee(DEP_KEY, [
      { op: 'maj_sous_item', id: depenseId, champ: 'reglements', sous_id: reglementId, champs },
    ])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  patcherCache(DEP_KEY, (liste) =>
    liste.map((x) =>
      x.id === depenseId
        ? { ...x, reglements: (x.reglements ?? []).map((y) => (y.id === reglementId ? { ...y, ...champs } : y)) }
        : x
    )
  );
  tracer({ action: 'Décaissement', entite: 'Dépense', refId: d.numero, resume: `${l.mode} ${l.piece} décaissé : ${l.montant} TND`, utilisateur });
  return { error: null };
}

// ───────── Trésorerie & financements : crédits, leasings, crédit de campagne ─────────
const FIN_LT_KEY = 'oliva.financements';
const FIN_LT_VIDE = { contrats: [], campagne: { plafond: 0, banque: '', deblocages: [] } };
const readFinLT = () => ({ ...FIN_LT_VIDE, ...JSON.parse(localStorage.getItem(FIN_LT_KEY) ?? '{}') });
const writeFinLT = (v) => localStorage.setItem(FIN_LT_KEY, JSON.stringify(v));

export async function fetchFinancements() {
  const f = readFinLT();
  const contrats = f.contrats.map((c) => {
    const echues = c.lignes.filter((l) => l.paye);
    return {
      ...c,
      totalTTC: Number(c.lignes.reduce((s, l) => s + Number(l.ttc || 0), 0).toFixed(3)),
      resteTTC: Number(c.lignes.filter((l) => !l.paye).reduce((s, l) => s + Number(l.ttc || 0), 0).toFixed(3)),
      nbEcheances: c.lignes.length,
      nbPayees: echues.length,
    };
  });
  const deblocages = f.campagne.deblocages.map((d) => ({
    ...d,
    agios: Number(((Number(d.nominal) || 0) - (Number(d.montantNet) || 0)).toFixed(3)),
  }));
  const encours = Number(deblocages.filter((d) => !d.rembourse).reduce((s, d) => s + Number(d.nominal || 0), 0).toFixed(3));
  return {
    contrats,
    campagne: {
      ...f.campagne,
      deblocages,
      encours,
      disponible: Number(((Number(f.campagne.plafond) || 0) - encours).toFixed(3)),
      agiosCumules: Number(deblocages.reduce((s, d) => s + d.agios, 0).toFixed(3)),
    },
  };
}

export async function creerContratFinancement({ libelle, organisme, type, montantFinance, taux, lignes, utilisateur }) {
  if (!String(libelle || '').trim()) return { error: 'Saisissez le libellé du contrat.' };
  if (!Array.isArray(lignes) || lignes.length === 0) return { error: 'Aucune échéance : importez le tableau d’amortissement.' };
  const propres = lignes
    .filter((l) => l.echeance && Number(l.ttc) > 0)
    .map((l, i) => ({
      id: `EA-${i + 1}`,
      echeance: String(l.echeance).slice(0, 10),
      capital: Number(l.capital) || 0,
      interets: Number(l.interets) || 0,
      tva: Number(l.tva) || 0,
      ttc: Number(l.ttc) || 0,
      paye: false,
    }))
    .sort((a, b) => a.echeance.localeCompare(b.echeance));
  if (!propres.length) return { error: 'Les lignes importées sont invalides (date ou montant TTC manquant).' };
  const f = readFinLT();
  const contrat = {
    id: `CTR-${Date.now()}`,
    numero: `FIN-2026-${String(f.contrats.length + 1).padStart(3, '0')}`,
    libelle: String(libelle).trim(),
    organisme: String(organisme || '').trim(),
    type: type || 'Crédit',
    montantFinance: Number(montantFinance) || 0,
    taux: Number(taux) || 0,
    lignes: propres,
    creeLe: new Date().toISOString().slice(0, 10),
    creePar: utilisateur ?? null,
  };
  writeFinLT({ ...f, contrats: [contrat, ...f.contrats] });
  tracer({ action: 'Création', entite: 'Financement', refId: contrat.numero, resume: `${contrat.type} « ${contrat.libelle} » — ${propres.length} échéances injectées à l'échéancier`, utilisateur });
  return { error: null, contrat };
}

export async function supprimerContratFinancement(id) {
  const f = readFinLT();
  writeFinLT({ ...f, contrats: f.contrats.filter((c) => c.id !== id) });
  return { error: null };
}

export async function marquerEcheanceFinancement(contratId, ligneId, utilisateur) {
  const f = readFinLT();
  writeFinLT({
    ...f,
    contrats: f.contrats.map((c) =>
      c.id === contratId ? { ...c, lignes: c.lignes.map((l) => (l.id === ligneId ? { ...l, paye: !l.paye, payeLe: l.paye ? null : new Date().toISOString().slice(0, 10), payePar: utilisateur ?? null } : l)) } : c
    ),
  });
  return { error: null };
}

export async function definirPlafondCampagne({ plafond, banque }) {
  const p = Number(plafond) || 0;
  if (p <= 0) return { error: 'Saisissez le plafond accordé par la banque.' };
  const f = readFinLT();
  writeFinLT({ ...f, campagne: { ...f.campagne, plafond: p, banque: String(banque || '').trim() } });
  return { error: null };
}

// Déblocage de crédit de campagne : agios = nominal − net, le nominal consomme le plafond.
export async function enregistrerDeblocage({ date, montantNet, nominal, echeance, libelle, utilisateur }) {
  const net = Number(montantNet) || 0;
  const nom = Number(nominal) || 0;
  if (net <= 0) return { error: 'Montant net du déblocage invalide.' };
  if (nom < net) return { error: 'Le montant nominal doit être supérieur ou égal au montant net encaissé.' };
  if (!echeance) return { error: 'Saisissez la date d’échéance de la traite.' };
  const f = readFinLT();
  const encours = f.campagne.deblocages.filter((d) => !d.rembourse).reduce((s, d) => s + Number(d.nominal || 0), 0);
  if (nom > (Number(f.campagne.plafond) || 0) - encours)
    return { error: `Plafond dépassé : reste disponible ${((Number(f.campagne.plafond) || 0) - encours).toFixed(3)} TND.` };
  const row = {
    id: `DEB-${Date.now()}`,
    numero: `CC-2026-${String(f.campagne.deblocages.length + 1).padStart(3, '0')}`,
    date: date || new Date().toISOString().slice(0, 10),
    libelle: String(libelle || 'Déblocage crédit de campagne').trim(),
    montantNet: net,
    nominal: nom,
    echeance: String(echeance).slice(0, 10),
    rembourse: false,
    par: utilisateur ?? null,
  };
  writeFinLT({ ...f, campagne: { ...f.campagne, deblocages: [row, ...f.campagne.deblocages] } });
  tracer({ action: 'Création', entite: 'Crédit campagne', refId: row.numero, resume: `Déblocage net ${net} TND, nominal ${nom} TND (agios ${(nom - net).toFixed(3)}), échéance ${row.echeance}`, utilisateur });
  return { error: null, row };
}

export async function rembourserDeblocage(id, utilisateur) {
  const f = readFinLT();
  const d = f.campagne.deblocages.find((x) => x.id === id);
  if (!d) return { error: 'Déblocage introuvable.' };
  writeFinLT({
    ...f,
    campagne: {
      ...f.campagne,
      deblocages: f.campagne.deblocages.map((x) => (x.id === id ? { ...x, rembourse: !x.rembourse, rembourseLe: x.rembourse ? null : new Date().toISOString().slice(0, 10) } : x)),
    },
  });
  tracer({ action: 'Remboursement', entite: 'Crédit campagne', refId: d.numero, resume: d.rembourse ? 'Remboursement annulé' : `Traite remboursée : plafond reconstitué de ${d.nominal} TND`, utilisateur });
  return { error: null };
}

// Échéancier de trésorerie GLOBAL : traites fournisseurs + tombées de financements
// + traites du crédit de campagne, trié par date d'échéance.
export async function fetchEcheancierGlobal() {
  const fournisseurs = (await fetchEcheancier()).map((l) => ({
    ...l,
    source: 'Fournisseur',
    tiers: l.fournisseur,
    reference: `${l.mode} ${l.piece}`,
  }));
  const f = readFinLT();
  const financements = f.contrats.flatMap((c) =>
    c.lignes
      .filter((l) => !l.paye)
      .map((l) => ({
        id: `${c.id}:${l.id}`,
        contratId: c.id,
        ligneId: l.id,
        source: c.type === 'Leasing' ? 'Leasing' : 'Crédit',
        tiers: c.organisme || c.libelle,
        reference: `${c.numero} — ${c.libelle}`,
        echeance: l.echeance,
        montant: Number(l.ttc) || 0,
      }))
  );
  const campagne = f.campagne.deblocages
    .filter((d) => !d.rembourse)
    .map((d) => ({
      id: d.id,
      source: 'Crédit campagne',
      tiers: f.campagne.banque || 'Banque',
      reference: `${d.numero} — traite de mobilisation`,
      echeance: d.echeance,
      montant: Number(d.nominal) || 0,
    }));
  const jour = new Date().toISOString().slice(0, 10);
  return [...fournisseurs, ...financements, ...campagne]
    .map((l) => ({ ...l, echu: String(l.echeance) <= jour, semaine: semaineIso(l.echeance) }))
    .sort((a, b) => String(a.echeance).localeCompare(String(b.echeance)));
}

// Semaine ISO (AAAA-Sxx) pour regrouper les sorties de trésorerie.
export const semaineIso = (iso) => {
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return '—';
  const jour = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - jour);
  const debut = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return `${d.getUTCFullYear()}-S${String(Math.ceil(((d - debut) / 86400000 + 1) / 7)).padStart(2, '0')}`;
};

const API_FIN = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function analyserAmortissement(fichier) {
  const body = new FormData();
  body.append('fichier', fichier);
  const r = await fetch(`${API_FIN}/finance/amortissement`, { method: 'POST', body });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return { error: data.detail || 'Lecture du PDF impossible.' };
  return { error: null, ...data };
}

export async function analyserReleveBancaire(fichier, seuil = 20000) {
  const body = new FormData();
  body.append('fichier', fichier);
  body.append('seuil', String(seuil));
  const r = await fetch(`${API_FIN}/finance/releve`, { method: 'POST', body });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return { error: data.detail || 'Lecture de l’extrait impossible.' };
  return { error: null, deblocages: data.deblocages ?? [] };
}

// Import multi-banques : plusieurs extraits d'un coup, avec rapprochement automatique
// des déblocages déjà enregistrés (même montant à 1 TND près et date à ±5 jours).
export async function analyserRelevesMultiBanques(fichiers, seuil = 20000) {
  const deja = readFinLT().campagne.deblocages;
  const proche = (a, b) => Math.abs(new Date(a) - new Date(b)) <= 5 * 86400000;
  const resultats = [];
  for (const fichier of fichiers) {
    const banque = String(fichier.name).replace(/\.[^.]+$/, '').slice(0, 40);
    const { error, deblocages } = await analyserReleveBancaire(fichier, seuil);
    resultats.push({
      banque,
      fichier: fichier.name,
      error: error ?? null,
      deblocages: (deblocages ?? []).map((d) => ({
        ...d,
        banque,
        rapproche: deja.some((x) => Math.abs(Number(x.montantNet) - Number(d.montantNet)) <= 1 && proche(x.date, d.date)),
      })),
    });
  }
  return resultats;
}

export async function suggererTraites({ nombre, montant, depart, beneficiaire }) {
  const charges = (await fetchEcheancierGlobal()).map((l) => ({ echeance: l.echeance, montant: l.montant }));
  const r = await fetch(`${API_FIN}/finance/suggestion-traites`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ nombre, montant, depart, beneficiaire, charges }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) return { error: data.detail || 'Suggestion indisponible.' };
  return { error: null, ...data };
}

// Échéancier de trésorerie : règlements différés non encore décaissés, par échéance.
export async function fetchEcheancier() {
  const comptes = readFin().comptes;
  return readDepenses()
    .flatMap((d) =>
      (d.reglements ?? [])
        .filter((r) => r.differe && !r.decaisse)
        .map((r) => ({
          ...r,
          depenseId: d.id,
          numero: d.numero,
          numeroFacture: d.numeroFacture,
          fournisseur: nomTiers(d.tiersId),
          compte: comptes.find((c) => c.id === r.compteId)?.nom ?? r.compteId,
          echu: r.echeance <= new Date().toISOString().slice(0, 10),
        }))
    )
    .sort((a, b) => String(a.echeance).localeCompare(String(b.echeance)));
}

// Déclaration TEJ : récapitulatif mensuel des retenues à la source.
export async function fetchDeclarationTEJ() {
  const rows = readDepenses().filter((d) => Number(d.montantRS) > 0);
  const mois = {};
  rows.forEach((d) => {
    const k = String(d.date).slice(0, 7);
    mois[k] = mois[k] ?? { mois: k, nb: 0, baseTTC: 0, montantRS: 0, lignes: [] };
    mois[k].nb += 1;
    mois[k].baseTTC = Number((mois[k].baseTTC + d.montantTTC).toFixed(3));
    mois[k].montantRS = Number((mois[k].montantRS + d.montantRS).toFixed(3));
    mois[k].lignes.push({
      ...d,
      fournisseur: nomTiers(d.tiersId),
      mf: readContacts().find((c) => c.id === d.tiersId)?.mf ?? '',
      cin: readContacts().find((c) => c.id === d.tiersId)?.cin ?? '',
      datePaiement: (d.reglements ?? []).slice(-1)[0]?.date ?? d.date,
    });
  });
  return Object.values(mois).sort((a, b) => b.mois.localeCompare(a.mois));
}


const FIN_KEY = 'oliva.finances';
// AUDIT C11 — AUCUN amorçage de données financières. Le registre de trésorerie est
// créé côté serveur (plan de comptes SEUL, sans mouvement ni règlement) par
// `backend/finance_commandes.initialiser_finances`. Un cache absent n'invente donc
// plus rien : une base vide reste vide, y compris après une remise à zéro.
const FIN_VIDE = { comptes: [], mouvements: [], reglements: [] };

const readFin = () => {
  const raw = localStorage.getItem(FIN_KEY);
  if (!raw) return FIN_VIDE;
  const fin = { ...FIN_VIDE, ...JSON.parse(raw) };
  // Migration : renommage Coffre-fort / Caisse Pont-Bascule + ajout Caisse Coursier.
  const comptes = fin.comptes.map((c) => {
    const ref = COMPTES_SEED.find((x) => x.id === c.id);
    // Rétro-compatibilité : report d'ouverture par défaut pour les comptes déjà en base.
    const base = {
      dateOuverture: c.dateOuverture ?? ref?.dateOuverture ?? '',
      decouvertAutorise: c.decouvertAutorise ?? ref?.decouvertAutorise ?? false,
    };
    return ref && ref.type !== 'Banque' ? { ...c, ...base, nom: ref.nom, type: ref.type } : { ...c, ...base };
  });
  COMPTES_SEED.filter((s) => !comptes.some((c) => c.id === s.id)).forEach((s) =>
    comptes.splice(2, 0, s)
  );
  return { ...fin, comptes };
};

// ─────────────────────────────────────────────────────────────────────────────
// ÉCRITURES DE TRÉSORERIE — commandes serveur transactionnelles (audit Lot A).
//
// Le registre financier n'est PLUS JAMAIS publié depuis le cache d'un poste
// (`PUT /api/store/oliva.finances` renvoie 403). Chaque opération envoie un DELTA
// avec un identifiant d'opération stable ; le serveur l'applique dans une
// transaction sur SON registre courant, avec les écritures liées (bon soldé,
// vente, stock, avance, dépense, opération coursier) — tout réussit ou rien.
//
// Après confirmation seulement, le cache local est aligné : le registre financier
// est imposé par la réponse du serveur, les clés liées reçoivent le même patch
// SANS republication (un instantané périmé ne doit jamais repartir vers la base).
// ─────────────────────────────────────────────────────────────────────────────

const CHAMPS_MOUVEMENT = ['date', 'type', 'compteId', 'compteCibleId', 'categorie', 'libelle',
  'piece', 'montant', 'beneficiaire', 'notes', 'justificatif', 'justificatifRef',
  'justificatifType', 'tiersId', 'mode', 'venteId', 'conversionId'];
const CHAMPS_REGLEMENT = ['date', 'categorie', 'tiersId', 'notes', 'beneficiaire', 'piece',
  'mode', 'compteId', 'montant', 'acompte', 'statut', 'justificatif', 'conversionId'];
// Correction d'une vente : le TOTAL est recalculé par le serveur, jamais envoyé.
const CHAMPS_VENTE = ['date', 'client', 'tiersId', 'denomination', 'kg', 'litres', 'unites',
  'prixKg', 'prixUnitaire', 'emballages', 'notes'];

// Seuls les champs connus du serveur partent : il refuse tout champ inconnu.
const ligneFiltree = (payload, champs) =>
  Object.fromEntries(champs.filter((c) => payload[c] !== undefined).map((c) => [c, payload[c]]));

// Patch du cache local APRÈS confirmation serveur (jamais publié).
const patcherCache = (cle, transformer) => {
  const brut = localStorage.getItem(cle);
  if (brut === null) return null;
  const apres = transformer(JSON.parse(brut));
  ecrireLocalSeulement(cle, JSON.stringify(apres));
  window.dispatchEvent(new Event('store-maj'));
  return apres;
};

const patcherItems = (cle, patchs) =>
  patcherCache(cle, (rows) =>
    (Array.isArray(rows) ? rows : []).map((r) => (patchs[r.id] ? { ...r, ...patchs[r.id] } : r))
  );

// Opération liée : modification ciblée d'un élément, vérifiée champ par champ par le serveur.
const opMaj = (id, champs) => ({ op: 'maj_item', id, champs });
const cleLiee = (cle, operations) => ({
  cle, operations, attendu: JSON.parse(localStorage.getItem(cle) || 'null'),
});

// AUDIT C09 — bons dont le serveur a retiré le soldement parce que leur règlement
// a été supprimé : le cache local adopte exactement ce que la base a écrit.
const restaurerBons = (ids) =>
  patcherItems(
    KEY,
    Object.fromEntries(
      (ids ?? []).map((id) => [
        id,
        { regle: false, regleDate: null, regleMode: null, regleRef: null, reglePar: null },
      ])
    )
  );

export function soldeCompte(compte, mouvements, reglements) {
  // Le report d'ouverture fait table rase : seules les opérations à partir de la date
  // d'ouverture alimentent le solde de la nouvelle saison.
  const depuis = compte.dateOuverture || '';
  const apres = (d) => !depuis || String(d ?? '') >= depuis;
  const entrees = mouvements
    .filter((m) => apres(m.date) && ((m.type === 'Alimentation' && m.compteId === compte.id) || (m.type === 'Transfert' && m.compteCibleId === compte.id)))
    .reduce((s, m) => s + m.montant, 0);
  const sorties = mouvements
    .filter((m) => apres(m.date) && ((m.type === 'Dépense' && m.compteId === compte.id) || (m.type === 'Transfert' && m.compteId === compte.id)))
    .reduce((s, m) => s + m.montant, 0);
  const paye = reglements
    .filter((r) => apres(r.date) && r.compteId === compte.id && r.statut === 'Payé')
    .reduce((s, r) => s + r.montant, 0);
  return Number(((Number(compte.initial) || 0) + entrees - sorties - paye).toFixed(3));
}

// Administration : report d'ouverture de trésorerie (montants négatifs = découvert).
export async function majSoldesOuverture(lignes) {
  const fin = readFin();
  const comptes = fin.comptes.map((c) => {
    const l = lignes.find((x) => x.id === c.id);
    if (!l) return c;
    return {
      ...c,
      initial: Number(l.initial) || 0,
      dateOuverture: l.dateOuverture || c.dateOuverture || '',
      noteOuverture: String(l.noteOuverture ?? '').trim(),
      decouvertAutorise: Boolean(l.decouvertAutorise),
    };
  });
  if (comptes.some((c) => !c.dateOuverture)) return { error: 'Chaque compte doit avoir une date de solde d’ouverture.' };
  const res = await envoyerCommande('soldes_ouverture.maj', {
    resume: `Soldes d’ouverture de ${lignes.length} compte(s)`,
    comptes: lignes.map((l) => ({
      id: l.id,
      champs: {
        initial: Number(l.initial) || 0,
        dateOuverture: l.dateOuverture || fin.comptes.find((c) => c.id === l.id)?.dateOuverture || '',
        noteOuverture: String(l.noteOuverture ?? '').trim(),
        decouvertAutorise: Boolean(l.decouvertAutorise),
      },
    })),
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  return { error: null, comptes: res.data?.comptes ?? comptes };
}

export async function fetchFinances() {
  const fin = readFin();
  return {
    ...fin,
    soldes: fin.comptes.map((c) => ({ ...c, solde: soldeCompte(c, fin.mouvements, fin.reglements) })),
  };
}

export async function ajouterMouvement(payload) {
  const fin = readFin();
  const montant = Number(payload.montant) || 0;
  if (montant <= 0) return { error: 'Saisissez un montant valide.' };
  if (!payload.libelle?.trim()) return { error: 'Saisissez un libellé.' };
  if (payload.type === 'Dépense' && !payload.categorie) return { error: 'Choisissez une catégorie de dépense.' };
  if (payload.type === 'Transfert') {
    if (!payload.compteCibleId) return { error: 'Choisissez la caisse de destination.' };
    if (payload.compteCibleId === payload.compteId) return { error: 'Les deux caisses doivent être différentes.' };
  }
  const compte = fin.comptes.find((c) => c.id === payload.compteId);
  let alerte = null;
  if (payload.type !== 'Alimentation') {
    const dispo = soldeCompte(compte, fin.mouvements, fin.reglements);
    if (montant > dispo) {
      if (!compte.decouvertAutorise) return { error: `Solde insuffisant sur « ${compte.nom} » : ${dispo.toFixed(2)} TND.` };
      alerte = `Découvert sur « ${compte.nom} » : solde après opération ${(dispo - montant).toFixed(3)} TND.`;
    }
  }
  const operation_id = nouvelIdOperation('mouvement');
  const ligne = {
    compteCibleId: null,
    categorie: null,
    ...ligneFiltree(payload, CHAMPS_MOUVEMENT),
    piece: (payload.piece || '').trim().replace(/^—$/, '') || attribuerNumero('piece_caisse', operation_id),
    libelle: payload.libelle.trim(),
    montant,
  };
  // Le serveur attribue l'identifiant sur SON registre : plus de collision entre postes.
  const res = await envoyerCommande('mouvement.creer', {
    operation_id,
    resume: `${payload.type} ${montant.toFixed(3)} TND — ${ligne.libelle}`,
    ajouts: [{ bucket: 'mouvements', ligne }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  return { error: null, row: { ...ligne, id: res.ids[0] }, alerte: res.alerte ?? alerte ?? null };
}

export async function ajouterReglement(payload) {
  const fin = readFin();
  const montant = Number(payload.montant) || 0;
  if (!payload.beneficiaire?.trim()) return { error: 'Saisissez le bénéficiaire.' };
  if (montant <= 0) return { error: 'Saisissez un montant valide.' };
  const compte = fin.comptes.find((c) => c.id === payload.compteId);
  if (!compte) return { error: 'Choisissez le compte de paiement.' };
  if ((payload.statut ?? 'Payé') === 'Payé') {
    const dispo = soldeCompte(compte, fin.mouvements, fin.reglements);
    if (montant > dispo && !compte.decouvertAutorise)
      return { error: `Solde insuffisant sur « ${compte.nom} » : ${dispo.toFixed(2)} TND.` };
  }
  const operation_id = nouvelIdOperation('reglement');
  const ligne = {
    acompte: false,
    statut: 'Payé',
    ...ligneFiltree(payload, CHAMPS_REGLEMENT),
    beneficiaire: payload.beneficiaire.trim(),
    piece: (payload.piece || '').trim().replace(/^—$/, '') || attribuerNumero('recu_paiement', operation_id),
    montant,
  };
  const res = await envoyerCommande('reglement.creer', {
    operation_id,
    resume: `Règlement ${montant.toFixed(3)} TND — ${ligne.beneficiaire}`,
    ajouts: [{ bucket: 'reglements', ligne }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  return { error: null, row: { ...ligne, id: res.ids[0] } };
}

export async function validerReglement(id) {
  const fin = readFin();
  const r = fin.reglements.find((x) => x.id === id);
  if (!r) return { error: 'Règlement introuvable.' };
  const compte = fin.comptes.find((c) => c.id === r.compteId);
  if (!compte) return { error: 'Compte de paiement introuvable sur ce règlement.' };
  const dispo = soldeCompte(compte, fin.mouvements, fin.reglements);
  if (r.montant > dispo && !compte.decouvertAutorise)
    return { error: `Solde insuffisant sur « ${compte.nom} » : ${dispo.toFixed(2)} TND.` };
  const res = await envoyerCommande('reglement.valider', {
    resume: `Validation du règlement ${id} (${Number(r.montant).toFixed(3)} TND)`,
    maj: [{ bucket: 'reglements', id, champs: { statut: 'Payé' } }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  return { error: null };
}

const KEY = 'oliva.receptions.v3';

const SEED = [
  {
    id: 'R-2601', date: '2026-06-19', parcours: 'fournisseur', tiersId: 'c1', qualite: 'extra_vierge',
    poidsBrut: 12400, tare: 400, mode: 'foss', foss: 18.5, prixFixe: null, rendementReel: null,
    prixBaseHuile: 10, tarifTrituration: null,
    devenir: null, cuveId: null, ventes: [], statut: 'Trituré',
  },
  {
    id: 'R-2602', date: '2026-06-19', parcours: 'fournisseur', tiersId: 'c2', qualite: 'lampante',
    poidsBrut: 8600, tare: 300, mode: 'fixe', foss: null, prixFixe: 1.05, rendementReel: null,
    prixBaseHuile: null, tarifTrituration: null,
    devenir: null, cuveId: null, ventes: [], statut: 'En trituration',
  },
  {
    id: 'R-2603', date: '2026-06-20', parcours: 'client', tiersId: 'c4', qualite: null,
    poidsBrut: 21500, tare: 500, mode: 'prestation', foss: null, prixFixe: null, rendementReel: 17.2,
    prixBaseHuile: null, tarifTrituration: 0.18,
    devenir: 'cuve', cuveId: 'v4', ventes: [], statut: 'Décompté',
  },
  {
    id: 'R-2604', date: '2026-06-20', parcours: 'client', tiersId: 'c5', qualite: null,
    poidsBrut: 6200, tare: 200, mode: 'prestation', foss: null, prixFixe: null, rendementReel: 16.4,
    prixBaseHuile: null, tarifTrituration: 0.2,
    devenir: 'sortie', cuveId: null, ventes: [{ articleId: 'a3', qte: 6 }, { articleId: 'a6', qte: 2 }], statut: 'Trituré',
  },
  {
    id: 'R-2605', date: '2026-06-20', parcours: 'fournisseur', tiersId: 'c3', qualite: 'vierge',
    poidsBrut: 15900, tare: 450, mode: 'reel', foss: null, prixFixe: null, rendementReel: null,
    prixBaseHuile: 10.5, tarifTrituration: null,
    devenir: null, cuveId: null, ventes: [], statut: 'En attente',
  },
];

const readTous = () => {
  const raw = localStorage.getItem(KEY);
  if (!raw) return amorcerLocal(KEY, SEED) ?? [];
  return JSON.parse(raw);
};
// Piste d'audit : les bons « Annulé » (soft delete) restent en base mais sortent de toute la logique métier.
const read = () => readTous().filter((r) => r.statut !== 'Annulé');
// Accès en lecture réutilisés par le module de risque huile (lib/risqueHuile.js).
export const readReceptionsActives = read;
export const readCuvesPubliques = () => readCuves();
export const CUVE_SORTIE_DIRECTE_ID = CUVE_SORTIE_DIRECTE.id;
const write = (rows) => {
  const annules = readTous().filter((r) => r.statut === 'Annulé' && !rows.some((x) => x.id === r.id));
  localStorage.setItem(KEY, JSON.stringify([...rows, ...annules]));
};
export async function fetchReceptionsAnnulees() {
  return readTous().filter((r) => r.statut === 'Annulé');
}

export const familleDe = (qualiteId) => QUALITES.find((q) => q.id === qualiteId)?.famille ?? 'noble';
export const labelQualite = (qualiteId) => QUALITES.find((q) => q.id === qualiteId)?.label ?? '—';
export const labelMode = (mode) =>
  mode === 'prestation' ? 'Prestation de service' : MODES_ACHAT.find((m) => m.id === mode)?.label ?? '—';
export const nomTiers = (id) => readContacts().find((c) => c.id === id)?.nom ?? '—';

export const tiersAvecCode = (id) => {
  const c = readContacts().find((contact) => contact.id === id);
  if (!c) return '—';
  return c.code ? `${c.nom} (${c.code})` : c.nom;
};
export const nomArticle = (id) => readFormats().find((a) => a.id === id)?.nom ?? '—';

// Taxe agricole retenue à la source sur les achats d'olives (Fonds des Calamités).
export const TAUX_CALAMITES = 1;

// Moteur de calcul : décompte agriculteur / facturation client.
export function decompte(r) {
  const formats = arguments.length > 1 ? arguments[1] : readFormats();
  const poidsNet = Math.max(0, (Number(r.poidsBrut) || 0) - (Number(r.tare) || 0));
  const rendement = r.mode === 'foss' ? Number(r.foss) || 0 : Number(r.rendementReel) || 0;
  const huile = (poidsNet * rendement) / 100;
  const emballages = (r.ventes || []).reduce((s, v) => {
    const a = formats.find((x) => x.id === v.articleId);
    return s + (a ? a.prixEmballage * Number(v.qte || 0) : 0);
  }, 0);

  if (r.parcours === 'client') {
    const tarif = Number(r.tarifTrituration) || 0;
    const triturationBase = poidsNet * tarif;
    // Minimum de facturation de la prestation : le complément est CONSERVÉ AVEC
    // L'OPÉRATION (instantané `minTrit`). Un bon sans instantané — toute opération
    // antérieure à cette règle — garde son comportement historique, et un changement
    // de paramètres ne réécrit jamais une pièce déjà établie.
    const min = r.minTrit && r.minTrit.actif === true && !r.minTrit.derogation ? r.minTrit : null;
    const minimumComplement = min ? Number(min.complement) || 0 : 0;
    const trituration = Number((triturationBase + minimumComplement).toFixed(3));
    const brut = trituration + emballages;
    return {
      poidsNet, rendement, huile, emballages,
      poidsUtile: poidsNet, tauxDechet: 0,
      trituration,
      triturationBase: Number(triturationBase.toFixed(3)),
      minimumComplement,
      minimum: r.minTrit ?? null,
      prixKg: tarif, tarifTrituration: tarif, prixBaseHuile: 0,
      montantBrut: brut, calamites: false, tauxCalamites: 0, retenueCalamites: 0,
      montant: brut,
      sens: 'Facturé au client',
      enAttenteRendement: false,
    };
  }

  const prixBase = Number(r.prixBaseHuile) || 0;
  // Achat « À négocier » : valorisation PROVISOIRE au cours figé à la réception,
  // jamais à zéro (sinon le CMP des cuves chuterait).
  const coursProvisoire = r.mode === 'negocier' ? Number(r.coursFige?.prixApplique) || 0 : 0;
  const prixKg =
    r.mode === 'fixe'
      ? Number(r.prixFixe) || 0
      : r.mode === 'negocier'
        ? (rendement / 100) * coursProvisoire
        : (rendement / 100) * prixBase;
  // Achat sur fosse : taux de déchet (feuilles, terre…) déduit du poids net avant valorisation.
  const tauxDechet = r.mode === 'foss' ? Math.min(100, Math.max(0, Number(r.tauxDechet) || 0)) : 0;
  const poidsUtile = Number((poidsNet * (1 - tauxDechet / 100)).toFixed(1));
  const brut = poidsUtile * prixKg;
  // Le fonds est toujours dû. La case choisit seulement qui en supporte le coût.
  // Ne jamais ajouter la provision aux décaissements ni à la base CMP.
  const calamites = r.calamites === true;
  const fonds = brut * (TAUX_CALAMITES / 100);
  const retenueCalamites = calamites ? fonds : 0;
  // Résiduel identique au serveur : brut arrondi - net arrondi, au millime.
  const provisionCalamites = (Math.round(Number(brut.toFixed(3)) * 1000)
    - Math.round(Number((brut - fonds).toFixed(3)) * 1000)) / 1000;
  const chargeCalamites = calamites ? 0 : provisionCalamites;
  return {
    poidsNet, rendement, huile, emballages, trituration: 0,
    poidsUtile, tauxDechet,
    prixKg, prixBaseHuile: prixBase, tarifTrituration: 0,
    montantBrut: brut,
    provisoire: r.mode === 'negocier' && !r.prixFixeLe,
    coursProvisoire,
    calamites,
    tauxCalamites: TAUX_CALAMITES,
    provisionCalamites, chargeCalamites,
    retenueCalamites,
    montant: brut - retenueCalamites,
    sens: 'À payer au fournisseur',
    enAttenteRendement: r.mode === 'reel' && !r.rendementReel,
  };
}

// ───────── Achats « À négocier » : fixation du prix définitif ─────────

// Lots achetés à prix non encore fixé (accès Administrateur et Responsable Pont-Bascule).
// Chiffres de la campagne en cours, pour comparaison avec les KPI historiques
// extraits des documents du coffre (Deep Scan).
export async function statsCampagneCourante(ref = new Date()) {
  const { debut, fin: fin_, libelle } = bornesCampagne(ref);
  const dans = (d) => String(d ?? '') >= debut && String(d ?? '') <= fin_;
  const rows = read().filter((r) => dans(r.date) && r.statut !== 'Annulé');
  const achats = rows.filter((r) => r.parcours === 'fournisseur');
  const olives = rows.reduce((s, r) => s + decompte(r).poidsNet, 0);
  const huile = rows.reduce((s, r) => s + ((r.cuves ?? []).reduce((a, l) => a + (Number(l.kg) || 0), 0) || decompte(r).huile), 0);
  const ca = readVentes().filter((v) => dans(v.date)).reduce((s, v) => s + (Number(v.total) || 0), 0);
  const charges = readDepenses()
    .filter((d) => dans(d.date) && d.categorie !== CAT_EXERCICE_ANTERIEUR)
    .reduce((s, d) => s + (Number(d.montantTTC) || Number(d.montantHT) || 0), 0);
  const achatsTnd = achats.reduce((s, r) => s + decompte(r).montant, 0);
  return {
    campagne: libelle,
    debut,
    fin: fin_,
    chiffreAffaires: Number(ca.toFixed(3)),
    volumeOlivesKg: Number(olives.toFixed(1)),
    volumeHuileKg: Number(huile.toFixed(3)),
    rendementMoyen: olives > 0 ? Number(((huile / olives) * 100).toFixed(2)) : 0,
    achatsOlivesTnd: Number(achatsTnd.toFixed(3)),
    chargesTotal: Number(charges.toFixed(3)),
    resultatNet: Number((ca - charges - achatsTnd).toFixed(3)),
  };
}

// Campagne oléicole : 1er septembre → 31 août.
export function bornesCampagne(ref = new Date()) {
  const d = ref instanceof Date ? ref : new Date(ref);
  const an = d.getMonth() >= 8 ? d.getFullYear() : d.getFullYear() - 1;
  return { debut: `${an}-09-01`, fin: `${an + 1}-08-31`, libelle: `${an}/${an + 1}` };
}

// Aide à la décision pour la négociation : cumuls de la campagne en cours par
// fournisseur (tonnage, huile, rendement moyen, prix moyen consenti), séparés
// entre lots au prix définitivement fixé et lots encore provisoires.
export async function statsFournisseurCampagne(tiersId, ref = new Date()) {
  const { debut, fin, libelle } = bornesCampagne(ref);
  const lots = read().filter(
    (r) =>
      r.tiersId === tiersId &&
      r.parcours === 'fournisseur' &&
      r.statut !== 'Annulé' &&
      String(r.date) >= debut &&
      String(r.date) <= fin
  );

  const agrege = (rows) => {
    let olives = 0;
    let huile = 0;
    let montant = 0;
    let nonTritures = 0;
    rows.forEach((r) => {
      const c = decompte(r);
      const kg = (r.cuves ?? []).reduce((a, l) => a + (Number(l.kg) || 0), 0) || c.huile;
      if (kg <= 0) nonTritures += 1;
      olives += c.poidsNet;
      huile += kg;
      montant += c.montant;
    });
    // Règle métier : une moyenne de rendement n'a de sens que si TOUS les lots de la
    // catégorie sont triturés — sinon elle est faussée à la baisse par les lots à 0 %.
    const fiable = rows.length > 0 && nonTritures === 0 && olives > 0;
    return {
      lots: rows.length,
      nonTritures,
      olivesKg: Number(olives.toFixed(1)),
      huileKg: Number(huile.toFixed(3)),
      montantTnd: Number(montant.toFixed(3)),
      rendementFiable: fiable,
      rendementMoyen: fiable ? Number(((huile / olives) * 100).toFixed(2)) : null,
      prixMoyenOlives: olives > 0 ? Number((montant / olives).toFixed(3)) : 0,
      prixMoyenHuile: huile > 0 ? Number((montant / huile).toFixed(3)) : 0,
    };
  };

  const estProvisoire = (r) => r.mode === 'negocier' && !r.prixFixeLe;
  const compte = await fetchCompteTiers(tiersId);

  return {
    campagne: libelle,
    debut,
    fin,
    global: agrege(lots),
    fixes: agrege(lots.filter((r) => !estProvisoire(r))),
    provisoires: agrege(lots.filter(estProvisoire)),
    parFamille: {
      noble: agrege(lots.filter((r) => familleDe(r.qualite) !== 'lampante')),
      lampante: agrege(lots.filter((r) => familleDe(r.qualite) === 'lampante')),
    },
    // Rendement moyen par qualité : jamais mélangé entre catégories.
    parQualite: QUALITES.map((q) => ({
      id: q.id,
      label: q.label,
      ...agrege(lots.filter((r) => r.qualite === q.id)),
    })).filter((q) => q.lots > 0),
    solde: compte.solde,
    totalPaye: compte.totalPaye,
    avanceDisponible: avanceDisponible(tiersId),
  };
}

export async function fetchLotsANegocier() {
  const cours = getCoursDuJour();
  const lignes = read()
    .filter((r) => r.parcours === 'fournisseur' && r.mode === 'negocier' && !r.prixFixeLe && r.statut !== 'Annulé')
    .map((r) => {
      const d = decompte(r);
      const huile = (r.cuves ?? []).reduce((s, l) => s + (Number(l.kg) || 0), 0);
      const coursJour = familleDe(r.qualite) === 'lampante' ? cours.lampante : cours.noble;
      const fige = Number(r.coursFige?.prixApplique) || 0;
      return {
        ...r,
        fournisseur: nomTiers(r.tiersId),
        poidsNet: d.poidsNet,
        huileProduite: Number(huile.toFixed(3)),
        rendement: d.poidsNet > 0 && huile > 0 ? Number(((huile / d.poidsNet) * 100).toFixed(2)) : d.rendement,
        coursFigeValeur: fige,
        coursJour,
        ecartCours: Number((coursJour - fige).toFixed(3)),
        provisionTnd: Number(d.montant.toFixed(3)),
        acomptes: Number(r.acompteVerse || 0),
        trituree: huile > 0,
      };
    })
    .sort((a, b) => (a.date < b.date ? 1 : -1));

  const ids = [...new Set(lignes.map((l) => l.tiersId).filter(Boolean))];
  const stats = Object.fromEntries(
    await Promise.all(ids.map(async (id) => [id, await statsFournisseurCampagne(id)]))
  );
  return lignes.map((l) => ({ ...l, stats: stats[l.tiersId] ?? null }));
}

// Fixation définitive : met à jour la dette fournisseur et réajuste le CMP des cuves
// concernées de l'écart provision → coût réel (prorata de ce qui reste en cuve).
export async function fixerPrixLot({ id, methode = 'base', prixBaseHuile, prixFixe, utilisateur, note }) {
  const rows = read();
  const r = rows.find((x) => x.id === id);
  if (!r) return { error: 'Lot introuvable.' };
  if (r.mode !== 'negocier') return { error: 'Ce lot n’est pas un achat « À négocier ».' };
  if (r.prixFixeLe) return { error: `Prix déjà fixé le ${String(r.prixFixeLe).slice(0, 10)}.` };

  const base = Number(prixBaseHuile) || 0;
  const fixe = Number(prixFixe) || 0;
  if (methode === 'base' && !(base > 0)) return { error: 'Saisissez le prix de base de l’huile (TND/kg).' };
  if (methode === 'fixe' && !(fixe > 0)) return { error: 'Saisissez le prix négocié (TND/kg d’olives).' };

  const provision = decompte(r).montant;
  const poidsNet = decompte(r).poidsNet;
  // Huile réellement produite : sert au rendement définitif (méthode « prix de base »).
  const huileTotale = (r.cuves ?? []).reduce((s, l) => s + (Number(l.kg) || 0), 0);
  const rendementDefinitif =
    poidsNet > 0 && huileTotale > 0 ? Number(((huileTotale / poidsNet) * 100).toFixed(3)) : Number(r.foss) || 0;
  if (methode === 'base' && !(rendementDefinitif > 0))
    return { error: 'Rendement inconnu : triturez le lot (ou saisissez le rendement fosse) avant de fixer un prix de base.' };
  const definitif = {
    ...r,
    mode: methode === 'fixe' ? 'fixe' : 'foss',
    foss: methode === 'base' ? rendementDefinitif : r.foss,
    prixBaseHuile: methode === 'base' ? base : null,
    prixFixe: methode === 'fixe' ? fixe : null,
  };
  const montantFinal = Number(decompte(definitif).montant.toFixed(3));
  const ecartTotal = Number((montantFinal - provision).toFixed(3));

  // Réajustement du CMP : l'écart est réparti sur les cuves au prorata de l'huile versée,
  // puis appliqué sur le stock financier restant (la part déjà vendue devient un écart de marge).
  const cuves = readCuves();
  let ecartSurVentes = 0;
  const ajustements = [];
  if (huileTotale > 0 && Math.abs(ecartTotal) > 0.001) {
    writeCuves(
      cuves.map((c) => {
        const ligne = (r.cuves ?? []).find((l) => l.cuveId === c.id);
        if (!ligne || c.virtuelle) return c;
        const kgVerse = Number(ligne.kg) || 0;
        const partEcart = Number((ecartTotal * (kgVerse / huileTotale)).toFixed(3));
        const restant = Math.min(kgVerse, Math.max(0, stockFinancier(c)));
        const vendu = Number((kgVerse - restant).toFixed(3));
        const ecartRestant = restant > 0 ? Number((partEcart * (restant / kgVerse)).toFixed(3)) : 0;
        ecartSurVentes = Number((ecartSurVentes + (partEcart - ecartRestant)).toFixed(3));
        const cmpAvant = Number(c.cmp) || 0;
        const valeur = Math.max(0, stockFinancier(c)) * cmpAvant + ecartRestant;
        const cmpApresAjust = Math.max(0, stockFinancier(c)) > 0 ? Number((valeur / Math.max(0, stockFinancier(c))).toFixed(3)) : cmpAvant;
        ajustements.push({
          cuveId: c.id,
          cuveNom: c.nom,
          kgVerse,
          kgRestant: restant,
          kgVendu: vendu,
          ecart: partEcart,
          ecartCmp: ecartRestant,
          cmpAvant,
          cmpApres: cmpApresAjust,
        });
        return {
          ...c,
          cmp: cmpApresAjust,
          volumeProvisoire: Number(Math.max(0, (c.volumeProvisoire || 0) - kgVerse).toFixed(3)),
        };
      })
    );
  }

  write(
    rows.map((x) =>
      x.id === id
        ? {
            ...x,
            mode: methode === 'fixe' ? 'fixe' : 'foss',
            modeOrigine: 'negocier',
            prixBaseHuile: methode === 'base' ? base : null,
            prixFixe: methode === 'fixe' ? fixe : null,
            foss: methode === 'base' ? rendementDefinitif : x.foss,
            prixFixeLe: new Date().toISOString(),
            prixFixePar: utilisateur ?? null,
            prixFixeNote: String(note ?? '').trim() || null,
            provisionInitiale: Number(provision.toFixed(3)),
            montantDefinitif: montantFinal,
            ecartFixation: ecartTotal,
            ajustementsCmp: ajustements,
          }
        : x
    )
  );

  tracer({
    action: 'Fixation prix achat',
    entite: 'Réception',
    refId: id,
    utilisateur,
    resume: `Réajustement CMP — fixation du prix du lot ${id} : provision ${provision.toFixed(3)} → définitif ${montantFinal.toFixed(3)} TND (écart ${ecartTotal.toFixed(3)})${
      ecartSurVentes ? `, dont ${ecartSurVentes.toFixed(3)} TND en écart de marge sur ventes déjà réalisées` : ''
    }`,
  });

  return { error: null, montantFinal, provision, ecart: ecartTotal, ecartSurVentes, ajustements };
}

export async function fetchContacts() {
  return readContacts();
}

// Historique des parcours réellement utilisés par un tiers : sert au
// pré-remplissage automatique du double rôle Client / Fournisseur.
export function historiqueParcours(tiersId) {
  const lots = read()
    .filter((r) => r.tiersId === tiersId)
    .sort((a, b) => (a.date < b.date ? -1 : 1));
  const parcours = (p) => lots.filter((r) => r.parcours === p);
  const bornes = (list) =>
    list.length ? { premiere: list[0].date, derniere: list[list.length - 1].date, n: list.length } : null;
  const client = bornes(parcours('client'));
  const fournisseur = bornes(parcours('fournisseur'));
  return {
    client,
    fournisseur,
    roles: [client ? 'client' : null, fournisseur ? 'fournisseur' : null].filter(Boolean),
    mixte: Boolean(client && fournisseur),
    refs: lots.map((r) => r.id),
  };
}

// Rapprochement d'une saisie (nom / tél / CIN) avec la base des tiers +
// l'historique de leurs parcours.
export function detecterTiers(saisie) {
  const res = rapprocher(saisie, readContacts().filter((c) => c.type !== 'personnel'));
  if (!res.contact) return { ...res, historique: null };
  return { ...res, historique: historiqueParcours(res.contact.id) };
}
// Base unifiée : les tiers servent indifféremment de client (prestation) et de
// fournisseur (achat d'olives).
export async function fetchTiers() {
  return readContacts().filter((c) => c.type === 'tiers');
}

// Création de contact avec détection de doublon (CIN, MF, téléphone, nom).
// En cas de correspondance : pas de doublon — le rôle manquant est ajouté au
// contact existant, qui devient un profil mixte (client ET fournisseur).
export async function createContact({ type = 'tiers', nom, tel, adresse, mf, cin, cnss, contrat, salaireJour, salaireMois, region, role, estClient, estFournisseur, typeTiers, regionDefault, varieteDefault, gpsDefault, traceStatut }) {
  const nomPropre = String(nom || '').trim();
  if (!nomPropre) return { error: 'Saisissez le nom / la raison sociale.' };
  if (type === 'personnel') {
    if (!String(cin || '').trim()) return { error: 'Le N° CIN est obligatoire pour un salarié.' };
    if (!String(cnss || '').trim()) return { error: 'Le N° CNSS est obligatoire pour un salarié.' };
    if (!TYPES_CONTRAT.includes(String(contrat || '')))
      return { error: 'Sélectionnez le type de contrat.' };
  }
  const veutClient = Boolean(estClient) || role === 'client';
  const veutFournisseur = Boolean(estFournisseur) || role === 'fournisseur';

  const rows = readContacts();
  const cle = (v) => String(v || '').replace(/[\s.-]/g, '').toLowerCase();
  const identite = rows.find(
    (c) =>
      (cle(cin) && cle(c.cin) === cle(cin)) ||
      (cle(mf) && cle(c.mf) === cle(mf)) ||
      (cle(tel) && cle(c.tel) === cle(tel))
  );
  // Homonymie (accents/ponctuation ignorés) : fusion uniquement si aucun téléphone contradictoire.
  const homonyme = rows.find(
    (c) => normNom(c.nom) === normNom(nomPropre) && (!cle(tel) || !cle(c.tel) || cle(c.tel) === cle(tel))
  );
  const existant = identite ?? homonyme;

  if (existant) {
    const receptions = read().filter((r) => r.tiersId === existant.id);
    const dejaClient = existant.estClient ?? receptions.some((r) => r.parcours === 'client');
    const dejaFournisseur = existant.estFournisseur ?? receptions.some((r) => r.parcours === 'fournisseur');
    const patch = {
      tel: existant.tel || String(tel || '').trim(),
      adresse: existant.adresse || String(adresse || '').trim(),
      mf: existant.mf || String(mf || '').trim(),
      cin: existant.cin || String(cin || '').trim(),
      cnss: existant.cnss || String(cnss || '').trim(),
      contrat: existant.contrat || String(contrat || '').trim(),
      region: existant.region && existant.region !== '—' ? existant.region : String(region || '').trim() || '—',
      estClient: dejaClient || veutClient,
      estFournisseur: dejaFournisseur || veutFournisseur,
      typeTiers: existant.typeTiers || typeTiers || undefined,
      regionDefault: existant.regionDefault || regionDefault, varieteDefault: existant.varieteDefault || varieteDefault, gpsDefault: existant.gpsDefault || gpsDefault,
    };
    const { contact } = await updateContact(existant.id, patch);
    const mixte = contact.estClient && contact.estFournisseur;
    return {
      error: null,
      contact,
      fusionne: true,
      message: mixte
        ? `« ${contact.nom} » (${contact.code}) existe déjà : rôle ajouté, la fiche devient un profil mixte (client ET fournisseur).`
        : `« ${contact.nom} » (${contact.code}) existe déjà : fiche mise à jour, aucun doublon créé.`,
    };
  }

  const contact = {
    id: `ct-${Date.now()}`,
    code: prochainCode(rows),
    nom: nomPropre,
    type: TYPES_UNIFIES.includes(type) ? 'tiers' : type,
    region: String(regionDefault || region || '').trim() || '—',
    regionDefault: regionDefault || region, varieteDefault, gpsDefault, traceStatut,
    tel: String(tel || '').trim(),
    adresse: String(adresse || '').trim(),
    mf: type === 'personnel' ? '' : String(mf || '').trim(),
    cin: String(cin || '').trim(),
    cnss: String(cnss || '').trim(),
    contrat: String(contrat || '').trim(),
    salaireJour: Number(salaireJour) || 0,
    salaireMois: Number(salaireMois) || 0,
    estClient: type === 'tiers' ? veutClient : undefined,
    estFournisseur: type === 'tiers' ? veutFournisseur : undefined,
    typeTiers: type === 'personnel' ? null : typeTiers || (veutFournisseur ? 'fournisseur_olives' : 'client'),
  };
  writeContacts([...rows, contact]);
  return { error: null, contact, fusionne: false };
}
export async function fetchCuves() {
  return readCuves().filter((c) => !c.virtuelle);
}

export async function createCuve(payload) {
  const rows = readCuves();
  const row = { id: `k${Date.now()}`, volume: 0, cmp: 0, proprietaire: 'huilerie', ...payload };
  writeCuves([...rows, row]);
  return row;
}

export async function updateCuve(id, patch, { override = false, utilisateur } = {}) {
  const avant = readCuves().find((c) => c.id === id);
  if (avant && patch.famille && patch.famille !== avant.famille && avant.volume > 0) {
    if (!override) return { error: `BLOCAGE SÉCURITÉ : « ${avant.nom} » contient encore ${avant.volume} ${avant.unite} de ${avant.famille === 'lampante' ? 'LAMPANTE' : 'NOBLE'} — changement de filière interdit.` };
    journalOverride(utilisateur, `changement de filière de la cuve ${avant.nom} avec stock`);
  }
  const next = readCuves().map((c) => (c.id === id ? { ...c, ...patch } : c));
  writeCuves(next);
  return next.find((c) => c.id === id);
}

export async function deleteCuve(id) {
  writeCuves(readCuves().filter((c) => c.id !== id));
}

// Transfert entre cuves — processus en deux étapes : Ordre de transfert (théorique,
// sans mouvement de stock) puis Validation au tonnage réel (mouvement + CMP).
const TRF_KEY = 'oliva.transferts';
const readTransferts = () => JSON.parse(localStorage.getItem(TRF_KEY) ?? '[]');
const writeTransferts = (v) => localStorage.setItem(TRF_KEY, JSON.stringify(v));

export async function fetchTransferts() {
  const cuves = readCuves();
  const nom = (id) => cuves.find((c) => c.id === id)?.nom ?? id;
  return readTransferts().map((t) => ({ ...t, sourceNom: nom(t.sourceId), cibleNom: nom(t.cibleId) }));
}

const controleFiliere = (src, dst, override, utilisateur, resume) => {
  if (src.famille === dst.famille) return null;
  if (!override)
    return (
      'BLOCAGE SÉCURITÉ — Affectation croisée interdite : une cuve de la filière ' +
      (src.famille === 'lampante' ? 'lampante' : 'nobles') +
      ' ne peut jamais alimenter une cuve ' +
      (dst.famille === 'lampante' ? 'lampante' : 'nobles') +
      '.'
    );
  journalOverride(utilisateur, resume);
  return null;
};

export async function creerOrdreTransfert({ sourceId, cibleId, quantite, utilisateur, override = false }) {
  const cuves = readCuves();
  const src = cuves.find((c) => c.id === sourceId);
  const dst = cuves.find((c) => c.id === cibleId);
  const q = Number(quantite) || 0;
  if (!src || !dst) return { error: 'Cuve introuvable.' };
  if (src.id === dst.id) return { error: 'Sélectionnez deux cuves différentes.' };
  if (q <= 0) return { error: 'Saisissez la quantité théorique à transférer.' };
  if (q > src.volume) return { error: 'Quantité supérieure au stock physique de la cuve source.' };
  if (q > dst.capacite - dst.volume) return { error: 'Capacité restante insuffisante dans la cuve de destination.' };
  const bloc = controleFiliere(src, dst, override, utilisateur, `ordre de transfert croisé ${src.nom} → ${dst.nom} (${q} kg)`);
  if (bloc) return { error: bloc };

  const rows = readTransferts();
  const num = rows.reduce((m, t) => Math.max(m, Number(String(t.numero).split('-').pop()) || 0), 0) + 1;
  const row = {
    id: `TRF-${Date.now()}`,
    numero: `OT-2026-${String(num).padStart(4, '0')}`,
    date: new Date().toISOString().slice(0, 10),
    sourceId,
    cibleId,
    qteTheorique: q,
    qteReelle: null,
    cmpSource: Number(src.cmp) || 0,
    valeur: null,
    statut: 'Planifié',
    creePar: utilisateur ?? null,
    validePar: null,
    valideLe: null,
    override: src.famille !== dst.famille,
  };
  writeTransferts([row, ...rows]);
  tracer({ action: 'Création', entite: 'Transfert', refId: row.numero, resume: `Ordre ${row.numero} : ${src.nom} → ${dst.nom} (${q} kg théoriques)`, utilisateur });
  // Validation automatique globale : l'ordre est clôturé à la quantité planifiée.
  if (getAutoValidation()) {
    const auto = await validerTransfert(row.id, q, { utilisateur: utilisateur ?? AUTO_VALIDATION_AUTEUR });
    if (auto.error) return { error: null, ordre: { ...row, sourceNom: src.nom, cibleNom: dst.nom }, autoValidation: auto.error };
    return {
      error: null,
      ordre: { ...row, statut: 'Terminé', qteReelle: q, sourceNom: src.nom, cibleNom: dst.nom },
      autoValidation: true,
    };
  }
  return { error: null, ordre: { ...row, sourceNom: src.nom, cibleNom: dst.nom } };
}

export async function annulerOrdreTransfert(id, utilisateur) {
  const t = readTransferts().find((x) => x.id === id);
  if (!t) return { error: 'Ordre introuvable.' };
  if (t.statut !== 'Planifié') return { error: 'Seul un ordre planifié peut être annulé.' };
  writeTransferts(readTransferts().map((x) => (x.id === id ? { ...x, statut: 'Annulé', validePar: utilisateur ?? null } : x)));
  return { error: null };
}

// Validation au réel : seule cette quantité mouvemente les stocks et clôture l'ordre.
export async function validerTransfert(id, qteReelle, { utilisateur, override = false } = {}) {
  const t = readTransferts().find((x) => x.id === id);
  if (!t) return { error: 'Ordre introuvable.' };
  if (t.statut !== 'Planifié') return { error: 'Cet ordre est déjà clôturé.' };
  const q = Number(qteReelle) || 0;
  if (q <= 0) return { error: 'Saisissez le tonnage réel transféré.' };
  const src = readCuves().find((c) => c.id === t.sourceId);
  const cmpSource = Number(src?.cmp) || 0;
  const { error } = await transfertHuile(t.sourceId, t.cibleId, q, { override: override || t.override, utilisateur });
  if (error) return { error };
  writeTransferts(
    readTransferts().map((x) =>
      x.id === id
        ? {
            ...x,
            qteReelle: q,
            cmpSource,
            valeur: Number((q * cmpSource).toFixed(3)),
            statut: 'Terminé',
            validePar: utilisateur ?? null,
            valideLe: new Date().toISOString().slice(0, 10),
          }
        : x
    )
  );
  tracer({ action: 'Validation', entite: 'Transfert', refId: t.numero, resume: `Transfert ${t.numero} validé au réel : ${q} kg (valorisés au CMP source ${cmpSource} TND/kg)`, utilisateur });
  return { error: null, qteReelle: q, valeur: Number((q * cmpSource).toFixed(3)) };
}

export async function transfertHuile(sourceId, cibleId, quantite, { override = false, utilisateur } = {}) {
  const rows = readCuves();
  const src = rows.find((c) => c.id === sourceId);
  const dst = rows.find((c) => c.id === cibleId);
  const q = Number(quantite) || 0;

  if (!src || !dst) return { error: 'Cuve introuvable.' };
  if (src.id === dst.id) return { error: 'Sélectionnez deux cuves différentes.' };
  const bloc = controleFiliere(src, dst, override, utilisateur, `transfert croisé ${src.nom} → ${dst.nom} (${q} kg)`);
  if (bloc) return { error: bloc };
  if (q <= 0) return { error: 'Saisissez une quantité valide.' };
  if (q > src.volume) return { error: 'Quantité supérieure au stock de la cuve source.' };
  if (q > dst.capacite - dst.volume) return { error: 'Capacité restante insuffisante dans la cuve cible.' };

  // L'huile des clients voyage au prorata ; seule la part huilerie entre dans le CMP de la cible.
  const partClients = Number((src.volume > 0 ? q * ((src.volumeClients || 0) / src.volume) : 0).toFixed(3));
  const partHuilerie = Number((q - partClients).toFixed(3));
  const next = rows.map((c) => {
    if (c.id === src.id)
      return {
        ...c,
        volume: Number((c.volume - q).toFixed(3)),
        volumeClients: Number(Math.max(0, (c.volumeClients || 0) - partClients).toFixed(3)),
        volumeRepassage: Number(Math.max(0, (c.volumeRepassage || 0) - partRepassage(src, q)).toFixed(3)),
      };
    if (c.id === dst.id)
      return {
        ...c,
        volume: Number((c.volume + q).toFixed(3)),
        volumeClients: Number(((c.volumeClients || 0) + partClients).toFixed(3)),
        // L'origine repassage suit l'huile transférée, toujours à coût matière nul.
        volumeRepassage: Number(((c.volumeRepassage || 0) + partRepassage(src, q)).toFixed(3)),
        cmp: cmpApres(c, Number(Math.max(0, partHuilerie - partRepassage(src, q)).toFixed(3)), src.cmp || 0),
      };
    return c;
  });
  writeCuves(next);
  return { error: null };
}
export async function fetchCaisse() {
  return readFin().mouvements;
}
export async function fetchReglements() {
  return readFin().reglements;
}
// ───────── Minimum de facturation de la prestation de trituration ─────────
// L'instantané est recalculé tant qu'il n'est pas FIGÉ par une validation : avant
// que le passage soit constitué il s'agit d'une estimation (un seul bon), ensuite il
// porte le passage réel. Un bon annulé ne porte jamais de complément.
const bonsDuPassage = (row, rows) => {
  const autres = row.passageId ? (rows ?? []).filter((x) => x.passageId === row.passageId && x.id !== row.id) : [];
  return [row, ...autres]
    .map((x) => ({ id: x.id, poidsNet: decompte(x).poidsNet, tarifTrituration: x.tarifTrituration }))
    // Ordre stable : le dernier bon absorbe l'ajustement d'arrondi, côté poste comme serveur.
    .sort((a, b) => String(a.id).localeCompare(String(b.id)));
};

const recalculerMinimum = (row, rows) => {
  if (!row || row.parcours !== 'client') return row;
  if (row.minTrit?.fige === true) return row;
  if (row.statut === 'Annulé') return { ...row, minTrit: null };
  const liste = bonsDuPassage(row, rows);
  return {
    ...row,
    minTrit: instantaneMinimum({
      bon: liste.find((b) => b.id === row.id),
      bonsPassage: liste,
      params: parametresMinimum(getTarifs()),
      exempt: readContacts().find((c) => c.id === row.tiersId)?.exempteMinimumTrituration === true,
      passageId: row.passageId ?? null,
      derogation: row.minTrit?.derogation ?? null,
      estimation: !row.passageId,
      fige: false,
    }),
  };
};

// Montant qui S'APPLIQUERAIT au bon (sans dérogation) : sert à l'affichage et à la
// décision sur le décompte, jamais à réécrire une pièce figée.
export function minimumPourBon(id) {
  const rows = read();
  const row = rows.find((r) => r.id === id);
  if (!row || row.parcours !== 'client') return null;
  const liste = bonsDuPassage(row, rows);
  return instantaneMinimum({
    bon: liste.find((b) => b.id === row.id),
    bonsPassage: liste,
    params: parametresMinimum(getTarifs()),
    exempt: readContacts().find((c) => c.id === row.tiersId)?.exempteMinimumTrituration === true,
    passageId: row.passageId ?? null,
    derogation: null,
    estimation: !row.passageId,
    fige: false,
  });
}

// Décision cohérente sur TOUT le passage, figée dans chaque bon concerné.
export async function enregistrerMinimumPassage(id, { applique, note = '', par } = {}) {
  const avant = localStorage.getItem(KEY);
  const rows = read();
  const row = rows.find((r) => r.id === id);
  if (!row) return { error: 'Réception introuvable.' };
  if (row.parcours !== 'client') return { error: null, bons: [] };
  const liste = bonsDuPassage(row, rows);
  const passage = liste.map((b) => rows.find((r) => r.id === b.id));
  if (liste.length > 1 && !passageHomogene(passage).homogene)
    return {
      error:
        'Harmonisation requise : les bons de ce passage ne portent pas le même tarif ou la même décision. Faites-les harmoniser par un utilisateur autorisé avant de valider.',
    };
  const params = parametresMinimum(getTarifs());
  const exempt = readContacts().find((c) => c.id === row.tiersId)?.exempteMinimumTrituration === true;
  const le = new Date().toISOString();
  const ids = liste.map((b) => b.id);
  write(
    rows.map((r) => {
      if (!ids.includes(r.id) || r.minTrit?.fige === true) return r;
      const theorique = instantaneMinimum({
        bon: liste.find((b) => b.id === r.id),
        bonsPassage: liste,
        params,
        exempt,
        passageId: r.passageId ?? null,
        derogation: null,
        estimation: false,
        fige: true,
      });
      if (applique) return { ...r, minTrit: theorique };
      return {
        ...r,
        minTrit: {
          ...theorique,
          actif: false,
          complement: 0,
          derogation: {
            par: par || '—',
            le,
            montantAbandonne: theorique.complement,
            note: String(note || '').trim() || null,
          },
        },
      };
    })
  );
  await publierMaintenant(KEY, avant);
  return { error: null, bons: ids };
}

// Suivi interne des exceptions (écran d'administration) : jamais sur les documents clients.
export function derogationsMinimum() {
  return read()
    .filter((r) => r.parcours === 'client' && r.minTrit?.derogation)
    .map((r) => ({
      id: r.id,
      date: r.date,
      tiersId: r.tiersId,
      tiers: nomTiers(r.tiersId),
      poidsNet: decompte(r).poidsNet,
      seuil: r.minTrit.seuil,
      tarif: r.minTrit.tarif,
      passageId: r.minTrit.passageId,
      montantAbandonne: Number(r.minTrit.derogation.montantAbandonne) || 0,
      par: r.minTrit.derogation.par,
      le: r.minTrit.derogation.le,
      note: r.minTrit.derogation.note,
    }))
    .sort((a, b) => String(b.le).localeCompare(String(a.le)));
}

export async function fetchReceptions() {
  return read();
}

export async function createReception(payload) {
  // Tiers strictement obligatoire : aucun lot ne peut exister sans client ni fournisseur rattaché.
  payload = { ...payload, ...garantirTracabiliteReception(payload, readContacts().find(c=>c.id===payload?.tiersId), read()) };
  if (!payload?.tiersId) throw new Error('Tiers obligatoire : rattachez un client ou un fournisseur au lot avant enregistrement.');
  const rows = read();
  const maxNum = rows.reduce((m, r) => Math.max(m, Number(String(r.id).split('-')[1]) || 0), 2600);
  // Instantané à la création seulement ; les changements de fiche ne retarifient aucun ancien bon.
  let donnees = payload;
  if (payload.parcours === 'client') {
    const contact = readContacts().find((c) => c.id === payload.tiersId);
    const manuel = payload.tarifTriturationSource === 'manuel';
    const tarif = manuel ? Number(payload.tarifTrituration) : tarifTriturationPour(payload.qualite, contact);
    if (!Number.isFinite(tarif) || !(tarif > 0)) throw new Error('Tarif de trituration invalide.');
    const special = contact?.tarifTriturationPersonnalise;
    donnees = { ...payload, tarifTrituration: tarif,
      tarifTriturationSource: manuel ? 'manuel' : (typeof special === 'number' && special > 0 && contact?.estClient !== false ? 'client' : 'qualite') };
  }
  const row = recalculerMinimum({ id: `R-${maxNum + 1}`, statut: 'En attente', ventes: [], ...donnees }, rows);
  const avant = localStorage.getItem(KEY);
  write([row, ...rows]);
  const resultat = imputerAvance(row);
  await publierMaintenant(KEY, avant);
  return resultat;
}

// Pont-bascule en flux continu : camions pesés en brut, en attente de la tare (sortie).
export async function fetchCamionsSurSite() {
  return read().filter((r) => r.statut === 'Sur site');
}

export async function cloturerTare(id, tare) {
  const r = read().find((x) => x.id === id);
  if (!r) return { error: 'Ticket introuvable.' };
  const t = Number(tare);
  if (!(t >= 0)) return { error: 'Saisissez la tare (poids du camion vide).' };
  if (t >= Number(r.poidsBrut)) return { error: 'La tare doit être inférieure au poids brut.' };
  const row = await updateReception(id, { tare: t, statut: 'En attente', heureSortie: new Date().toISOString() });
  return { error: null, row };
}

// Ventilation d'un bon fournisseur en plusieurs lignes de qualité (nobles / lampante…).
// Le poids camion (brut/tare) reste sur chaque ligne à titre d'information ;
// chaque ligne devient un bon autonome (R-xxxx, R-xxxx/2…) pour la trituration cloisonnée.
export async function ventilerReception(id, lignes, communs = {}) {
  const rows = read();
  const r = rows.find((x) => x.id === id);
  if (!r) return { error: 'Bon introuvable.' };
  if (r.parcours !== 'fournisseur') return { error: 'La ventilation par qualité ne concerne que les achats d’olives.' };
  if (r.statut === 'Sur site') return { error: 'Saisissez d’abord la tare de sortie.' };
  if (r.regle === true) return { error: 'Bon déjà soldé : ventilation impossible.' };
  const propres = (lignes || [])
    .map((l) => ({ ...l, qualite: l.qualite, kg: Number(l.kg) || 0 }))
    .filter((l) => l.kg > 0 && QUALITES.some((q) => q.id === l.qualite));
  if (propres.length < 2) return { error: 'Saisissez au moins deux lignes de qualité avec un poids.' };
  const netCamion = decompte(r).poidsNet;
  const total = propres.reduce((s, l) => s + l.kg, 0);
  if (Math.abs(total - netCamion) > 0.5)
    return { error: `La ventilation (${total.toFixed(0)} kg) doit totaliser le poids net du camion (${netCamion.toFixed(0)} kg).` };
  const base = r.bonParent ? rows.find((x) => x.id === r.bonParent) ?? r : r;
  const racine = base.id.split('/')[0];
  const autres = rows.filter((x) => (x.bonParent === racine || x.id === racine) && x.id !== r.id && x.ventile);
  const nouveaux = propres.map((l, i) => ({
    ...r,
    ...communs,
    // Paramètres propres à la ligne (type d'achat, prix, FOSS, déchet) : jamais globaux au camion.
    ...(l.mode ? { mode: l.mode, prixFixe: l.prixFixe ?? null, prixBaseHuile: l.prixBaseHuile ?? null, foss: l.foss ?? null, tauxDechet: l.tauxDechet ?? 0, coursFige: l.coursFige ?? null } : {}),
    id: i === 0 ? r.id : `${racine}/${autres.length + i + 1}`,
    qualite: l.qualite,
    poidsBrut: l.kg,
    tare: 0,
    brutCamion: r.brutCamion ?? r.poidsBrut,
    tareCamion: r.tareCamion ?? r.tare,
    bonParent: racine,
    ventile: true,
    partPct: Number(((l.kg / netCamion) * 100).toFixed(1)),
    regle: false, avanceImputee: 0,
  }));
  const idx = rows.findIndex((x) => x.id === r.id);
  const next = [...rows.slice(0, idx), ...nouveaux, ...rows.slice(idx + 1)];
  const avant = localStorage.getItem(KEY);
  write(next);
  nouveaux.forEach((n) => imputerAvance(n));
  await publierMaintenant(KEY, avant);
  return { error: null, lignes: nouveaux.map((n) => n.id) };
}

// Lignes sœurs d'un bon ventilé (pour le total camion dans la liste).
export const lignesDuBon = (r) => {
  if (!r.ventile) return [r];
  const racine = r.bonParent || r.id.split('/')[0];
  return read().filter((x) => x.ventile && (x.bonParent || x.id.split('/')[0]) === racine);
};

// Solde en un clic de toutes les lignes impayées d'un même camion.
export async function solderCamion(id, { mode = 'Espèces', utilisateur, compteId } = {}) {
  const r = read().find((x) => x.id === id);
  if (!r) return { error: 'Bon introuvable.' };
  const cibles = lignesDuBon(r).filter((l) => etatPaiement(l).code === 'impaye');
  if (!cibles.length) return { error: 'Aucune ligne impayée sur ce camion.' };
  let total = 0;
  const soldees = [];
  for (const l of cibles) {
    const res = await solderReception(l.id, { mode, utilisateur, compteId });
    if (res.error) return { error: `${l.id} : ${res.error}`, soldees, total };
    total += res.montant;
    soldees.push(l.id);
  }
  return { error: null, soldees, total: Number(total.toFixed(3)), mode };
}

// Indicateur de paiement d'une réception : impayé réel, dépôt en cuve, soldé…
export const bonIncomplet = (r) =>
  r.parcours === 'fournisseur' &&
  (!r.qualite || !r.mode || (r.mode === 'fixe' ? !(Number(r.prixFixe) > 0) : !(Number(r.prixBaseHuile) > 0)) || (r.mode === 'foss' && !(Number(r.foss) > 0)));

// Pesée éclair : contact + poids brut, le reste est complété à l'étape suivante.
export async function creerPeseeEclair({ tiersId, parcours, immatriculation, poidsBrut, tare, date, qualite, regionOrigine, variete, gps, traceStatut }) {
  if (!tiersId) return { error: 'Sélectionnez le contact.' };
  if (!qualite || !QUALITES.some((q) => q.id === qualite))
    return { error: 'Sélectionnez la qualité des olives (Extra-Vierge, Vierge ou Lampante) : sans elle, le bon n’est pas routé vers le planning atelier.' };
  const brut = Number(poidsBrut);
  if (!(brut > 0)) return { error: 'Saisissez le poids brut.' };
  const tareSaisie = tare !== '' && tare !== null && tare !== undefined;
  if (tareSaisie && Number(tare) >= brut) return { error: 'La tare doit être inférieure au poids brut.' };
  const client = parcours === 'client';
  const t = getTarifs();
  const row = await createReception({
    date: date || new Date().toISOString().slice(0, 10),
    parcours,
    tiersId,
    qualite,
    immatriculation: String(immatriculation || '').trim().toUpperCase().slice(0,32),
    poidsBrut: brut,
    tare: tareSaisie ? Number(tare) : null,
    mode: client ? 'prestation' : null,
    foss: null, prixFixe: null, prixBaseHuile: null,
    tarifTrituration: client ? tarifTriturationPour(qualite, readContacts().find((c) => c.id === tiersId)) : null,
    calamites: !client && t.calamitesDefaut === true,
    rendementReel: null,
    devenir: null,
    cuveId: null,
    ventes: [],
    statut: tareSaisie ? 'En attente' : 'Sur site',
    heureEntree: new Date().toISOString(),
    eclair: true, regionOrigine, variete, gps, traceStatut,
  });
  return { error: null, row };
}

// Part du montant d'une réception déjà couverte : avance fournisseur imputée
// + versement partiel reçu sur le compte courant du tiers.
export const dejaCouvert = (r) => Number((Number(r.avanceImputee || 0) + Number(r.reglePartiel || 0)).toFixed(3));

export function etatPaiement(r) {
  const c = decompte(r);
  if (r.statut === 'Sur site') return { code: 'attente', label: 'En attente de tare' };
  if (r.regle === true && r.regleMode === 'Avance') return { code: 'solde', label: `Soldé · avance imputée ${Number(r.avanceImputee || 0).toFixed(3)}` };
  if (r.regle === true) return { code: 'solde', label: `Soldé · ${r.regleMode || 'Espèces'}` };
  if (r.parcours === 'client' && r.devenir === 'cuve') return { code: 'depot', label: 'En dépôt · stock cuve' };
  if (r.parcours === 'fournisseur' && bonIncomplet(r)) return { code: 'incomplet', label: 'Détails à compléter (qualité / prix)' };
  if (r.parcours === 'client' && !(Number(r.tarifTrituration) > 0)) return { code: 'incomplet', label: 'Détails à compléter (tarif)' };
  if (c.enAttenteRendement) return { code: 'attente', label: 'Montant en attente (rendement)' };
  const imput = dejaCouvert(r);
  if (imput > 0 && c.montant > imput)
    return { code: 'impaye', label: `Reste ${(c.montant - imput).toFixed(3)} à payer · ${Number(r.reglePartiel || 0) > 0 ? 'versement' : 'avance'} ${imput.toFixed(3)} imputé` };
  if (c.montant > 0) return { code: 'impaye', label: r.parcours === 'client' ? 'Non soldé · à encaisser' : 'Non soldé · à payer' };
  return { code: 'aucun', label: '—' };
}

const compteParMode = (fin, mode) => {
  const ids = fin.comptes.map((c) => c.id);
  if (mode === 'Virement') return fin.comptes.find((c) => c.type === 'Banque')?.id ?? ids[0];
  return ids.includes('chq') ? 'chq' : ids.includes('esp') ? 'esp' : ids[0];
};

// Règlement en un clic : 100 % du montant de la ligne, espèces par défaut.
// UNE SEULE commande serveur : l'écriture de caisse ET le marquage du bon sont
// appliqués dans la même transaction (audit C02).
export async function solderReception(id, { mode = 'Espèces', compteId, utilisateur } = {}) {
  const r = read().find((x) => x.id === id);
  if (!r) return { error: 'Réception introuvable.' };
  if (r.regle === true) return { error: 'Cette réception est déjà soldée.' };
  const c = decompte(r);
  if (c.enAttenteRendement) return { error: 'Rendement réel non saisi : le montant n’est pas encore connu.' };
  if (!(c.montant > 0)) return { error: 'Aucun montant à solder sur cette ligne.' };
  const fin = readFin();
  const compte = compteId || compteParMode(fin, mode);
  const date = new Date().toISOString().slice(0, 10);
  const nom = nomTiers(r.tiersId);
  const montant = Number((c.montant - dejaCouvert(r)).toFixed(3));
  if (!(montant > 0)) return { error: 'Aucun reste à payer sur cette ligne.' };
  const ref = fin.comptes.find((x) => x.id === compte);
  if (!ref) return { error: 'Choisissez la caisse de règlement.' };
  const client = r.parcours === 'client';
  if (!client) {
    const dispo = soldeCompte(ref, fin.mouvements, fin.reglements);
    if (montant > dispo && !ref.decouvertAutorise)
      return { error: `Solde insuffisant sur « ${ref.nom} » : ${dispo.toFixed(2)} TND.` };
  }
  const ligne = client
    ? {
        date, type: 'Alimentation', compteId: compte, libelle: `Encaissement ${nom} — ${r.id}`,
        piece: r.id, montant, tiersId: r.tiersId, notes: `Solde prestation ${r.id} (${mode})`, mode,
      }
    : {
        date, categorie: 'Tiers', beneficiaire: nom, tiersId: r.tiersId, notes: `Solde réception ${r.id}`,
        piece: r.id, mode, compteId: compte, montant, acompte: false, statut: 'Payé',
      };
  const patch = { regle: true, regleDate: date, regleMode: mode, regleRef: '@ajout:0', reglePar: utilisateur ?? null };
  const res = await envoyerCommande('reception.solder', {
    resume: `Solde ${r.id} — ${nom} (${montant.toFixed(3)} TND)`,
    ajouts: [{ bucket: client ? 'mouvements' : 'reglements', ligne }],
    liees: [cleLiee(KEY, [opMaj(id, patch)])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  patcherItems(KEY, { [id]: { ...patch, regleRef: res.ids?.[0] ?? null } });
  republierLot(id);
  return { error: null, montant, mode };
}

// Republication automatique du portail public d'un lot (dès qu'un token existe),
// pour que le client voie le nouveau statut sans réimpression du bon.
export async function republierLot(id) {
  if (!aToken('lot', id)) return;
  const r = read().find((x) => x.id === id);
  if (!r) return;
  const c = decompte(r);
  const b = getBranding();
  await publier('lot', id, {
    id: r.id,
    date: r.date,
    tiers: nomTiers(r.tiersId),
    parcours: r.parcours,
    poidsBrut: r.poidsBrut,
    tare: r.tare,
    poidsNet: c.poidsNet,
    statut: r.statut,
    huilerie: b.nom,
    logo: b.logo,
  });
}

export async function updateReception(id, patch) {
  const avant = localStorage.getItem(KEY);
  const rows = read();
  // `minTrit` fourni explicitement (décision de dérogation) : jamais recalculé par-dessus.
  const explicite = Object.prototype.hasOwnProperty.call(patch ?? {}, 'minTrit');
  const next = rows.map((r) => {
    if (r.id !== id) return r;
    const fusion = { ...r, ...patch };
    return explicite ? fusion : recalculerMinimum(fusion, rows);
  });
  write(next);
  let row = next.find((r) => r.id === id);
  if (row && row.parcours === 'fournisseur' && !row.regle && !('avanceImputee' in patch)) row = imputerAvance(row);
  await publierMaintenant(KEY, avant);
  republierLot(id);
  return row;
}

// ---------------------------------------------------------------------------
// AVANCES FOURNISSEURS : versées à l'avance (règlement acompte), imputées
// automatiquement sur les nouveaux bons dès que leur montant est connu.
// ---------------------------------------------------------------------------
export function avanceDisponible(tiersId) {
  const versees = readFin().reglements
    .filter((x) => x.tiersId === tiersId && x.acompte === true && x.statut === 'Payé')
    .reduce((s, x) => s + Number(x.montant || 0), 0);
  const imputees = read()
    .filter((r) => r.tiersId === tiersId)
    .reduce((s, r) => s + Number(r.avanceImputee || 0), 0);
  return Number(Math.max(0, versees - imputees).toFixed(3));
}

function imputerAvance(r) {
  if (r.parcours !== 'fournisseur' || r.regle === true || r.statut === 'Sur site') return r;
  const c = decompte(r);
  if (c.enAttenteRendement || !(c.montant > 0)) return r;
  const reste = c.montant - dejaCouvert(r);
  if (reste <= 0.0005) return r;
  const dispo = avanceDisponible(r.tiersId);
  const imput = Math.min(dispo, reste);
  if (imput <= 0) return r;
  const cumul = Number((Number(r.avanceImputee || 0) + imput).toFixed(3));
  const solde = reste - imput <= 0.0005;
  const patch = {
    avanceImputee: cumul,
    ...(solde ? { regle: true, regleMode: 'Avance', regleDate: new Date().toISOString().slice(0, 10), regleRef: null } : {}),
  };
  const next = read().map((x) => (x.id === r.id ? { ...x, ...patch } : x));
  write(next);
  return next.find((x) => x.id === r.id);
}

export async function enregistrerAvanceFournisseur({ tiersId, montant, mode = 'Espèces', compteId, date, notes }) {
  const m = Number(montant) || 0;
  if (!tiersId) return { error: 'Sélectionnez le fournisseur.' };
  if (m <= 0) return { error: 'Saisissez un montant valide.' };
  const fin = readFin();
  const jour = date || new Date().toISOString().slice(0, 10);
  const compte = compteId || compteParMode(fin, mode);
  const ref = fin.comptes.find((c) => c.id === compte);
  if (!ref) return { error: 'Choisissez la caisse / banque de décaissement.' };
  const dispo = soldeCompte(ref, fin.mouvements, fin.reglements);
  if (m > dispo && !ref.decouvertAutorise)
    return { error: `Solde insuffisant sur « ${ref.nom} » : ${dispo.toFixed(2)} TND.` };
  const ligne = {
    date: jour,
    categorie: 'Tiers',
    beneficiaire: nomTiers(tiersId),
    tiersId,
    notes: notes || 'Avance sur livraisons à venir',
    piece: 'AVANCE',
    mode,
    compteId: compte,
    montant: m,
    acompte: true,
    statut: 'Payé',
  };
  // Imputation immédiate du pool d'avances sur les bons ouverts de ce fournisseur
  // (plus anciens d'abord) : décaissement et imputations dans la même transaction.
  const imputation = calculerImputation({
    tiersId,
    parcours: 'fournisseur',
    montant: Number((avanceDisponible(tiersId) + m).toFixed(3)),
    mode: 'Avance',
    date: jour,
    surAvance: true,
  });
  const res = await envoyerCommande('avance.fournisseur', {
    resume: `Avance fournisseur ${nomTiers(tiersId)} — ${m.toFixed(3)} TND`,
    ajouts: [{ bucket: 'reglements', ligne }],
    liees: lieesImputation(imputation.patchs),
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const id = res.ids?.[0] ?? null;
  appliquerImputation(imputation.patchs, id);
  return {
    error: null,
    row: { ...ligne, id },
    imputes: imputation.soldees.length + (imputation.partielle ? 1 : 0),
    disponible: avanceDisponible(tiersId),
  };
}

export async function fetchAvancesEnCours() {
  const ids = new Set(readFin().reglements.filter((x) => x.acompte === true && x.tiersId).map((x) => x.tiersId));
  return [...ids]
    .map((id) => ({ tiersId: id, nom: nomTiers(id), disponible: avanceDisponible(id) }))
    .filter((a) => a.disponible > 0)
    .sort((a, b) => b.disponible - a.disponible);
}

// Instantané allégé destiné au moteur de la Vigie (backend) : uniquement les
// données nécessaires aux 3 règles d'alerte et au brief quotidien.
export async function snapshotVigie() {
  const receptions = read();
  const cuves = readCuves().filter((c) => !c.virtuelle);
  const fin = readFin();
  return {
    date: new Date().toISOString().slice(0, 10),
    heure: new Date().toISOString(),
    regle_exercice_anterieur: `Les mouvements de catégorie « ${CAT_EXERCICE_ANTERIEUR} » règlent des chèques ou traites émis la saison précédente : ils sortent/entrent réellement en trésorerie mais doivent être EXCLUS des charges et statistiques de la saison en cours.`,
    receptions: receptions.map((r) => {
      const c = decompte(r);
      return {
        id: r.id,
        date: r.date,
        parcours: r.parcours,
        tiers: nomTiers(r.tiersId),
        tiersId: r.tiersId,
        statut: r.statut,
        poidsNet: c.poidsNet,
        foss: r.foss ?? null,
        rendementReel: r.rendementReel ?? null,
        huileExtraite: r.huileExtraite ?? null,
        devenir: r.devenir ?? null,
        montant: Number(c.montant.toFixed(3)),
        emballagesMontant: r.emballagesMontant ?? 0,
        emballagesRegle: r.emballagesRegle === true,
        emballagesDetail: (r.emballagesFournis ?? []).map((e) => `${e.nom} × ${e.qte}`),
      };
    }),
    cuves: cuves.map((c) => ({
      id: c.id,
      nom: c.nom,
      famille: c.famille,
      volume: c.volume,
      capacite: c.capacite,
      verrouillee: c.verrouillee === true,
      remplissage: c.capacite > 0 ? Number(((c.volume / c.capacite) * 100).toFixed(1)) : 0,
    })),
    caisses: fin.comptes.map((c) => ({
      id: c.id,
      nom: c.nom,
      type: c.type,
      solde: soldeCompte(c, fin.mouvements, fin.reglements),
    })),
    mouvementsDuJour: fin.mouvements.filter((m) => m.date === new Date().toISOString().slice(0, 10)).length,
  };
}
export async function buildSnapshot() {
  const receptions = read();
  const cuves = readCuves();
  const k = await fetchKpis();
  return {
    date_du_jour: new Date().toISOString().slice(0, 10),
    parametres: { tarification: 'saisie par réception (tarif trituration / prix de base huile)' },
    kpi: {
      tonnage: k.tonnage,
      rendements: k.rendements,
      volumes_cuves: k.volumes,
      banques: k.banques,
      caisses: k.caisses,
      comptoir_emballages_tnd: k.comptoir,
    },
    receptions: receptions.map((r) => {
      const c = decompte(r);
      return {
        id: r.id,
        date: r.date,
        parcours: r.parcours,
        tiers: nomTiers(r.tiersId),
        qualite: r.qualite ? labelQualite(r.qualite) : null,
        filiere: r.parcours === 'fournisseur' ? familleDe(r.qualite) : 'client',
        mode: labelMode(r.mode),
        tarif_trituration_tnd_par_kg: r.tarifTrituration ?? null,
        prix_base_huile_tnd: r.prixBaseHuile ?? null,
        poids_net_kg: c.poidsNet,
        rendement_pct: c.rendement,
        huile_l: Math.round(c.huile),
        montant_tnd: Number(c.montant.toFixed(2)),
        emballages_tnd: Number(c.emballages.toFixed(2)),
        statut: r.statut,
      };
    }),
    cuves: cuves.map((c) => ({
      nom: c.nom,
      filiere: c.famille,
      qualite: c.qualite,
      unite: c.unite,
      capacite: c.capacite,
      quantite: c.volume,
      reste: c.capacite - c.volume,
      remplissage_pct: c.capacite ? Number(((c.volume / c.capacite) * 100).toFixed(1)) : 0,
      cmp_tnd: c.cmp,
      emplacement: c.emplacement,
    })),
    sous_produits: readSp(),
    ventes_comptoir: readVentes(),
    emballages: readFormats(),
    conditionnements: readCond(),
    caisse: (() => {
      const fin = readFin();
      return {
        comptes: fin.comptes.map((c) => ({ nom: c.nom, type: c.type, solde_tnd: soldeCompte(c, fin.mouvements, fin.reglements) })),
        mouvements: fin.mouvements,
      };
    })(),
    reglements: readFin().reglements,
    contacts: readContacts().map((c) => ({ nom: c.nom, type: c.type, region: c.region, tel: c.tel })),
    // Modules récents exposés à l'IA
    personnel: readContacts()
      .filter((c) => c.type === 'personnel')
      .map((c) => ({
        nom: c.nom,
        contrat: c.contrat ?? null,
        cin: c.cin ?? null,
        cnss: c.cnss ?? null,
        salaire_jour_tnd: c.salaireJour ?? 0,
        salaire_mois_tnd: c.salaireMois ?? 0,
      })),
    pointages: readPointages(),
    achats_huile: readAchatsHuile(),
    bonus_retenues: readBonus(),
    rapprochement_bancaire: (() => {
      const fin = readFin();
      return {
        principe: 'import de relevé CSV/Excel/PDF (lecture IA Gemini), aucune connexion API bancaire',
        pointages: readRapp(),
        comptes: fin.comptes
          .filter((c) => c.type === 'Banque')
          .map((c) => ({
            nom: c.nom,
            solde_ouverture_tnd: Number(c.initial) || 0,
            date_ouverture: c.dateOuverture ?? null,
            decouvert_autorise: Boolean(c.decouvertAutorise),
            solde_theorique_tnd: soldeCompte(c, fin.mouvements, fin.reglements),
            solde_pointe_tnd: soldeRapproche(c, fin),
          })),
      };
    })(),
    coffre_et_caisses: (() => {
      const fin = readFin();
      return fin.comptes
        .filter((c) => c.type !== 'Banque')
        .map((c) => ({
          nom: c.nom,
          type: c.type,
          solde_ouverture_tnd: Number(c.initial) || 0,
          date_ouverture: c.dateOuverture ?? null,
          solde_tnd: soldeCompte(c, fin.mouvements, fin.reglements),
        }));
    })(),
    emballages_vides: readFormats().map((f) => ({
      format: f.nom,
      contenance_l: f.litres,
      prix_unitaire_tnd: f.prixEmballage,
      stock_vides_unites: f.stock,
      nature: 'consommable acheté chez un fournisseur, non vendable seul',
    })),
    produits_finis_sku: readPF().map((x) => ({
      sku: x.id,
      designation: x.nom,
      format: x.formatNom,
      denomination: x.denomination,
      contenance_l: x.litres,
      stock_rayon_unites: x.stock,
      cout_unitaire_tnd: x.cout,
      prix_vente_unitaire_tnd: x.prixVente ?? 0,
      marge_unitaire_tnd: Number(((x.prixVente ?? 0) - x.cout).toFixed(3)),
      nature: 'issu du conditionnement (huile + emballage vide), vendable au détail',
    })),
    appro_emballages: readAppro(),
    journal_audit: readAudit().slice(0, 50),
    roles_et_permissions: {
      profils: {
        Administrateur: 'accès total, statistiques, banques, coffre, corrections/suppressions',
        'Responsable Pont-Bascule': 'réception, achats, ventes, caisse bascule, dépenses, grille de pointage (sans les soldes du personnel) — aucune statistique globale',
        'Chef d’Atelier': 'trituration, cuves, sous-produits — aucune donnée financière',
        Coursier: 'saisie des dépenses uniquement',
      },
    },
  };
}

// Applique une proposition du Copilote après confirmation du gérant.
export async function appliquerPropositionReception(p) {
  const annuaire = readContacts();
  const tiers = annuaire.find(
    (c) => c.nom.toLowerCase() === String(p.tiers || '').toLowerCase()
  ) ?? annuaire.find((c) => String(p.tiers || '').toLowerCase().includes(c.nom.toLowerCase().split(' ')[0]));
  if (!tiers) return { error: `Tiers « ${p.tiers} » introuvable dans les contacts.` };

  const parcours = p.parcours === 'fournisseur' ? 'fournisseur' : 'client';
  const mode = parcours === 'client' ? 'prestation' : p.mode && p.mode !== 'prestation' ? p.mode : 'fixe';

  const row = await createReception({
    date: new Date().toISOString().slice(0, 10),
    parcours,
    tiersId: tiers.id,
    qualite: parcours === 'fournisseur' ? p.qualite || 'extra_vierge' : null,
    poidsBrut: Number(p.poids_brut) || 0,
    tare: Number(p.tare) || 0,
    mode,
    foss: mode === 'foss' ? Number(p.foss) || null : null,
    prixFixe: mode === 'fixe' ? Number(p.prix_fixe) || null : null,
    prixBaseHuile: mode === 'foss' || mode === 'reel' ? Number(p.prix_base_huile) || null : null,
    tarifTrituration: parcours === 'client' ? Number(p.tarif_trituration) || tarifTriturationPour(p.qualite, tiers) : null,
    ...(parcours === 'client' && Number(p.tarif_trituration) > 0 ? { tarifTriturationSource: 'manuel' } : {}),
    rendementReel: null,
    devenir: parcours === 'client' ? p.devenir || 'cuve' : null,
    cuveId: null,
    ventes: [],
    statut: 'En attente',
  });
  return { error: null, row };
}

// --- Trituration (mode opérateur) ---

export const familleLot = (r) => (familleDe(r.qualite) === 'lampante' ? 'lampante' : 'noble');

// File d'attente atelier : 4 files strictes (parcours × filière).
export const fileAttenteLot = (r) =>
  `${r.parcours === 'client' ? 'client' : 'fournisseur'}_${familleLot(r)}`;

export async function fetchFileAttente() {
  return read().filter(
    (r) => r.statut === 'En attente' || r.statut === 'Planifié' || r.statut === 'En trituration'
  );
}

// --- Ordres de Fabrication : planning atelier piloté par la Bascule / Direction ---

const OF_KEY = 'oliva.ofs';
const readOfs = () => JSON.parse(localStorage.getItem(OF_KEY) ?? '[]');
const writeOfs = (v) => localStorage.setItem(OF_KEY, JSON.stringify(v));

export async function fetchOfs() {
  const rows = read();
  return readOfs().map((o) => {
    const lots = o.lots.map((id) => rows.find((r) => r.id === id)).filter(Boolean);
    const olives = lots.reduce((s, r) => s + decompte(r).poidsNet, 0);
    const huile = lots.reduce((s, r) => s + (Number(r.huileExtraite) || 0), 0);
    const coutOlives = lots.filter((r) => r.parcours === 'fournisseur').reduce((s, r) => s + (decompte(r).enAttenteRendement ? 0 : decompte(r).montant), 0);
    const termine = lots.length > 0 && lots.every((r) => r.statut === 'Trituré' || r.statut === 'Décompté');
    // Alertes visuelles : OF vide, lots sans huile saisie, lots sans qualité, OF partiellement traité.
    const lotsSansHuile = lots.filter((r) => (r.statut === 'Trituré' || r.statut === 'Décompté') && !(Number(r.huileExtraite) > 0));
    const lotsSansQualite = lots.filter((r) => !r.qualite);
    const partiel = lots.some((r) => r.statut === 'Trituré' || r.statut === 'Décompté') && !termine;
    const alertes = [
      lots.length === 0 ? 'OF vide — aucun lot rattaché' : null,
      lotsSansQualite.length ? `Qualité manquante : ${lotsSansQualite.map((r) => r.id).join(', ')}` : null,
      lotsSansHuile.length ? `Huile non saisie : ${lotsSansHuile.map((r) => r.id).join(', ')}` : null,
      partiel ? 'Retour d’atelier incomplet — lots restants non triturés' : null,
      !termine && !partiel && lots.length > 0 ? 'Non traité — en attente de retour d’atelier' : null,
    ].filter(Boolean);
    const prixRef = prixReference(lots.some((r) => familleLot(r) === 'lampante') ? 'lampante' : 'noble');
    const fosse = lots.filter((r) => r.mode === 'foss' && ecartRendement(r) !== null);
    const bonusFosseKg = fosse.reduce((s, r) => s + ecartRendement(r), 0);
    const bonusFosseTnd = fosse.reduce((s, r) => s + ecartRendement(r) * (Number(r.prixBaseHuile) || prixRef), 0);
    const coutKg = huile > 0 && coutOlives > 0 ? coutOlives / huile : null;
    return {
      ...o,
      statut: o.statut === 'Terminé' || termine ? 'Terminé' : o.statut ?? 'Ouvert',
      alertes,
      enAlerte: alertes.length > 0,
      olives, huile,
      rendement: olives > 0 && huile > 0 ? Number(((huile / olives) * 100).toFixed(2)) : null,
      coutOlives,
      coutRevientKg: coutKg != null ? Number(coutKg.toFixed(3)) : null,
      prixRef,
      ecartMarche: coutKg != null ? Number(((prixRef - coutKg) * huile).toFixed(3)) : null,
      famille: lots.some((r) => familleLot(r) === 'lampante') ? 'lampante' : 'noble',
      tiersNoms: [...new Set(lots.map((r) => nomTiers(r.tiersId)))].join(', '),
      fosse: fosse.length ? { lots: fosse.length, kg: Number(bonusFosseKg.toFixed(3)), tnd: Number(bonusFosseTnd.toFixed(3)) } : null,
      lignes: lots.map((r, i) => ({
        ordre: i + 1,
        id: r.id,
        tiers: nomTiers(r.tiersId),
        tiersId: r.tiersId,
        parcours: r.parcours,
        qualite: r.qualite ? labelQualite(r.qualite) : '—',
        mode: labelMode(r.mode),
        poidsNet: decompte(r).poidsNet,
        statut: r.statut,
        huile: Number(r.huileExtraite) || 0,
        cuves: (r.cuves || []).map((c) => readCuves().find((k) => k.id === c.cuveId)?.nom ?? c.cuveId).join(', '),
        devenir: r.devenir,
      })),
    };
  });
}

export async function planifierLots(ids, utilisateur, { decanteur = '', libelle = '' } = {}) {
  const rows = read();
  const lots = rows.filter((r) => ids.includes(r.id));
  if (!lots.length) return { error: 'Sélectionnez au moins un lot en attente.' };
  const dejaTraites = lots.filter((r) => r.statut !== 'En attente');
  if (dejaTraites.length)
    return { error: `Lot(s) déjà engagé(s) : ${dejaTraites.map((r) => r.id).join(', ')}.` };
  const sansQualite = lots.filter((r) => !r.qualite);
  if (sansQualite.length)
    return {
      error: `Qualité manquante sur ${sansQualite.map((r) => r.id).join(', ')} : complétez le bon (Extra-Vierge / Vierge / Lampante) avant de le planifier.`,
    };
  if ([...new Set(lots.map(familleLot))].length > 1)
    return { error: 'Un OF ne peut pas mélanger des lots lampante et nobles.' };
  // Un OF peut planifier plusieurs passages de clients DIFFÉRENTS : chaque lot garde son
  // tiers et son huile (aucun total commun n'est réparti entre clients — cf. repartirProrata
  // et declarerSortieHuile). Les prestations clients ne se mélangent pas avec des achats.
  const clients = [...new Set(lots.filter((r) => r.parcours === 'client').map((r) => r.tiersId))];
  if (clients.length > 0 && lots.some((r) => r.parcours === 'fournisseur'))
    return { error: 'Un OF ne mélange pas des prestations clients et des achats d’olives : planifiez-les séparément.' };

  const id = `OF-${Date.now()}`;
  const of = {
    id,
    numero: attribuerNumero('ordre_fabrication', id),
    date: new Date().toISOString().slice(0, 10),
    creePar: utilisateur ?? '—',
    lots: ids,
    decanteur: decanteur || null,
    libelle: libelle || null,
    statut: 'Ouvert',
  };
  writeOfs([of, ...readOfs()]);
  write(rows.map((r) => (ids.includes(r.id) ? { ...r, statut: 'Planifié', ofId: id } : r)));
  ids.forEach((i) => republierLot(i));
  return { error: null, of };
}

// Lots planifiables : bons en attente. Un bon sans qualité n'est jamais masqué,
// il est renvoyé avec le drapeau sansQualite pour être signalé à l'opérateur.
export async function fetchLotsPlanifiables() {
  return read()
    .filter((r) => r.statut === 'En attente')
    .map((r) => ({ ...r, sansQualite: !r.qualite }));
}

// Bons non affectés à un OF (ni planifiés, ni triturés) — payés ou non.
export const nonTriture = (r) => !['Planifié', 'En trituration', 'Trituré', 'Décompté'].includes(r.statut);

// Retour d'atelier : saisie huile + cuve par lot d'un OF, puis clôture de l'OF.
export async function retourAtelier(ofId, lignes, utilisateur, opts = {}) {
  const of = readOfs().find((o) => o.id === ofId);
  if (!of) return { error: 'OF introuvable.' };
  const propres = (lignes || []).filter((l) => Number(l.huile) > 0);
  if (!propres.length) return { error: 'Saisissez l’huile produite pour au moins un lot.' };
  for (const l of propres) {
    const r = read().find((x) => x.id === l.id);
    if (!r || r.statut === 'Trituré' || r.statut === 'Décompté') continue;
    const directe = r.parcours === 'client' && r.devenir === 'sortie';
    const repartition = (l.repartition ?? []).filter((x) => x.cuveId && Number(x.kg) > 0);
    if (!directe && !l.cuveId && repartition.length === 0)
      return { error: `${l.id} : choisissez la cuve de destination.` };
    const statutAvant = r.statut;
    if (r.statut !== 'En trituration') await demarrerTrituration([l.id]);
    // Toute l'huile produite entre physiquement en cuve ; la retenue y bascule au stock huilerie.
    const q = Number(l.huile);
    const res = await declarerSortieHuile({
      ids: [l.id],
      poidsHuile: q,
      repartition: directe ? undefined : repartition.length ? repartition : [{ cuveId: l.cuveId, kg: q }],
      emballages: l.emballages,
      directe,
      override: opts.override,
      utilisateur,
    });
    if (res.error) {
      write(read().map((x) => (x.id === l.id ? { ...x, statut: statutAvant } : x)));
      return { error: `${l.id} : ${res.error}` };
    }
  }
  const lots = read().filter((r) => of.lots.includes(r.id));
  const tousFaits = opts.cloturer === true || (lots.length > 0 && lots.every((r) => r.statut === 'Trituré' || r.statut === 'Décompté'));
  // Moteur analytique (§15) exécuté à la clôture : coefficient de réalisation & rendements ajustés par fournisseur.
  let analytique = null;
  if (tousFaits) {
    const fourn = lots.filter((r) => r.parcours === 'fournisseur');
    const kg = fourn.reduce((s, r) => s + decompte(r).poidsNet, 0);
    const theo = fourn.reduce((s, r) => s + huileTheorique(r), 0);
    const reel = fourn.reduce((s, r) => s + (Number(r.huileExtraite) || 0), 0);
    const coef = theo > 0 ? reel / theo : null;
    analytique = {
      kg, huileTheorique: Number(theo.toFixed(3)), huileReelle: Number(reel.toFixed(3)),
      rendementTheoriquePondere: kg > 0 ? Number(((theo / kg) * 100).toFixed(2)) : null,
      rendementReel: kg > 0 ? Number(((reel / kg) * 100).toFixed(2)) : null,
      bonusMalusKg: Number((reel - theo).toFixed(3)),
      coefficientRealisation: coef != null ? Number(coef.toFixed(4)) : null,
      lots: fourn.map((r) => {
        const t = decompte(r).poidsNet > 0 ? huileTheorique(r) / decompte(r).poidsNet : 0;
        return { id: r.id, tiersId: r.tiersId, kg: decompte(r).poidsNet, rendementTheorique: Number((t * 100).toFixed(2)), rendementAjuste: coef != null ? Number((t * coef * 100).toFixed(2)) : null, bonusMalusIndicatifKg: coef != null ? Number((decompte(r).poidsNet * (t * coef - t)).toFixed(3)) : null };
      }),
    };
  }
  writeOfs(readOfs().map((o) => (o.id === ofId ? { ...o, statut: tousFaits ? 'Terminé' : 'En cours', termineLe: tousFaits ? new Date().toISOString().slice(0, 10) : null, valideePar: utilisateur ?? null, analytique: analytique ?? o.analytique ?? null } : o)));
  return { error: null, termine: tousFaits };
}

export async function supprimerOf(id) {
  writeOfs(readOfs().filter((o) => o.id !== id));
  write(
    read().map((r) =>
      r.ofId === id && r.statut === 'Planifié' ? { ...r, statut: 'En attente', ofId: null } : r
    )
  );
  return { error: null };
}

export const numeroOf = (ofId) => readOfs().find((o) => o.id === ofId)?.numero ?? null;
export const ordreDansOf = (r) => {
  const of = readOfs().find((o) => o.id === r.ofId);
  return of ? of.lots.indexOf(r.id) + 1 : null;
};

export async function demarrerTrituration(ids) {
  write(read().map((r) => (ids.includes(r.id) ? { ...r, statut: 'En trituration' } : r)));
  ids.forEach((id) => republierLot(id));
  return { error: null };
}

// Déclaration de fin de lot : verse l'huile extraite dans une cuve et
// incrémente instantanément le stock. Blocage vital lampante ↔ nobles.
// Retenue automatique de 2 % au bénéfice de l'huilerie, uniquement pour :
// achat au rendement réel (compteurs), achat à prix fixe négocié, ou client
// prestation ayant choisi le stockage à l'huilerie.
export const TAUX_RETENUE = 0.02; // valeur par défaut, surchargée par les paramètres
export const prixReference = (famille) => Number(famille === 'lampante' ? getTarifs().prixMarcheLampante : getTarifs().prixMarcheHuile) || PRIX_VENTE_HUILE;
const tauxRetenue = () => (Number(getTarifs().retenue) || 0) / 100;
export { tauxRetenue };

// Retenue d'huile : uniquement les clients (prestation) qui laissent leur huile en stockage à l'huilerie.
export const lotRetenu = (r) => r.parcours === 'client' && r.devenir === 'cuve';

const BONUS_KEY = 'oliva.bonus';
const BONUS_DEFAUT = { volume: 0, noble: 0, lampante: 0, valeur: 0, parCuve: {}, vendu: 0, realise: 0, mouvements: [] };
const readBonus = () => ({ ...BONUS_DEFAUT, ...JSON.parse(localStorage.getItem(BONUS_KEY) ?? '{}') });
const writeBonus = (v) => localStorage.setItem(BONUS_KEY, JSON.stringify(v));

// L'huile de bonus a un coût d'acquisition nul : elle est valorisée au dernier prix
// de vente réellement pratiqué dans sa filière (valeur estimée).
export function dernierPrixVente(famille = 'noble') {
  const lampante = famille === 'lampante';
  const vente = readVentes()
    .filter((v) => (familleDe(v.denomination) === 'lampante') === lampante)
    .filter((v) => Number(v.prixKg) > 0)
    .sort((a, b) => (a.date < b.date ? 1 : -1))[0];
  return Number(vente?.prixKg) || PRIX_VENTE_HUILE;
}

// Répartition de l'huile de bonus par cuve physique. Les retenues enregistrées avant
// la mise en place de ce suivi sont reconstituées depuis la traçabilité des lots.
function parCuveBonus(b) {
  if (Object.keys(b.parCuve ?? {}).length > 0) return { ...b.parCuve };
  const map = {};
  read().forEach((r) => {
    const retenue = Number(r.retenueHuilerie) || 0;
    const lignes = r.cuves ?? [];
    const total = lignes.reduce((s, l) => s + (Number(l.kg) || 0), 0);
    if (retenue <= 0 || total <= 0) return;
    lignes.forEach((l) => {
      const part = Number((retenue * ((Number(l.kg) || 0) / total)).toFixed(3));
      if (part > 0) map[l.cuveId] = Number(((map[l.cuveId] || 0) + part).toFixed(3));
    });
  });
  return map;
}

export async function fetchBonus() {
  const b = readBonus();
  const prixNoble = dernierPrixVente('noble');
  const prixLampante = dernierPrixVente('lampante');
  return {
    ...b,
    valeur: 0,
    prixNoble,
    prixLampante,
    valeurEstimee: Number((b.noble * prixNoble + b.lampante * prixLampante).toFixed(3)),
    valeurRealisee: Number((b.realise || 0).toFixed(3)),
    kgVendu: Number((b.vendu || 0).toFixed(3)),
  };
}

// Vente physique depuis une cuve réelle : on isole la part d'huile de bonus vendue
// et on inscrit sa valeur réalisée (prix de vente final exact) sur la cuve virtuelle.
// Calcul PUR : rien n'est écrit ici, le patch est porté par la commande serveur.
function calculerBonusSurVente({ vente, cumul, volumesAvant, prixParKg }) {
  const b = readBonus();
  const parCuve = parCuveBonus(b);
  let kgBonus = 0;
  Object.entries(cumul).forEach(([cuveId, kg]) => {
    const dispoBonus = Number(parCuve[cuveId] || 0);
    const volume = Number(volumesAvant[cuveId] || 0);
    if (dispoBonus <= 0 || volume <= 0) return;
    const part = Math.min(dispoBonus, Number(((Number(kg) || 0) * (dispoBonus / volume)).toFixed(3)));
    if (part <= 0) return;
    parCuve[cuveId] = Number((dispoBonus - part).toFixed(3));
    kgBonus = Number((kgBonus + part).toFixed(3));
  });
  if (kgBonus <= 0) return null;

  const lampante = familleDe(vente.denomination) === 'lampante';
  const realise = Number((kgBonus * prixParKg).toFixed(3));
  return {
    kgBonus,
    realise,
    champs: {
      volume: Number(Math.max(0, b.volume - kgBonus).toFixed(3)),
      noble: Number(Math.max(0, b.noble - (lampante ? 0 : kgBonus)).toFixed(3)),
      lampante: Number(Math.max(0, b.lampante - (lampante ? kgBonus : 0)).toFixed(3)),
      valeur: 0,
      parCuve,
      vendu: Number(((b.vendu || 0) + kgBonus).toFixed(3)),
      realise: Number(((b.realise || 0) + realise).toFixed(3)),
    },
    mouvement: {
      id: `B-${Date.now()}`,
      date: vente.date,
      lots: [vente.id],
      famille: lampante ? 'lampante' : 'noble',
      kg: -kgBonus,
      valeur: realise,
      realise,
      prixKg: Number(prixParKg.toFixed(3)),
      motif: `Part de bonus vendue avec ${vente.id} (${vente.client}) à ${prixParKg.toFixed(3)} TND/kg — valeur réalisée`,
    },
  };
}

// Répartition libre de l'huile produite sur plusieurs cuves + retenue 2 %.
export async function declarerSortieHuile({ ids, poidsHuile, repartition, cuveId, emballages, directe, override = false, utilisateur }) {
  const rows = read();
  const lots = rows.filter((r) => ids.includes(r.id));
  const cuves = readCuves();
  const q = Number(poidsHuile) || 0;

  if (!lots.length) return { error: 'Aucun lot sélectionné.' };
  if (q <= 0) return { error: 'Saisissez le poids d’huile extraite.' };

  const familles = [...new Set(lots.map(familleLot))];
  if (familles.length > 1)
    return { error: 'Regroupement interdit : un lot lampante ne peut pas être trituré avec des lots nobles.' };
  const famille = familles[0];

  // Un total d'huile mesuré n'est JAMAIS réparti entre des clients différents : les droits
  // en huile restent attachés au tiers de chaque lot (les OF multiclients sont autorisés,
  // mais chaque passage se déclare avec son propre total).
  const tiersClients = clientsDistincts(lots);
  if (tiersClients.length > 1)
    return {
      error:
        'Déclaration refusée : ces lots appartiennent à des clients différents. Déclarez un total d’huile par client (passage réellement trituré ensemble).',
    };
  if (tiersClients.length === 1 && lots.some((r) => r.parcours === 'fournisseur'))
    return { error: 'Déclaration refusée : une prestation client et un achat d’olives ne partagent pas le même total d’huile.' };

  // Sortie immédiate : l'huile part avec le client, aucune cuve physique à choisir.
  // Le devenir non fixé au pont-bascule est décidé ici, à la trituration.
  const sortieDirecte =
    typeof directe === 'boolean' ? directe : lots.every((r) => r.parcours === 'client' && r.devenir === 'sortie');

  // Emballages fournis par l'atelier : décrément du stock de vides et créance client.
  const lignesEmb = (emballages ?? [])
    .map((e) => ({ formatId: e.formatId, qte: Number(e.qte) || 0 }))
    .filter((e) => e.qte > 0);
  const clientsLots = lots.filter((r) => r.parcours === 'client');
  // Minimum de facturation : jamais de tarif ni de décision choisis en silence pour
  // un passage. Harmonisation demandée à un utilisateur autorisé avant validation.
  if (clientsLots.length > 1 && !passageHomogene(clientsLots).homogene)
    return {
      error:
        'Harmonisation requise avant déclaration : les bons de ce passage ne portent pas le même tarif de trituration ou la même décision de dérogation. Faites-les harmoniser par un utilisateur autorisé.',
    };
  // Emballages facultatifs : sans saisie, on considère « pas d'emballages fournis »
  // (le client peut apporter ses propres bidons).
  const formats = readFormats();
  for (const e of lignesEmb) {
    const f = formats.find((x) => x.id === e.formatId);
    if (!f) return { error: 'Emballage inconnu dans la saisie atelier.' };
    if (e.qte > (Number(f.stock) || 0))
      return { error: `Stock d’emballages insuffisant : « ${f.nom} » (reste ${f.stock}).` };
  }
  if (lignesEmb.length && !clientsLots.length)
    return { error: 'Les emballages ne se saisissent que pour un lot client (prestation).' };

  // Retenue calculée au prorata de l'huile des lots éligibles.
  // Éligibilité effective : prestation client dont l'huile est réellement versée en cuve
  // (stockée à l'huilerie), y compris quand le devenir n'a pas été fixé au pont-bascule.
  const estRetenu = (r) => r.parcours === 'client' && !sortieDirecte;
  const netTotal = lots.reduce((s, r) => s + decompte(r).poidsNet, 0);
  const netRetenu = lots.filter(estRetenu).reduce((s, r) => s + decompte(r).poidsNet, 0);
  const TAUX = tauxRetenue();
  const retenue = Number((q * (netTotal > 0 ? netRetenu / netTotal : 0) * TAUX).toFixed(3));
  // La retenue reste physiquement dans la cuve : tout le volume produit est versé.
  const aVerser = q;
  const netClients = clientsLots.reduce((s, r) => s + decompte(r).poidsNet, 0);
  const qClients = netTotal > 0 ? q * (netClients / netTotal) : 0; // huile brute des clients (retenue incluse)
  const qFourn = Number((q - qClients).toFixed(3));

  const repartitionEffective = sortieDirecte
    ? [{ cuveId: CUVE_SORTIE_DIRECTE.id, kg: aVerser }]
    : repartition ?? (cuveId ? [{ cuveId, kg: q }] : []);

  const lignes = repartitionEffective
    .map((l) => ({ kg: Number(l.kg) || 0, cuve: cuves.find((c) => c.id === l.cuveId) }))
    .filter((l) => l.cuve && l.kg > 0);
  if (lignes.length === 0) return { error: 'Ajoutez au moins une cuve de destination avec une quantité.' };

  const croisee = lignes.find((l) => !l.cuve.virtuelle && l.cuve.famille !== famille);
  if (croisee && !override)
    return {
      error:
        famille === 'lampante'
          ? `BLOCAGE SÉCURITÉ : lot LAMPANTE interdit dans la cuve noble « ${croisee.cuve.nom} ».`
          : `BLOCAGE SÉCURITÉ : lot NOBLE interdit dans la cuve lampante « ${croisee.cuve.nom} ».`,
    };
  if (croisee) journalOverride(utilisateur, `versement ${famille} dans la cuve ${croisee.cuve.nom} (lots ${ids.join(', ')})`);

  const verrouillee = lignes.find((l) => l.cuve.verrouillee === true);
  if (verrouillee)
    return { error: `Cuve « ${verrouillee.cuve.nom} » verrouillée par la direction : versement refusé.` };

  const somme = Number(lignes.reduce((s, l) => s + l.kg, 0).toFixed(3));
  if (Math.abs(somme - aVerser) > 0.05)
    return {
      error: `La répartition (${somme} kg) doit correspondre à l’huile produite (${aVerser} kg, retenue incluse — elle reste en cuve).`,
    };

  const cumul = {};
  lignes.forEach((l) => { cumul[l.cuve.id] = (cumul[l.cuve.id] || 0) + l.kg; });
  for (const [id, kg] of Object.entries(cumul)) {
    const c = cuves.find((x) => x.id === id);
    if (!c.virtuelle && kg > c.capacite - c.volume)
      return { error: `Capacité insuffisante dans « ${c.nom} » : reste ${c.capacite - c.volume} ${c.unite}.` };
  }

  // Part d'huile d'un lot : prorata de son poids net — même règle que l'attribution
  // enregistrée plus bas (`huileExtraite`), pour que coût et rendement soient cohérents.
  const partProrata = (r) => (netTotal > 0 ? q * (decompte(r).poidsNet / netTotal) : q / lots.length);
  const coutLot = (r) => {
    if (r.parcours !== 'fournisseur') return 0;
    // FOSS : même prix définitif que le décompte fournisseur (déchets inclus).
    // La retenue est une dette envers l’État, pas une réduction du coût matière.
    if (r.mode === 'foss') return decompte(r).montantBrut;
    const net = decompte(r).poidsNet;
    if (r.mode === 'fixe') return net * (Number(r.prixFixe) || 0);
    const huile = lots.length === 1 ? q : partProrata(r);
    const rdt = r.mode === 'foss' && r.foss ? Number(r.foss) : net > 0 ? (huile / net) * 100 : 0;
    // « À négocier » : provision au cours figé à la réception (jamais 0).
    const base = r.mode === 'negocier' ? Number(r.coursFige?.prixApplique) || prixReference(familleDe(r.qualite)) : Number(r.prixBaseHuile) || 0;
    return net * (rdt / 100) * base;
  };
  const cout = lots.reduce((s, r) => s + coutLot(r), 0);
  const coutParKg = qFourn > 0 ? cout / qFourn : 0;
  // Part d'huile encore valorisée à titre provisoire (prix non fixé) : le CMP de la
  // cuve est marqué « provisoire » et sera réajusté à la fixation du prix.
  const qProvisoire = Number(
    lots
      .filter((r) => r.parcours === 'fournisseur' && r.mode === 'negocier' && !r.prixFixeLe)
      .reduce((s, r) => s + (lots.length === 1 ? q : partProrata(r)), 0)
      .toFixed(3)
  );

  // Stock physique vs stock financier par cuve :
  //  - huile fournisseur → stock financier, entre dans le CMP au coût d'achat ;
  //  - huile client (nette de retenue) → dette en nature (volumeClients), hors CMP ;
  //  - retenue → bascule client → huilerie, valorisée au CMP courant (ne dilue pas le CMP).
  let valeurRetenue = 0;
  writeCuves(
    cuves.map((c) => {
      const kg = cumul[c.id];
      if (!kg) return c;
      const part = kg / q;
      const kgFourn = Number((qFourn * part).toFixed(3));
      const kgRetenue = Number((retenue * part).toFixed(3));
      const kgClientsNet = Number((kg - kgFourn - kgRetenue).toFixed(3));
      const cmp = c.virtuelle ? c.cmp : cmpApres(c, kgFourn, coutParKg);
      valeurRetenue += kgRetenue * cmp;
      const kgProvisoire = Number((qProvisoire * part).toFixed(3));
      return {
        ...c,
        volume: Number((c.volume + kg).toFixed(3)),
        volumeClients: Number(((c.volumeClients || 0) + Math.max(0, kgClientsNet)).toFixed(3)),
        volumeProvisoire: Number(((c.volumeProvisoire || 0) + kgProvisoire).toFixed(3)),
        _traceEntree: { receptions: lots.map(r=>({id:r.id,poids:decompte(r).poidsNet})) },
        cmp,
      };
    })
  );
  valeurRetenue = Number(valeurRetenue.toFixed(3));

  if (retenue > 0) {
    const b = readBonus();
    // Lot Client/Prestation : la retenue est UNIQUEMENT en nature. Sa valeur financière
    // est strictement bloquée à 0 TND (coût d'acquisition nul pour l'huilerie).
    const parCuve = { ...(b.parCuve ?? {}) };
    const verseTotal = Object.values(cumul).reduce((s, k) => s + (Number(k) || 0), 0);
    Object.entries(cumul).forEach(([cuveId, kg]) => {
      const part = verseTotal > 0 ? Number((retenue * ((Number(kg) || 0) / verseTotal)).toFixed(3)) : 0;
      if (part > 0) parCuve[cuveId] = Number(((parCuve[cuveId] || 0) + part).toFixed(3));
    });
    writeBonus({
      ...b,
      volume: Number((b.volume + retenue).toFixed(3)),
      noble: Number((b.noble + (famille === 'lampante' ? 0 : retenue)).toFixed(3)),
      lampante: Number((b.lampante + (famille === 'lampante' ? retenue : 0)).toFixed(3)),
      valeur: 0,
      parCuve,
      mouvements: [
        {
          id: `B-${Date.now()}`,
          date: new Date().toISOString().slice(0, 10),
          lots: ids,
          famille,
          kg: retenue,
          valeur: 0,
          cuves: Object.keys(cumul),
          motif: `Retenue ${(TAUX * 100).toFixed(2)} % stockage client — en nature uniquement (valeur financière nulle)`,
        },
        ...b.mouvements,
      ].slice(0, 200),
    });
  }

  // Emballages fournis par l'atelier : décrément du stock de vides et créance
  // portée au compte du client (alerte « Emballage à régler » jusqu'à encaissement).
  let embMontant = 0;
  let embDetail = [];
  if (lignesEmb.length) {
    embDetail = lignesEmb.map((e) => {
      const f = formats.find((x) => x.id === e.formatId);
      return {
        formatId: e.formatId,
        nom: f.nom,
        qte: e.qte,
        prixUnitaire: Number(f.prixEmballage) || 0,
        total: Number((e.qte * (Number(f.prixEmballage) || 0)).toFixed(3)),
      };
    });
    embMontant = Number(embDetail.reduce((s, l) => s + l.total, 0).toFixed(3));
    writeFormats(
      formats.map((f) => {
        const l = lignesEmb.find((e) => e.formatId === f.id);
        return l ? { ...f, stock: Number(f.stock) - l.qte } : f;
      })
    );
  }
  // La créance emballages est imputée au premier lot client du cycle.
  const lotEmb = clientsLots[0]?.id ?? null;

  // Passage commercial : identifiant stable posé sur les bons réellement triturés
  // ensemble. C'est la base du minimum de facturation (un seul complément par passage).
  const passageId = clientsLots.length
    ? clientsLots.find((r) => r.passageId)?.passageId ?? `PS-${Date.now().toString(36).toUpperCase()}`
    : null;
  const paramsMin = parametresMinimum(getTarifs());
  const contactsMin = readContacts();
  const bonsPassageMin = clientsLots
    .map((r) => ({ id: r.id, poidsNet: decompte(r).poidsNet, tarifTrituration: r.tarifTrituration }))
    .sort((a, b) => String(a.id).localeCompare(String(b.id)));
  const minTritPour = (r, net) => {
    if (r.parcours !== 'client' || r.minTrit?.fige === true) return r.minTrit;
    return instantaneMinimum({
      bon: { id: r.id, poidsNet: net, tarifTrituration: r.tarifTrituration },
      bonsPassage: bonsPassageMin,
      params: paramsMin,
      exempt: contactsMin.find((c) => c.id === r.tiersId)?.exempteMinimumTrituration === true,
      passageId: r.passageId ?? passageId,
      derogation: r.minTrit?.derogation ?? null,
      estimation: false,
      fige: false,
    });
  };

  write(
    rows.map((r) => {
      if (!ids.includes(r.id)) return r;
      const net = decompte(r).poidsNet;
      // Part d'huile au prorata du poids net : garantit somme(retenues) = retenue globale.
      const brut = netTotal > 0 ? q * (net / netTotal) : q / lots.length;
      const retenuLot = estRetenu(r) ? Number((brut * TAUX).toFixed(3)) : 0;
      const huile = Number((brut - retenuLot).toFixed(3));
      const porteEmb = embMontant > 0 && r.id === lotEmb;
      return {
        ...r,
        statut: 'Trituré',
        dateTrituration: new Date().toISOString().slice(0, 10),
        // Horodatage de fin de production : base des périodes d'origine du repassage.
        finTriturationLe: new Date().toISOString(),
        devenir: r.parcours === 'client' ? (sortieDirecte ? 'sortie' : 'cuve') : r.devenir,
        cuves: Object.entries(cumul).map(([id, kg]) => ({ cuveId: id, kg })),
        cuveId: lignes[0].cuve.id, // conservé pour compatibilité (1re cuve de la répartition)
        sortieDirecte: sortieDirecte || r.sortieDirecte === true,
        retenueHuilerie: retenuLot,
        // Passage commercial et minimum de facturation : le poids physique reste intact.
        passageId: r.parcours === 'client' ? r.passageId ?? passageId : r.passageId,
        minTrit: minTritPour(r, net),
        // Au gramme : même précision que la répartition saisie, aucune perte d'arrondi.
        huileExtraite: Number(huile.toFixed(3)),
        rendementReel: net > 0 ? Number(((huile / net) * 100).toFixed(2)) : r.rendementReel,
        ...(porteEmb
          ? {
              emballagesFournis: embDetail,
              emballagesMontant: embMontant,
              emballagesRegle: false,
            }
          : {}),
      };
    })
  );

  ids.forEach((id) => republierLot(id));

  return {
    error: null,
    retenue,
    aVerser,
    sortieDirecte,
    emballagesMontant: embMontant,
    cuves: Object.entries(cumul).map(([id, kg]) => ({
      nom: cuves.find((c) => c.id === id).nom,
      kg,
    })),
  };
}

// --- Emballages fournis à l'atelier : encaissement de la créance client ---

export const emballagesDus = () =>
  read()
    .filter((r) => (r.emballagesMontant || 0) > 0 && r.emballagesRegle !== true)
    .map((r) => ({
      id: r.id,
      date: r.date,
      tiersId: r.tiersId,
      tiers: nomTiers(r.tiersId),
      montant: Number(r.emballagesMontant),
      detail: r.emballagesFournis ?? [],
    }));

export async function reglerEmballages(id, { compteId, mode, piece, date }) {
  const r = read().find((x) => x.id === id);
  if (!r) return { error: 'Lot introuvable.' };
  if ((r.emballagesMontant || 0) <= 0) return { error: 'Aucun emballage à régler sur ce lot.' };
  if (r.emballagesRegle === true) return { error: 'Emballages déjà réglés.' };

  const res = await envoyerCommande('emballages.regler', {
    resume: `Emballages du lot ${r.id} — ${Number(r.emballagesMontant).toFixed(3)} TND`,
    ajouts: [{
      bucket: 'mouvements',
      ligne: {
        date: date || new Date().toISOString().slice(0, 10),
        type: 'Alimentation',
        compteId,
        categorie: 'Emballages',
        libelle: `Emballages fournis — lot ${r.id} — ${nomTiers(r.tiersId)}${mode ? ` (${mode})` : ''}`,
        piece: piece || r.id,
        montant: Number(r.emballagesMontant),
      },
    }],
    liees: [cleLiee(KEY, [opMaj(id, { emballagesRegle: true })])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };

  patcherItems(KEY, { [id]: { emballagesRegle: true } });
  return { error: null, montant: r.emballagesMontant };
}

// --- Relevés clients : huile stockée pour le compte des tiers ---

const RET_KEY = 'oliva.retraits';
const readRetraits = () => JSON.parse(localStorage.getItem(RET_KEY) ?? '[]');
export const readRetraitsPublics = readRetraits;
const writeRetraits = (v) => localStorage.setItem(RET_KEY, JSON.stringify(v));

export async function fetchRelevesClients() {
  const rows = read().filter(
    (r) => r.parcours === 'client' && r.devenir === 'cuve' && (r.statut === 'Trituré' || r.statut === 'Décompté')
  );
  const retraits = readRetraits();
  const cuves = readCuves();
  const nomCuve = (id) => cuves.find((c) => c.id === id)?.nom ?? '—';

  const map = {};
  rows.forEach((r) => {
    const c = decompte(r);
    const huile = Number(r.huileExtraite ?? c.huile) || 0;
    const nom = nomTiers(r.tiersId);
    map[nom] = map[nom] ?? { nom, tiersId: r.tiersId, depots: [], retraits: [], depose: 0, retire: 0 };
    map[nom].depots.push({
      id: r.id,
      date: r.date,
      cuve: nomCuve(r.cuveId),
      cuveId: r.cuveId,
      olives: c.poidsNet,
      rendement: c.rendement,
      tarif: c.tarifTrituration,
      huile: Number(huile.toFixed(1)),
      trituration: Number(c.trituration.toFixed(2)),
      statut: r.statut,
    });
    map[nom].depose += huile;
  });

  JSON.parse(localStorage.getItem('oliva.reprises_huile') ?? '[]')
    .filter((r) => ['huile_client', 'droit_huile'].includes(r.type))
    .forEach((r) => {
      const nom = nomTiers(r.tiersId);
      map[nom] = map[nom] ?? { nom, tiersId: r.tiersId, depots: [], retraits: [], depose: 0, retire: 0 };
      map[nom].depose += Number(r.kg) || 0;
      map[nom].depots.push({ id: r.id, date: r.date, huile: Number(r.kg), olives: 0, rendement: 0, tarif: 0, trituration: 0, statut: 'Report', cuveId: r.cuveId, cuve: readCuves().find((c) => c.id === r.cuveId)?.nom || '', notes: r.reference });
    });

  retraits.forEach((t) => {
    map[t.client] = map[t.client] ?? { nom: t.client, tiersId: null, depots: [], retraits: [], depose: 0, retire: 0 };
    map[t.client].retraits.push({ ...t, cuve: nomCuve(t.cuveId) });
    map[t.client].retire += t.litres;
  });

  return Object.values(map)
    .map((c) => ({
      ...c,
      depose: Number(c.depose.toFixed(1)),
      retire: Number(c.retire.toFixed(1)),
      solde: Number((c.depose - c.retire).toFixed(1)),
      fraisTrituration: Number(c.depots.reduce((s, d) => s + d.trituration, 0).toFixed(2)),
    }))
    .sort((a, b) => b.solde - a.solde);
}

// Droits d'huile d'un client, cuve par cuve : ses dépôts et reports rattachés à chaque
// cuve, moins ce qui en a déjà été retiré ou racheté. Jamais négatif.
export function droitsClientParCuve(fiche) {
  const par = {};
  (fiche?.depots ?? []).forEach((d) => {
    if (d.cuveId) par[d.cuveId] = (par[d.cuveId] || 0) + (Number(d.huile) || 0);
  });
  (fiche?.retraits ?? []).forEach((t) => {
    // `droits` porte la répartition réelle du prélèvement ; sinon la cuve de la pièce.
    const detail = t.droits && typeof t.droits === 'object' && Object.keys(t.droits).length
      ? t.droits
      : (t.cuveId ? { [t.cuveId]: Number(t.litres ?? t.kg) || 0 } : null);
    if (!detail) return;
    Object.entries(detail).forEach(([id, kg]) => { par[id] = (par[id] || 0) - (Number(kg) || 0); });
  });
  Object.keys(par).forEach((id) => { par[id] = Number(par[id].toFixed(3)); });
  return par;
}

// Diminution des droits clients dans une filière : la cuve choisie d'abord, puis les autres
// cuves de la même famille. Avec `droitsClient` (droits du client concerné, par cuve), le
// prélèvement est strictement limité à son huile : les droits des autres clients sont intouchables.
export function repartirDiminutionClients(cuves, source, quantite, droitsClient = null) {
  if (!source || source.virtuelle || source.id === 'CUVE_SORTIE_DIRECTE' || source.verrouillee)
    return { error: 'Choisissez une cuve physique non verrouillée.' };
  if (!Number.isFinite(quantite) || quantite <= 0)
    return { error: 'Quantité invalide.' };
  const candidates = cuves.filter(c => !c.virtuelle && c.id !== 'CUVE_SORTIE_DIRECTE' && c.famille === source.famille);
  const mobilisable = (c) => {
    const cuve = Math.max(0, Number(c.volumeClients) || 0);
    return droitsClient ? Math.min(cuve, Math.max(0, Number(droitsClient[c.id]) || 0)) : cuve;
  };
  const total = candidates.reduce((s, c) => s + mobilisable(c), 0);
  if (quantite > total + 0.00001)
    return {
      error: droitsClient
        ? `Droits de ce client insuffisants dans cette filière : ${total.toFixed(3)} kg rattachés à ses cuves pour ${quantite.toFixed(3)} kg demandés. Vérifiez la cuve où son huile est enregistrée — les droits d'un autre client ne sont jamais consommés.`
        : 'Droits clients insuffisants dans cette filière. Vérifiez la répartition du stock client.',
    };
  let reste = Math.round(quantite * 1000);
  const ordre = [
    ...candidates.filter(c => c.id === source.id),
    ...candidates.filter(c => c.id !== source.id)
      .sort((a, b) => mobilisable(b) - mobilisable(a) || String(a.id).localeCompare(String(b.id))),
  ];
  const parts = {};
  const prises = {};
  for (const c of ordre) {
    const avant = Math.max(0, Math.round((Number(c.volumeClients) || 0) * 1000));
    const pris = Math.min(Math.round(mobilisable(c) * 1000), reste);
    parts[c.id] = (avant - pris) / 1000;
    if (pris > 0) prises[c.id] = pris / 1000;
    reste -= pris;
  }
  return { cuves: cuves.map(c => Object.hasOwn(parts, c.id) ? { ...c, volumeClients: parts[c.id] } : c), prises };
}

// Prévient quand la cuve désignée ne porte aucun droit du client : l'opération reste
// possible, mais le rattachement de son huile doit être vérifié.
const avertissementRattachement = (source, prises, cuves) =>
  (prises[source.id] ? null
    : `Aucun droit de ce client n'est rattaché à « ${source.nom} » : les droits ont été prélevés sur ${Object.keys(prises).map((id) => cuves.find((c) => c.id === id)?.nom || id).join(', ') || 'aucune cuve'}. Vérifiez où son huile est enregistrée.`);

export async function enregistrerRetrait({ date, client, cuveId, litres, notes = '', utilisateur }) {
  const q = Number(litres) || 0;
  if (!client) return { error: 'Sélectionnez le client.' };
  if (q <= 0) return { error: 'Saisissez la quantité retirée.' };

  const releves = await fetchRelevesClients();
  const fiche = releves.find((r) => r.nom === client);
  if (!fiche || fiche.solde <= 0) return { error: `Aucun solde d'huile disponible pour ${client}.` };
  if (q > fiche.solde)
    return { error: `Retrait supérieur au solde de ${client} : ${fiche.solde} L disponibles.` };

  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === cuveId);
  if (!cuve) return { error: 'Sélectionnez la cuve de retrait.' };
  if (q > cuve.volume) return { error: `Stock insuffisant dans « ${cuve.nom} » : ${cuve.volume} ${cuve.unite}.` };

  const droits = repartirDiminutionClients(cuves, cuve, q, droitsClientParCuve(fiche));
  if (droits.error) return droits;
  // Le physique sort de la cuve choisie ; les droits diminuent dans la même filière.
  writeCuves(droits.cuves.map((c) => (c.id === cuve.id ? { ...c, volume: Number((c.volume - q).toFixed(3)) } : c)));
  const retraits = readRetraits();
  const maxId = retraits.reduce((m, t) => Math.max(m, Number(String(t.id).split('-')[1]) || 0), 0);
  const row = {
    id: `T-${maxId + 1}`,
    date,
    client,
    tiersId: readContacts().find((c) => c.nom === client)?.id ?? null,
    cuveId,
    cuveNom: cuve.nom,
    qualite: cuve.qualite || (cuve.famille === 'lampante' ? 'Lampante' : 'Vierge'),
    litres: q,
    droits: droits.prises,
    notes: String(notes || '').trim(),
    par: utilisateur ?? null,
    soldeApres: Number((fiche.solde - q).toFixed(1)),
  };
  writeRetraits([row, ...retraits]);
  return { error: null, row, avertissement: avertissementRattachement(cuve, droits.prises, cuves) };
}

// KPI détaillés : filière lampante strictement cloisonnée.
export async function fetchKpis(du = '', au = '') {
  const dansP = (d) => (!du || d >= du) && (!au || d <= au);
  const rows = read().filter((r) => dansP(r.date));
  const achats = rows.filter((r) => r.parcours === 'fournisseur');
  const clients = rows.filter((r) => r.parcours === 'client');
  const nobleAchat = achats.filter((r) => familleDe(r.qualite) === 'noble');
  const lampanteAchat = achats.filter((r) => familleDe(r.qualite) === 'lampante');

  const poids = (list) => list.reduce((s, r) => s + decompte(r).poidsNet, 0);
  const traite = (r) => r.statut === 'Trituré' || r.statut === 'Décompté';
  const moyenneRdt = (list) => {
    const avec = list.filter((r) => decompte(r).rendement > 0);
    return avec.length
      ? Number((avec.reduce((s, r) => s + decompte(r).rendement, 0) / avec.length).toFixed(2))
      : 0;
  };

  const tonnage = {
    total: poids(rows),
    attente: poids(rows.filter((r) => !traite(r))),
    traite: poids(rows.filter(traite)),
    prestation: poids(clients),
    achat: poids(achats),
    noble: poids(nobleAchat) + poids(clients),
    lampante: poids(lampanteAchat),
  };

  const rendements = {
    extra: moyenneRdt(nobleAchat),
    lampante: moyenneRdt(lampanteAchat),
    trituration: moyenneRdt(clients),
  };

  const cuves = readCuves().filter((c) => !c.virtuelle);
  const vol = (f) => cuves.filter(f).reduce((s, c) => s + c.volume, 0);
  const volumes = {
    total: vol(() => true),
    huilerie: Number(cuves.reduce((s, c) => s + stockFinancier(c), 0).toFixed(3)),
    clients: Number(cuves.reduce((s, c) => s + (c.volumeClients || 0), 0).toFixed(3)),
    noble: vol((c) => c.famille === 'noble'),
    lampante: vol((c) => c.famille === 'lampante'),
  };

  const fin = readFin();
  const banques = fin.comptes
    .filter((c) => c.type === 'Banque')
    .map((c) => ({
      id: c.id,
      nom: c.banque ?? c.nom,
      rib: c.rib ?? '—',
      solde: soldeCompte(c, fin.mouvements, fin.reglements),
      soldePointe: soldeRapproche(c, fin),
    }));
  const caisses = fin.comptes
    .filter((c) => c.type !== 'Banque')
    .map((c) => ({ id: c.id, nom: c.nom, solde: soldeCompte(c, fin.mouvements, fin.reglements) }));

  return {
    tonnage,
    rendements,
    volumes,
    banques,
    caisses,
    tresorerie: {
      banques: banques.reduce((s, b) => s + b.solde, 0),
      banquesPointe: banques.reduce((s, b) => s + b.soldePointe, 0),
      caisses: caisses.reduce((s, c) => s + c.solde, 0),
    },
    lampante: { tonnage: tonnage.lampante, volume: volumes.lampante },
    comptoir: clients.reduce((s, r) => s + decompte(r).emballages, 0),
  };
}

// --- Comptes courants tiers : grand livre unifié (prestation + achats + argent) ---

const libelleMode = (r) =>
  r.parcours === 'client'
    ? 'Prestation trituration'
    : `Achat olives — ${labelMode(r.mode)}${
        r.mode === 'negocier' && !r.prixFixeLe ? ' (montant provisoire au cours figé)' : ''
      }${r.modeOrigine === 'negocier' && r.prixFixeLe ? ' (prix fixé après négociation)' : ''}`;

export async function fetchCompteTiers(tiersId) {
  const contact = readContacts().find((c) => c.id === tiersId);
  const receptions = read().filter((r) => r.tiersId === tiersId);
  const fin = readFin();

  const lignes = [];

  // Solde de départ saisi sur la fiche contact (report d'ouverture).
  const depart = Number(contact?.soldeDepart) || 0;
  if (depart !== 0 && !contact?.repriseGeree) {
    lignes.push({
      id: `${tiersId}-depart`,
      date: contact.soldeDepartDate || '0000-00-00',
      type: 'Solde de départ (report)',
      nature: depart > 0 ? 'achat' : 'prestation',
      bon: 'OUVERTURE',
      poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
      debit: depart < 0 ? -depart : 0,
      credit: depart > 0 ? depart : 0,
      notes: contact.soldeDepartNote || 'Report du solde antérieur à la mise en service',
      statut: 'Report',
    });
  }

  if (contact?.repriseGeree) {
    JSON.parse(localStorage.getItem('oliva.reprises_depart') ?? '[]')
      .filter((r) => r.tiersId === tiersId && ['dette', 'creance'].includes(r.type))
      .forEach((r) => lignes.push({ id: r.id, date: r.date, type: 'Reprise antérieure', nature: 'report', bon: r.reference,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: r.type === 'creance' ? Number(r.montant) : 0, credit: r.type === 'dette' ? Number(r.montant) : 0,
        notes: r.motif, statut: 'Report' }));
  }

  // Retraits d'huile : vraie transaction datée (volume, cuve, note), sans impact financier.
  readRetraits()
    .filter((t) => (t.tiersId && t.tiersId === tiersId) || (!t.tiersId && contact && t.client === contact.nom))
    .forEach((t) => {
      lignes.push({
        id: t.id,
        date: t.date,
        type: 'Retrait d’huile',
        nature: 'retrait',
        bon: t.id,
        poidsBrut: 0, tare: 0, poidsNet: -Number(t.litres), rendement: 0, prixBase: 0,
        debit: 0, credit: 0,
        litres: Number(t.litres),
        notes: `${Number(t.litres).toFixed(1)} kg d’huile retirés · cuve ${readCuves().find((c) => c.id === t.cuveId)?.nom ?? t.cuveId}${t.notes ? ` — ${t.notes}` : ''}`,
        statut: 'Retiré',
      });
    });

  receptions.forEach((r) => {
    const c = decompte(r);
    const client = r.parcours === 'client';
    lignes.push({
      id: r.id,
      date: r.date,
      type: libelleMode(r),
      nature: client ? 'prestation' : 'achat',
      bon: r.id,
      poidsBrut: Number(r.poidsBrut) || 0,
      tare: Number(r.tare) || 0,
      poidsNet: c.poidsNet,
      rendement: c.rendement,
      // Confidentialité fournisseur : sur les documents, seul le rendement théorique
      // validé à l'entrée (machine / FOSS) est communiqué. Le rendement réel de
      // l'atelier reste interne.
      rendementTheorique: client ? c.rendement : r.mode === 'foss' ? Number(r.foss) || 0 : null,
      // Prix de base communiqué au fournisseur : TOUJOURS exprimé au kilo d'HUILE
      // (la négociation porte sur la valeur de l'huile). Pour un achat à prix fixe
      // au kilo d'olives, on publie l'équivalent huile ; pour un lot « à négocier »
      // non fixé, on publie le cours figé qui a servi à calculer la provision.
      prixBase: client
        ? c.tarifTrituration
        : r.mode === 'negocier' && !r.prixFixeLe
          ? Number(r.coursFige?.prixApplique) || 0
          : r.mode === 'fixe'
            ? c.huile > 0
              ? Number((c.montant / c.huile).toFixed(3))
              : 0
            : c.prixBaseHuile,
      prixBaseUnite: client ? 'olive' : 'huile',
      // Équivalent calculé (prix fixe au kilo d'olives converti en valeur huile).
      prixBaseEquivalent: !client && r.mode === 'fixe' && c.huile > 0,
      // Montant calculé sur un cours figé, non définitif tant que le prix n'est pas négocié.
      provisoire: r.parcours === 'fournisseur' && r.mode === 'negocier' && !r.prixFixeLe,
      coursFigeValeur: r.mode === 'negocier' ? Number(r.coursFige?.prixApplique) || null : null,
      debit: client ? c.montant : 0,
      credit: client ? 0 : c.montant,
      notes: [
        c.enAttenteRendement ? 'En attente du rendement réel' : '',
        r.parcours === 'client' && r.devenir === 'sortie' && r.huileExtraite
          ? `Huile livrée directement au client : ${Number(r.huileExtraite).toFixed(1)} kg`
          : '',
        c.retenueCalamites > 0 ? `Retenue Fonds des Calamités 1 % : −${c.retenueCalamites.toFixed(3)} TND (brut ${c.montantBrut.toFixed(3)})` : '',
      ]
        .filter(Boolean)
        .join(' · '),
      statut: r.statut,
    });
    if ((r.emballagesMontant || 0) > 0) {
      lignes.push({
        id: `${r.id}-emb`,
        date: r.date,
        type: 'Emballages fournis (atelier)',
        nature: 'emballages',
        bon: r.id,
        poidsBrut: 0,
        tare: 0,
        poidsNet: 0,
        rendement: 0,
        prixBase: 0,
        debit: r.emballagesRegle === true ? 0 : Number(r.emballagesMontant),
        credit: 0,
        notes:
          (r.emballagesFournis ?? []).map((e) => `${e.nom} × ${e.qte}`).join(', ') +
          (r.emballagesRegle === true ? ' — réglé' : ' — À RÉGLER'),
        statut: r.emballagesRegle === true ? 'Payé' : 'En attente',
      });
    }
  });

  fin.reglements
    .filter((x) => x.tiersId === tiersId)
    .forEach((x) =>
      lignes.push({
        id: x.id,
        date: x.date,
        type: x.acompte ? 'Avance versée' : 'Paiement versé',
        nature: 'paiement',
        bon: x.piece,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: x.statut === 'Payé' ? x.montant : 0,
        credit: 0,
        notes: x.notes || '',
        statut: x.statut,
        mode: x.mode,
      })
    );

  fin.mouvements
    .filter((x) => x.tiersId === tiersId)
    .forEach((x) =>
      lignes.push({
        id: x.id,
        date: x.date,
        type: 'Encaissement reçu',
        nature: 'encaissement',
        bon: x.piece,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: 0,
        credit: x.montant,
        notes: x.notes || x.libelle || '',
        statut: 'Encaissé',
      })
    );

  readVentes()
    .filter((v) => v.tiersId === tiersId && v.paiement === 'Différé')    .forEach((v) =>
      lignes.push({
        id: v.id,
        date: v.date,
        type: `Vente ${v.format === 'vrac' ? 'vrac' : 'détail'} — ${v.denomination ?? 'huile'}`,
        nature: 'vente',
        bon: v.id,
        poidsBrut: 0, tare: 0, poidsNet: v.kg, rendement: 0, prixBase: v.prixKg,
        debit: v.total,
        credit: 0,
        notes: 'Facture à crédit — créance client',
        statut: 'À encaisser',
      })
    );

  lireFacturesLibres()
    .filter((x) => x.tiersId === tiersId)
    .forEach((x) =>
      lignes.push({
        id: x.id,
        date: x.date,
        type: x.type === 'groupee' ? `Facture groupée ${x.numero}` : `Facture diverse ${x.numero}`,
        nature: 'vente',
        bon: x.numero,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: x.total,
        credit: 0,
        notes: x.notes || `${x.lignes.length} ligne(s) — créance client`,
        statut: 'À encaisser',
      })
    );

  readVentes()
    .filter((v) => v.tiersId === tiersId && v.paiement !== 'Différé' && (v.supplement ?? 0) > 0)
    .forEach((v) =>
      lignes.push({
        id: `${v.id}-sup`,
        date: v.date,
        type: `Lignes libres sur facture ${v.id}`,
        nature: 'vente',
        bon: v.id,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: v.supplement,
        credit: 0,
        notes: (v.lignesLibres || []).map((l) => l.designation).join(' · '),
        statut: 'À encaisser',
      })
    );

  readAppro()
    .filter((a) => a.tiersId === tiersId)
    .forEach((a) =>
      lignes.push({
        id: a.id,
        date: a.date,
        type: `Achat d’emballages (${a.unites} u.)`,
        nature: 'achat',
        bon: a.id,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: 0,
        credit: a.total,
        notes: a.notes || 'Approvisionnement consommables',
        statut: 'Reçu',
      })
    );

  readAchatsHuile()
    .filter((a) => a.tiersId === tiersId)    .forEach((a) => {
      lignes.push({
        id: a.id,
        date: a.date,
        type: a.type === 'externe' ? 'Achat huile externe' : 'Rachat huile client',
        nature: 'achat',
        bon: a.id,
        poidsBrut: 0, tare: 0, poidsNet: a.kg, rendement: 0, prixBase: a.prixKg, prixBaseUnite: 'huile',
        debit: 0,
        credit: a.montant,
        notes: a.notes || '',
        statut: a.cuveNom,
      });
      if (a.compense > 0)
        lignes.push({
          id: `${a.id}-C`,
          date: a.date,
          type: 'Compensation automatique',
          nature: 'paiement',
          bon: a.id,
          poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
          debit: a.compense,
          credit: 0,
          notes: `Dette épongée par le rachat d’huile ${a.id}`,
          statut: 'Compensé',
        });
    });

  readPointages()
    .filter((p) => p.tiersId === tiersId)
    .forEach((p) =>
      lignes.push({
        id: p.id,
        date: p.date,
        type: `Pointage — ${p.typeTravail}`,
        nature: 'achat',
        bon: p.id,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: 0,
        credit: p.montant,
        notes: p.notes || 'Salaire dû',
        statut: 'Validé',
      })
    );

  // Factures de frais généraux : dette envers le fournisseur (TTC diminué de la retenue à la source).
  readDepenses()
    .filter((d) => d.tiersId === tiersId)
    .forEach((d) => {
      const ttc = Number(d.montantTTC) || 0;
      const rs = Number(d.montantRS) || 0;
      lignes.push({
        id: d.id,
        date: d.date,
        type: `Facture frais généraux ${d.numeroFacture}`,
        nature: 'achat',
        bon: d.numero,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: 0,
        credit: Number((ttc - rs).toFixed(3)),
        notes: [
          d.categorie,
          d.libelle,
          `HT ${Number(d.montantHT || 0).toFixed(3)}`,
          Number(d.autresTaxes) ? `FODEC ${Number(d.autresTaxes).toFixed(3)}` : '',
          `TVA ${Number(d.montantTVA || 0).toFixed(3)}`,
          Number(d.timbreFiscal) ? `timbre ${Number(d.timbreFiscal).toFixed(3)}` : '',
          `TTC ${ttc.toFixed(3)}`,
          rs > 0 ? `retenue à la source ${d.tauxRS} % : −${rs.toFixed(3)}` : '',
        ]
          .filter(Boolean)
          .join(' · '),
        statut: 'À payer',
      });
      (d.reglements ?? []).forEach((l) =>
        lignes.push({
          id: l.id,
          date: l.date,
          type: `Règlement facture ${d.numeroFacture}`,
          nature: 'paiement',
          bon: l.piece || d.numero,
          poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
          debit: Number(l.montant) || 0,
          credit: 0,
          notes: `${l.mode}${l.piece ? ` ${l.piece}` : ''}${
            l.differe && !l.decaisse ? ` — en attente de décaissement (échéance ${l.echeance ?? '—'})` : ''
          }`,
          statut: l.differe && !l.decaisse ? 'En attente de décaissement' : 'Payé',
          mode: l.mode,
        })
      );
    });

  // Avances / acomptes versés au fournisseur : décaissement réel, imputé ensuite sur les factures.
  readAvances()
    .filter((a) => a.tiersId === tiersId)
    .forEach((a) => {
      const impute = Number((a.imputations ?? []).reduce((s, i) => s + Number(i.montant), 0).toFixed(3));
      lignes.push({
        id: a.id,
        date: a.date,
        type: `Avance versée ${a.numero}`,
        nature: 'paiement',
        bon: a.numero,
        poidsBrut: 0, tare: 0, poidsNet: 0, rendement: 0, prixBase: 0,
        debit: Number(a.montant) || 0,
        credit: 0,
        notes: [
          `${a.mode}${a.piece ? ` ${a.piece}` : ''}`,
          readFin().comptes.find((c) => c.id === a.compteId)?.nom,
          impute > 0 ? `imputé ${impute.toFixed(3)} sur factures` : 'non encore imputée',
        ]
          .filter(Boolean)
          .join(' · '),
        statut: impute > 0 ? 'Imputée' : 'Solde créditeur',
        mode: a.mode,
      });
    });

  // Conversions « huile → dette monétaire » : la dette en nature (kg) devient une
  // dette TND envers le client, payable par les circuits de règlement existants.
  JSON.parse(localStorage.getItem('oliva.conversions') ?? '[]')
    .filter((c) => c.tiersId === tiersId && !c.annuleLe && (c.effetAuPaiement ? Boolean(c.payeeLe) : true))
    .forEach((c) => {
      lignes.push({
        id: c.id,
        date: c.dateEffet,
        type: `Conversion huile → dette (${c.kg} kg à ${c.prixKg} TND/kg)`,
        nature: 'conversion',
        bon: c.reference || c.id,
        poidsBrut: 0,
        tare: 0,
        poidsNet: 0,
        rendement: 0,
        prixBase: Number(c.prixKg) || 0,
        prixBaseUnite: 'huile',
        debit: 0,
        credit: Number(c.montant) || 0,
        notes: [c.echeance ? `échéance ${c.echeance}` : '', (c.paye || 0) > 0 ? `réglé ${Number(c.paye).toFixed(3)} TND` : 'non réglée', c.notes]
          .filter(Boolean)
          .join(' · '),
        statut: (c.paye || 0) >= (c.montant || 0) - 0.001 ? 'Payé' : 'En attente',
      });
      if ((c.paye || 0) > 0) {
        lignes.push({
          id: `${c.id}-P`,
          date: c.payeeLe || c.dateEffet,
          type: `Règlement conversion ${c.id}`,
          nature: 'paiement',
          bon: c.id,
          poidsBrut: 0,
          tare: 0,
          poidsNet: 0,
          rendement: 0,
          prixBase: 0,
          debit: Number(c.paye) || 0,
          credit: 0,
          notes: 'Paiement de la dette issue de la conversion d’huile',
          statut: 'Payé',
        });
      }
    });

  const ordre = { achat: 0, prestation: 0, retrait: 0, conversion: 0, paiement: 1, encaissement: 1 };
  lignes.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : (ordre[a.nature] ?? 0) - (ordre[b.nature] ?? 0)));

  let cumul = 0;
  const avecSolde = lignes.map((l) => {
    cumul += l.credit - l.debit;
    return { ...l, solde: Number(cumul.toFixed(3)) };
  });

  const somme = (f) => Number(lignes.filter(f).reduce((s, l) => s + l.credit + l.debit, 0).toFixed(3));

  return {
    tiersId,
    nom: contact?.nom ?? nomTiers(tiersId),
    type: contact?.type ?? null,
    tel: contact?.tel ?? '',
    adresse: contact?.adresse ?? '',
    mf: contact?.mf ?? '',
    cin: contact?.cin ?? '',
    mixte:
      (contact?.estClient ?? receptions.some((r) => r.parcours === 'client')) &&
      (contact?.estFournisseur ?? receptions.some((r) => r.parcours === 'fournisseur')),
    lignes: avecSolde,
    totalAchats: somme((l) => l.nature === 'achat'),
    totalPrestations: somme((l) => l.nature === 'prestation'),
    totalPaye: somme((l) => l.nature === 'paiement'),
    totalEncaisse: somme((l) => l.nature === 'encaissement'),
    solde: Number(cumul.toFixed(3)),
  };
}
// Espace personnel du tiers (QR permanent) : instantané complet republié sur
// le serveur à chaque écriture, pour que le relevé flashé soit toujours à jour.
export async function publierCompte(tiersId) {
  const [compte, releves] = await Promise.all([fetchCompteTiers(tiersId), fetchRelevesClients()]);
  const contact = readContacts().find((c) => c.id === tiersId);
  const huile = releves.find((r) => r.nom === compte.nom);
  const b = getBranding();
  // Factures de frais généraux du fournisseur : détail et reste à payer réel.
  const factures = readDepenses()
    .filter((d) => d.tiersId === tiersId)
    .map(enrichirDepense)
    .sort((x, y) => (x.date < y.date ? 1 : -1))
    .map((d) => ({
      numero: d.numero,
      numeroFacture: d.numeroFacture,
      date: d.date,
      categorie: d.categorie,
      libelle: d.libelle,
      montantHT: d.montantHT,
      montantTVA: d.montantTVA,
      montantTTC: d.montantTTC,
      montantRS: d.montantRS,
      avanceImputee: Number(d.avanceImputee || 0),
      regle: d.regle,
      reste: d.reste,
      statut: d.statut,
    }));
  // Avances versées par l'huilerie : montant, part imputée, solde créditeur restant.
  const avances = readAvances()
    .filter((a) => a.tiersId === tiersId)
    .sort((x, y) => (x.date < y.date ? 1 : -1))
    .map((a) => {
      const impute = Number((a.imputations ?? []).reduce((s, i) => s + Number(i.montant), 0).toFixed(3));
      return {
        numero: a.numero,
        date: a.date,
        montant: Number(a.montant) || 0,
        mode: a.mode,
        piece: a.piece || '',
        impute,
        reste: Number(((Number(a.montant) || 0) - impute).toFixed(3)),
      };
    });
  const resteAPayer = Number(factures.reduce((s, f) => s + Number(f.reste || 0), 0).toFixed(3));
  const voyages = read()
    .filter((r) => r.tiersId === tiersId)
    .sort((x, y) => (x.date < y.date ? 1 : -1))
    .map((r) => {
      const c = decompte(r);
      return {
        id: r.id, date: r.date, parcours: r.parcours, statut: r.statut,
        qualite: r.qualite ? labelQualite(r.qualite) : 'Prestation',
        poidsBrut: Number(r.poidsBrut) || 0, tare: r.tare ?? null, poidsNet: c.poidsNet,
        rendement: c.enAttenteRendement || r.parcours === 'fournisseur' ? (r.mode === 'foss' ? Number(r.foss) || null : null) : c.rendement,
        huile: c.enAttenteRendement || r.parcours === 'fournisseur' ? null : c.huile,
        montant: c.enAttenteRendement ? null : c.montant,
        avanceImputee: Number(r.avanceImputee || 0),
        devenir: r.devenir, cuve: r.cuveId ? readCuves().find((k) => k.id === r.cuveId)?.nom ?? null : null,
        paiement: etatPaiement(r),
      };
    });
  return publier('compte', tiersId, {
    tiersId,
    code: contact?.code ?? '',
    nom: compte.nom,
    tel: compte.tel,
    solde: compte.solde,
    stockHuile: huile?.solde ?? 0,
    depose: huile?.depose ?? 0,
    retire: huile?.retire ?? 0,
    lignes: compte.lignes,
    voyages,
    factures,
    avances,
    resteAPayer,
    avanceCreditee: Number(avances.reduce((s, a) => s + a.reste, 0).toFixed(3)),
    avanceDisponible: avanceDisponible(tiersId),
    huilerie: b.nom,
    logo: b.logo,
  });
}

const CLES_SANS_PORTAIL = ['oliva.portail.tokens', 'oliva.audit', 'oliva.utilisateurs', 'oliva.numeros', 'oliva.branding'];
let republicationEnCours = false;
surEcriture(async (cles) => {
  if (republicationEnCours || cles.every((c) => CLES_SANS_PORTAIL.includes(c))) return;
  republicationEnCours = true;
  try {
    for (const id of tiersAvecPortail()) await publierCompte(id);
  } finally {
    republicationEnCours = false;
  }
});



export async function fetchComptesTiers() {
  const actifs = new Set(read().map((r) => r.tiersId));
  readContacts().forEach((c) => Number(c.soldeDepart) && actifs.add(c.id));
  const fin = readFin();
  fin.reglements.forEach((r) => r.tiersId && actifs.add(r.tiersId));
  fin.mouvements.forEach((m) => m.tiersId && actifs.add(m.tiersId));
  const comptes = await Promise.all([...actifs].filter(Boolean).map((id) => fetchCompteTiers(id)));
  return comptes.sort((a, b) => b.solde - a.solde);
}

// Calcul PUR de l'imputation d'un versement sur les réceptions impayées du tiers,
// les plus anciennes d'abord. AUCUNE écriture : les patchs partent dans la commande
// serveur et ne sont appliqués au cache qu'après confirmation (audit C02).
// Une réception intégralement couverte passe `regle: true` ; le reliquat trop faible
// est imputé partiellement sur la réception suivante, qui reste non soldée avec un
// reste à payer ; ce qui dépasse toutes les réceptions reste un solde créditeur.
// Le versement a déjà produit son unique écriture de trésorerie : on ne fait que
// l'affecter, aucun second mouvement de caisse n'est généré ici.
// `avanceImputee` n'est alimenté que si le versement est enregistré comme acompte, car
// `avanceDisponible()` le lit pour calculer le pool d'avances fournisseur ; les règlements
// ordinaires utilisent `reglePartiel`, pour ne pas vider une avance qui n'existe pas.
function calculerImputation({ tiersId, parcours, montant, mode, date, surAvance }) {
  const champ = surAvance ? 'avanceImputee' : 'reglePartiel';
  const cibles = read()
    .filter((r) => r.tiersId === tiersId && r.parcours === parcours && etatPaiement(r).code === 'impaye')
    .sort((a, b) => (a.date === b.date ? (a.id < b.id ? -1 : 1) : a.date < b.date ? -1 : 1));
  let reste = Number(montant) || 0;
  const patchs = {};
  const soldees = [];
  let partielle = null;
  for (const r of cibles) {
    if (reste <= 0.0005) break;
    const du = Number((decompte(r).montant - dejaCouvert(r)).toFixed(3));
    if (du <= 0.0005) continue;
    const pris = Number(Math.min(reste, du).toFixed(3));
    const couverte = pris >= du - 0.0005;
    patchs[r.id] = {
      [champ]: Number((Number(r[champ] || 0) + pris).toFixed(3)),
      ...(couverte ? { regle: true, regleDate: date, regleMode: mode, regleRef: '@ajout:0' } : {}),
    };
    if (couverte) soldees.push({ id: r.id, montant: pris });
    else partielle = { id: r.id, montant: pris, reste: Number((du - pris).toFixed(3)) };
    reste = Number((reste - pris).toFixed(3));
  }
  return { patchs, soldees, partielle, credit: Number(Math.max(0, reste).toFixed(3)) };
}

// Opérations liées à envoyer au serveur (vide si rien à imputer).
const lieesImputation = (patchs) =>
  Object.keys(patchs).length ? [cleLiee(KEY, Object.entries(patchs).map(([id, champs]) => opMaj(id, champs)))] : [];

// Application au cache local après confirmation : la référence provisoire `@ajout:0`
// est remplacée par l'identifiant réellement attribué par le serveur.
const appliquerImputation = (patchs, refReelle) => {
  if (!Object.keys(patchs).length) return;
  const resolus = Object.fromEntries(
    Object.entries(patchs).map(([id, champs]) => [
      id,
      champs.regleRef === '@ajout:0' ? { ...champs, regleRef: refReelle ?? null } : champs,
    ])
  );
  patcherItems(KEY, resolus);
  Object.keys(resolus).forEach((id) => republierLot(id));
};

// Résumé lisible de l'imputation, porté sur les reçus imprimables.
export const resumeImputation = (im) => {
  if (!im) return '—';
  const parts = [
    im.soldees?.length ? `${im.soldees.length} bon(s) soldé(s) : ${im.soldees.map((s) => s.id).join(', ')}` : null,
    im.partielle ? `${im.partielle.id} partiellement réglé — reste ${im.partielle.reste.toFixed(3)} TND` : null,
    im.credit > 0 ? `${im.credit.toFixed(3)} TND porté en solde créditeur` : null,
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : 'Aucun bon impayé — versement porté en solde créditeur';
};

// Règlement / avance sur compte courant tiers. Montant totalement libre : solde
// complet, paiement partiel ou avance supérieure au solde. L'écriture de caisse et
// l'affectation aux bons partent dans UNE SEULE commande transactionnelle.
export async function enregistrerPaiementTiers({ date, tiersId, sens, montant, mode, compteId, piece, notes }) {
  const m = Number(montant) || 0;
  if (!tiersId) return { error: 'Sélectionnez le contact.' };
  if (m <= 0) return { error: 'Saisissez un montant valide.' };

  const compte = await fetchCompteTiers(tiersId);
  const nom = compte.nom;
  const jour = date || new Date().toISOString().slice(0, 10);
  const entree = sens === 'entree';
  const avance = entree ? m > Math.max(0, -compte.solde) : m > Math.max(0, compte.solde);
  const imputation = calculerImputation({
    tiersId,
    parcours: entree ? 'client' : 'fournisseur',
    montant: m,
    mode: mode || 'Espèces',
    date: jour,
    surAvance: entree ? false : avance,
  });

  const ligne = entree
    ? {
        date: jour, type: 'Alimentation', compteId, libelle: `Encaissement ${nom}`,
        piece: piece || '', montant: m, tiersId, notes: notes || '',
      }
    : {
        date: jour, categorie: 'Tiers', beneficiaire: nom, tiersId, notes: notes || '',
        piece: piece || '', mode: mode || 'Espèces', compteId, montant: m,
        acompte: avance, statut: 'Payé',
      };
  const res = await envoyerCommande('paiement_tiers', {
    resume: `${entree ? 'Encaissement' : 'Règlement'} ${nom} — ${m.toFixed(3)} TND`,
    ajouts: [{ bucket: entree ? 'mouvements' : 'reglements', ligne }],
    liees: lieesImputation(imputation.patchs),
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const id = res.ids?.[0] ?? null;
  appliquerImputation(imputation.patchs, id);
  return { error: null, row: { ...ligne, id }, avance, imputation };
}

// Les ventes se font exclusivement depuis les cuves physiques (voir enregistrerVente) :
// la part de bonus vendue est calculée automatiquement et valorisée au prix de vente réel.

// Traçabilité : quels lots ont alimenté chaque cuve, avec les quantités versées.
export async function fetchTracabiliteCuves() {
  const map = {};
  read().forEach((r) => {
    const lignes = r.cuves?.length
      ? r.cuves
      : r.cuveId && r.huileExtraite
        ? [{ cuveId: r.cuveId, kg: r.huileExtraite }]
        : [];
    const totalVerse = lignes.reduce((s, l) => s + (Number(l.kg) || 0), 0);
    lignes.forEach((l) => {
      const partRetenue =
        totalVerse > 0 ? Number(((Number(r.retenueHuilerie) || 0) * ((Number(l.kg) || 0) / totalVerse)).toFixed(3)) : 0;
      (map[l.cuveId] ??= []).push({
        lot: r.id,
        date: r.date,
        tiers: nomTiers(r.tiersId),
        parcours: r.parcours,
        kg: Number(l.kg) || 0,
        retenue: partRetenue,
      });
    });
  });
  return map;
}

// --- Relevé de compte d'huile par cuve : mouvements chronologiques + PMP recalculé ---
export async function fetchReleveCuve(cuveId) {
  const cuve = readCuves().find((c) => c.id === cuveId);
  if (!cuve) return { error: 'Cuve introuvable.' };
  const nomCuve = (id) => readCuves().find((c) => c.id === id)?.nom ?? id;
  const evts = [];

  // Entrées de trituration : l'huile du client entre à coût matière nul, l'achat à son coût réel.
  read().forEach((r) => {
    const parts = r.cuves?.length
      ? r.cuves
      : r.cuveId && r.huileExtraite
        ? [{ cuveId: r.cuveId, kg: r.huileExtraite }]
        : [];
    const d = decompte(r);
    parts
      .filter((l) => l.cuveId === cuveId && Number(l.kg) > 0)
      .forEach((l) => {
        evts.push({
          date: r.date,
          rang: 1,
          type: r.parcours === 'client' ? 'Entrée trituration — dépôt client' : 'Entrée trituration — achat olives',
          piece: r.id,
          tiers: nomTiers(r.tiersId),
          sens: 'entree',
          kg: Number(l.kg),
          pu: r.parcours === 'client' ? 0 : d.huile > 0 ? Number((d.montant / d.huile).toFixed(3)) : 0,
        });
      });
  });

  readAchatsHuile().forEach((a) => {
    const kg = Number(a.kg) || 0;
    if (kg <= 0 || a.cuveId !== cuveId) return;
    if (a.type === 'externe')
      evts.push({ date: a.date, rang: 2, type: 'Achat d’huile externe', piece: a.id, tiers: nomTiers(a.tiersId), sens: 'entree', kg, pu: Number(a.prixKg) || 0 });
    else if (a.destination === 'transferer')
      evts.push({ date: a.date, rang: 2, type: 'Rachat client — transfert sortant', piece: a.id, tiers: nomTiers(a.tiersId), sens: 'sortie', kg, pu: Number(a.prixKg) || 0 });
  });

  readTransferts()
    .filter((t) => t.statut === 'Terminé' && Number(t.qteReelle) > 0)
    .forEach((t) => {
      const commun = { date: t.valideLe || t.date, rang: 3, piece: t.numero, tiers: '', kg: Number(t.qteReelle), pu: Number(t.cmpSource) || 0 };
      if (t.sourceId === cuveId) evts.push({ ...commun, type: `Transfert sortant → ${nomCuve(t.cibleId)}`, sens: 'sortie' });
      if (t.cibleId === cuveId) evts.push({ ...commun, type: `Transfert entrant ← ${nomCuve(t.sourceId)}`, sens: 'entree' });
    });

  readRetraits()
    .filter((t) => t.cuveId === cuveId && Number(t.litres) > 0)
    .forEach((t) => {
      evts.push({
        date: t.date,
        rang: 4,
        type: t.motif === 'Rachat par l’huilerie' ? 'Rachat huile client' : 'Retrait client',
        piece: t.id,
        tiers: t.client ?? '',
        sens: 'sortie',
        kg: Number(t.litres),
        pu: null,
      });
    });

  readCond()
    .filter((x) => x.cuveId === cuveId && Number(x.kg) > 0)
    .forEach((x) => {
      evts.push({ date: x.date, rang: 5, type: `Conditionnement${x.denomination ? ` — ${x.denomination}` : ''}`, piece: x.id, tiers: '', sens: 'sortie', kg: Number(x.kg), pu: null });
    });

  readVentes().forEach((v) => {
    (v.cuves || [])
      .filter((l) => l.cuveId === cuveId && Number(l.kg) > 0)
      .forEach((l) => {
        evts.push({ date: v.date, rang: 6, type: 'Vente en vrac', piece: v.id, tiers: v.client ?? '', sens: 'sortie', kg: Number(l.kg), pu: Number(v.prixKg) || null });
      });
  });

  evts.sort((a, b) => (a.date === b.date ? a.rang - b.rang : a.date < b.date ? -1 : 1));

  // Solde d'ouverture : stock déjà présent dans la cuve avant le premier mouvement
  // traçable (mise en service, inventaire, campagnes antérieures à la traçabilité).
  const volumeTrace = Number(evts.reduce((s, e) => s + (e.sens === 'entree' ? e.kg : -e.kg), 0).toFixed(3));
  const ouverture = Number((Number(cuve.volume) - volumeTrace).toFixed(3));
  if (ouverture >= 0.001)
    evts.unshift({
      date: evts[0]?.date ?? new Date().toISOString().slice(0, 10),
      rang: -1,
      type: 'Solde d’ouverture — stock antérieur à la traçabilité détaillée',
      piece: '—',
      tiers: '',
      sens: 'entree',
      kg: ouverture,
      pu: Number(cuve.cmp) || 0,
      ouverture: true,
    });

  // Reconstitution mouvement par mouvement : une sortie part au PMP courant, qui reste inchangé.
  let volume = 0;
  let valeur = 0;
  const lignes = evts.map((e, i) => {
    const pmpAvant = volume > 0 ? valeur / volume : 0;
    if (e.sens === 'entree') {
      valeur = Number((valeur + e.kg * (Number(e.pu) || 0)).toFixed(3));
      volume = Number((volume + e.kg).toFixed(3));
    } else {
      valeur = Number((valeur - e.kg * pmpAvant).toFixed(3));
      volume = Number((volume - e.kg).toFixed(3));
    }
    return {
      ...e,
      id: e.ouverture ? 'ouverture' : `${e.piece}-${i}`,
      pu: e.pu ?? Number(pmpAvant.toFixed(3)),
      solde: volume,
      valeur,
      pmp: volume > 0 ? Number((valeur / volume).toFixed(3)) : 0,
    };
  });

  // Le relevé doit toujours se terminer sur le volume physique réel de la cuve.
  const ecart = Number((Number(cuve.volume) - volume).toFixed(3));
  if (Math.abs(ecart) >= 0.001) {
    const pmp = volume > 0 ? valeur / volume : Number(cuve.cmp) || 0;
    valeur = Number(Math.max(0, valeur + ecart * pmp).toFixed(3));
    volume = Number(Number(cuve.volume).toFixed(3));
    lignes.push({
      id: 'ajustement',
      date: new Date().toISOString().slice(0, 10),
      type: 'Ajustement — mouvements non détaillés',
      piece: '—',
      tiers: '',
      sens: ecart > 0 ? 'entree' : 'sortie',
      kg: Math.abs(ecart),
      pu: Number(pmp.toFixed(3)),
      solde: volume,
      valeur,
      pmp: volume > 0 ? Number((valeur / volume).toFixed(3)) : 0,
      ajustement: true,
    });
  }

  return { error: null, cuve, lignes, soldeFinal: volume, valeurFinale: valeur, cmpReel: Number(cuve.cmp) || 0, ecart, ouverture: ouverture >= 0.001 ? ouverture : 0 };
}

// --- Écart de rendement Foss vs réel (analyse de rentabilité, admin) ---

export const huileTheorique = (r) =>
  r.mode === 'foss' && r.foss ? Number((decompte(r).poidsNet * (Number(r.foss) / 100)).toFixed(3)) : 0;

export const ecartRendement = (r) => {
  const theo = huileTheorique(r);
  if (!theo || !r.huileExtraite) return null;
  return Number((Number(r.huileExtraite) - theo).toFixed(3));
};

export async function fetchPerformanceFoss(du = '', au = '') {
  const dansP = (d) => (!du || d >= du) && (!au || d <= au);
  const lots = read().filter((r) => ecartRendement(r) !== null && dansP(r.date));
  const bonus = lots.filter((r) => ecartRendement(r) > 0).reduce((s, r) => s + ecartRendement(r), 0);
  const malus = lots.filter((r) => ecartRendement(r) < 0).reduce((s, r) => s + ecartRendement(r), 0);
  const details = lots
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .map((r) => {
      const c = decompte(r);
      const ecart = ecartRendement(r);
      const huile = Number(r.huileExtraite) || 0;
      const of = r.ofId ? readOfs().find((o) => o.id === r.ofId) : null;
      return {
        id: r.id, date: r.date, tiers: nomTiers(r.tiersId), qualite: labelQualite(r.qualite),
        olives: c.poidsNet, foss: Number(r.foss) || 0,
        reel: c.poidsNet > 0 ? Number(((huile / c.poidsNet) * 100).toFixed(2)) : 0,
        theorique: huileTheorique(r), huile, ecart,
        ecartTnd: Number((ecart * (Number(r.prixBaseHuile) || prixReference(familleLot(r)))).toFixed(3)),
        paye: c.montant, coutKg: huile > 0 ? Number((c.montant / huile).toFixed(3)) : null,
        mixe: Boolean(of && of.lots.length > 1), of: of?.numero ?? null,
      };
    });
  return {
    lots: lots.length,
    bonus: Number(bonus.toFixed(3)),
    malus: Number(malus.toFixed(3)),
    net: Number((bonus + malus).toFixed(3)),
    theorique: Number(lots.reduce((s, r) => s + huileTheorique(r), 0).toFixed(3)),
    reel: Number(lots.reduce((s, r) => s + Number(r.huileExtraite || 0), 0).toFixed(3)),
    details,
  };
}

// Lots d'un fournisseur : rendement, coût de revient, traçabilité OF (lot mixé).
export async function fetchLotsFournisseur(tiersId, du = '', au = '') {
  const dansP = (d) => (!du || d >= du) && (!au || d <= au);
  return read()
    .filter((r) => r.tiersId === tiersId && r.parcours === 'fournisseur' && dansP(r.date))
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .map((r) => {
      const c = decompte(r);
      const huile = Number(r.huileExtraite) || 0;
      const of = r.ofId ? readOfs().find((o) => o.id === r.ofId) : null;
      const autres = of ? of.lots.filter((id) => id !== r.id).length : 0;
      const coutKg = huile > 0 && !c.enAttenteRendement ? c.montant / huile : null;
      return {
        id: r.id, date: r.date, qualite: labelQualite(r.qualite), mode: labelMode(r.mode), statut: r.statut,
        olives: c.poidsNet, paye: c.enAttenteRendement ? null : c.montant, huile,
        rendement: huile > 0 && c.poidsNet > 0 ? Number(((huile / c.poidsNet) * 100).toFixed(2)) : null,
        coutKg: coutKg != null ? Number(coutKg.toFixed(3)) : null,
        prixRef: prixReference(familleLot(r)),
        // Marge unitaire : ce que rapporte (ou coûte) chaque kilo par rapport au cours de référence.
        ecartKgHuile: coutKg != null ? Number((prixReference(familleLot(r)) - coutKg).toFixed(3)) : null,
        ecartKgOlives:
          coutKg != null && c.poidsNet > 0
            ? Number(((prixReference(familleLot(r)) * huile - c.montant) / c.poidsNet).toFixed(4))
            : null,
        ecartMarche: coutKg != null ? Number(((prixReference(familleLot(r)) - coutKg) * huile).toFixed(3)) : null,
        mixe: autres > 0, of: of?.numero ?? null, autresLots: autres,
      };
    });
}

// --- Achats d'huile : négoce externe et rachat d'huile client ---

const AH_KEY = 'oliva.achats_huile';
const readAchatsHuile = () => JSON.parse(localStorage.getItem(AH_KEY) ?? '[]');
const writeAchatsHuile = (v) => localStorage.setItem(AH_KEY, JSON.stringify(v));

export async function fetchAchatsHuile() {
  return readAchatsHuile();
}

const nextAchatId = () =>
  `AH-${readAchatsHuile().reduce((m, a) => Math.max(m, Number(String(a.id).split('-')[1]) || 0), 3000) + 1}`;

export async function enregistrerAchatHuileExterne({ date, tiersId, qualite, kg, prixKg, cuveId, override = false, utilisateur }) {
  const q = Number(kg) || 0;
  const prix = Number(prixKg) || 0;
  if (!tiersId) return { error: 'Sélectionnez le fournisseur.' };
  if (q <= 0) return { error: 'Saisissez la quantité achetée (kg).' };
  if (prix <= 0) return { error: 'Saisissez le prix unitaire négocié.' };

  const cuves = readCuves();
  const cuve = cuves.find((c) => c.id === cuveId);
  if (!cuve) return { error: 'Sélectionnez la cuve de destination.' };

  const famille = QUALITES.find((x) => x.id === qualite)?.famille ?? 'noble';
  if (famille !== cuve.famille) {
    if (!override)
      return {
        error:
          famille === 'lampante'
            ? `BLOCAGE SÉCURITÉ : huile LAMPANTE interdite dans la cuve noble « ${cuve.nom} ».`
            : `BLOCAGE SÉCURITÉ : huile NOBLE interdite dans la cuve lampante « ${cuve.nom} ».`,
      };
    journalOverride(utilisateur, `achat huile ${famille} versé dans la cuve ${cuve.nom} (${q} kg)`);
  }
  if (q > cuve.capacite - cuve.volume)
    return { error: `Capacité insuffisante dans « ${cuve.nom} » : reste ${cuve.capacite - cuve.volume} ${cuve.unite}.` };

  const nouveau = Number((cuve.volume + q).toFixed(3));
  const cmp = cmpApres(cuve, q, prix);
  writeCuves(cuves.map((c) => (c.id === cuve.id ? { ...c, volume: nouveau, cmp } : c)));

  const row = {
    id: nextAchatId(),
    date,
    type: 'externe',
    tiersId,
    qualite,
    kg: q,
    prixKg: prix,
    montant: Number((q * prix).toFixed(3)),
    cuveId: cuve.id,
    cuveNom: cuve.nom,
    compensation: false,
    notes: `Achat huile externe — ${cuve.nom}`,
  };
  writeAchatsHuile([row, ...readAchatsHuile()]);
  return { error: null, row };
}

export async function enregistrerAchatHuileClient({
  date, tiersId, kg, prixKg, destination, cuveSourceId, cuveDestId, compensation,
}) {
  const q = Number(kg) || 0;
  const prix = Number(prixKg) || 0;
  if (!tiersId) return { error: 'Sélectionnez le client.' };
  if (q <= 0) return { error: 'Saisissez la quantité rachetée (kg).' };
  if (prix <= 0) return { error: 'Saisissez le prix unitaire négocié.' };

  const nom = nomTiers(tiersId);
  const releves = await fetchRelevesClients();
  const fiche = releves.find((r) => r.nom === nom);
  if (!fiche || fiche.solde < q)
    return { error: `Stock d'huile client insuffisant : ${fiche ? fiche.solde : 0} kg disponibles.` };

  const cuves = readCuves();
  const source = cuves.find((c) => c.id === cuveSourceId);
  if (!source) return { error: 'Sélectionnez la cuve où se trouve l’huile du client.' };
  if (!Number.isFinite(q) || !Number.isFinite(prix)) return { error: 'Quantité ou prix invalide.' };
  if (q > source.volume) return { error: 'Stock physique insuffisant dans la cuve choisie.' };
  const droits = repartirDiminutionClients(cuves, source, q, droitsClientParCuve(fiche));
  if (droits.error) return droits;
  const avantDe = (id) => cuves.find((x) => x.id === id);

  if (destination === 'transferer') {
    const dest = cuves.find((c) => c.id === cuveDestId);
    if (!dest || dest.virtuelle || dest.verrouillee) return { error: 'Sélectionnez une cuve physique non verrouillée.' };
    if (dest.id === source.id) return { error: 'Choisissez une cuve de destination différente.' };
    if (dest.famille !== source.famille)
      return { error: `BLOCAGE SÉCURITÉ : transfert croisé interdit entre « ${source.nom} » et « ${dest.nom} ».` };
    if (q > dest.capacite - dest.volume)
      return { error: `Capacité insuffisante dans « ${dest.nom} » : reste ${dest.capacite - dest.volume} ${dest.unite}.` };
    if (q > source.volume) return { error: `Volume insuffisant dans « ${source.nom} ».` };
    // L'huile qui entre vaut le prix de rachat pour la part dont les droits s'éteignent
    // dans la cuve de départ, et le coût de cette cuve pour la part déjà possédée.
    const prisSource = droits.prises[source.id] || 0;
    const prixEntree = (Math.min(prisSource, q) * prix + Math.max(0, q - prisSource) * (source.cmp || 0)) / q;
    writeCuves(
      droits.cuves.map((c) => {
        const avant = avantDe(c.id);
        const pris = droits.prises[c.id] || 0;
        if (c.id === dest.id) {
          const apresRachat = pris > 0
            ? { ...avant, cmp: cmpApres(avant, pris, prix), volumeClients: Math.max(0, (avant.volumeClients || 0) - pris) }
            : avant;
          return { ...c, volume: Number((c.volume + q).toFixed(3)), cmp: cmpApres(apresRachat, q, prixEntree) };
        }
        if (c.id === source.id) {
          const reste = Math.max(0, pris - q); // part rachetée qui reste sur place
          const base = reste > 0 ? { ...c, cmp: cmpApres(avant, reste, prix) } : c;
          return { ...base, volume: Number((c.volume - q).toFixed(3)) };
        }
        return pris > 0 ? { ...c, cmp: cmpApres(avant, pris, prix) } : c;
      })
    );
  } else {
    // Changement de propriété : le physique ne bouge pas. Le stock propre augmente là où
    // les droits du client s'éteignent : le CMP y est recalculé au prix de rachat.
    writeCuves(
      droits.cuves.map((c) => (droits.prises[c.id]
        ? { ...c, cmp: cmpApres(avantDe(c.id), droits.prises[c.id], prix) }
        : c))
    );
  }

  // Sortie du stock virtuel du client (compte huile).
  const retraits = readRetraits();
  writeRetraits([
    {
      id: `T-${Date.now()}`,
      date,
      client: nom,
      cuveId: source.id,
      cuve: source.nom,
      litres: q,
      droits: droits.prises,
      motif: 'Rachat par l’huilerie',
    },
    ...retraits,
  ]);

  const montant = Number((q * prix).toFixed(3));
  const compte = await fetchCompteTiers(tiersId);
  const dette = compte.solde < 0 ? -compte.solde : 0;
  const compense = compensation && dette > 0 ? Number(Math.min(dette, montant).toFixed(3)) : 0;

  const row = {
    id: nextAchatId(),
    date,
    type: 'client',
    tiersId,
    qualite: source.famille === 'lampante' ? 'lampante' : 'vierge',
    kg: q,
    prixKg: prix,
    montant,
    cuveId: source.id,
    cuveNom: destination === 'transferer' ? `${source.nom} → ${cuves.find((c) => c.id === cuveDestId).nom}` : source.nom,
    destination,
    droits: droits.prises,
    compensation: compense > 0,
    compense,
    resteAPayer: Number((montant - compense).toFixed(3)),
    notes:
      compense > 0
        ? `Rachat huile client — compensation automatique de ${compense.toFixed(3)} TND sur dette existante`
        : 'Rachat huile client — règlement séparé',
  };
  writeAchatsHuile([row, ...readAchatsHuile()]);
  return { error: null, row, dette, compense, avertissement: avertissementRattachement(source, droits.prises, cuves) };
}

// --- Ressources humaines : pointage & paie ---

export const TYPES_TRAVAIL = ['Shift 12h', 'Demi-journée', 'Mensuel'];

// Montant par défaut d'un pointage d'après les salaires de la fiche employé.
export const salaireDefaut = (employe, typeTravail) => {
  const jour = Number(employe?.salaireJour) || 0;
  const mois = Number(employe?.salaireMois) || 0;
  if (typeTravail === 'Mensuel') return Number(mois.toFixed(3));
  if (typeTravail === 'Demi-journée') return Number((jour / 2).toFixed(3));
  return Number(jour.toFixed(3));
};
export const TYPES_CONTRAT = ['Mensuel', 'Saisonnier (Shift 12h)', 'Mixte (Mensuel/Saisonnier)'];

const PTG_KEY = 'oliva.pointages';
const readPointages = () => JSON.parse(localStorage.getItem(PTG_KEY) ?? '[]');
// C02 : même confirmation immédiate et conservation de brouillon que store.js.
// Un seul envoi à la fois sur ce poste ; les conflits entre postes restent traités
// par la version attendue du store serveur (409), sans fusion ni réessai aveugle.
let pointageEnCours = false;
const writePointages = async (v) => {
  if (pointageEnCours) return { error: 'Un enregistrement de pointage est déjà en cours. Attendez son résultat.' };
  if (!donneesPretes())
    return { error: 'Base serveur non chargée : pointage non envoyé. Rechargez les données avant de valider.' };
  pointageEnCours = true;
  try {
    const avant = localStorage.getItem(PTG_KEY);
    localStorage.setItem(PTG_KEY, JSON.stringify(v));
    await publierMaintenant(PTG_KEY, avant);
    return { error: null };
  } catch (e) {
    // Une réponse perdue peut suivre un commit : ne jamais annoncer « rien écrit ».
    // publierMaintenant conserve le brouillon, restaure le cache et bloque la file.
    return { error: `Pointage NON CONFIRMÉ : ${String(e.message || e)}. Vérifiez la base avant de ressaisir.` };
  } finally {
    pointageEnCours = false;
  }
};

export async function fetchPersonnel() {
  return readContacts().filter((c) => c.type === 'personnel');
}

export async function fetchPointages() {
  return readPointages();
}

export async function enregistrerPointage({ date, tiersId, typeTravail, montant, notes }) {
  const m = Number(montant) || 0;
  if (!tiersId) return { error: 'Sélectionnez l’employé.' };
  if (!TYPES_TRAVAIL.includes(typeTravail)) return { error: 'Sélectionnez le type de travail.' };
  if (m <= 0) return { error: 'Saisissez le montant à créditer (TND).' };

  const rows = readPointages();
  const row = {
    id: `P-${rows.reduce((mx, r) => Math.max(mx, Number(String(r.id).split('-')[1]) || 0), 4000) + 1}`,
    date,
    tiersId,
    typeTravail,
    montant: Number(m.toFixed(3)),
    notes: String(notes || '').trim(),
  };
  const confirmation = await writePointages([row, ...rows]);
  if (confirmation.error) return confirmation;
  return { error: null, row };
}

export const pointagesTiers = (tiersId) => readPointages().filter((p) => p.tiersId === tiersId);

// Saisie en masse : une seule validation pour toute la journée.
export async function validerJournee({ date, lignes }) {
  if (!date) return { error: 'Sélectionnez la date du pointage.' };
  const presents = (lignes || []).filter((l) => l.present);
  if (presents.length === 0) return { error: 'Cochez au moins un employé présent.' };

  const rows = readPointages();
  const dejaPointe = presents.filter((l) => rows.some((r) => r.date === date && r.tiersId === l.tiersId));
  if (dejaPointe.length > 0)
    return { error: `${nomTiers(dejaPointe[0].tiersId)} est déjà pointé le ${date}.` };

  const invalide = presents.find((l) => !(Number(l.montant) > 0) || !TYPES_TRAVAIL.includes(l.typeTravail));
  if (invalide)
    return { error: `Montant ou type de travail manquant pour ${nomTiers(invalide.tiersId)}.` };

  let seq = rows.reduce((mx, r) => Math.max(mx, Number(String(r.id).split('-')[1]) || 0), 4000);
  const nouveaux = presents.map((l) => {
    seq += 1;
    return {
      id: `P-${seq}`,
      date,
      tiersId: l.tiersId,
      typeTravail: l.typeTravail,
      montant: Number(Number(l.montant).toFixed(3)),
      notes: String(l.notes || '').trim(),
    };
  });
  const confirmation = await writePointages([...nouveaux.reverse(), ...rows]);
  if (confirmation.error) return confirmation;
  return {
    error: null,
    rows: nouveaux,
    total: Number(nouveaux.reduce((s, r) => s + r.montant, 0).toFixed(3)),
  };
}

export const pointagesDuJour = (date) => readPointages().filter((p) => p.date === date);

// --- Super-pouvoirs Administrateur : correction / suppression avec cascade + audit ---

const AUDIT_KEY = 'oliva.audit';
const readAudit = () => JSON.parse(localStorage.getItem(AUDIT_KEY) ?? '[]');
const writeAudit = (v) => localStorage.setItem(AUDIT_KEY, JSON.stringify(v));

export async function fetchAudit() {
  return readAudit();
}

export function tracer({ action, entite, refId, resume, utilisateur, avant, apres }) {
  const rows = readAudit();
  writeAudit(
    [
      {
        id: `A-${Date.now()}-${rows.length + 1}`,
        horodatage: new Date().toISOString(),
        utilisateur: utilisateur || 'Administrateur',
        action,
        entite,
        refId,
        resume,
        avant: avant ?? null,
        apres: apres ?? null,
      },
      ...rows,
    ].slice(0, 500)
  );
}

const majCuveVolume = (cuveId, delta, deltaClients = 0) => {
  const cuves = readCuves();
  writeCuves(
    cuves.map((c) =>
      c.id === cuveId
        ? { ...c, volume: Number(Math.max(0, c.volume + delta).toFixed(3)), volumeClients: Number(Math.max(0, (c.volumeClients || 0) + deltaClients).toFixed(3)) }
        : c
    )
  );
};

// -- Réceptions --
export async function adminModifierReception(id, patch, utilisateur) {
  const rows = read();
  const avant = rows.find((r) => r.id === id);
  if (!avant) return { error: 'Réception introuvable.' };
  const apres = { ...avant, ...patch };
  write(rows.map((r) => (r.id === id ? apres : r)));
  await republierLot(id);
  tracer({ action: 'Modification', entite: 'Réception', refId: id, resume: `Réception ${id} corrigée`, utilisateur, avant, apres });
  return { error: null, row: apres };
}

export async function adminSupprimerReception(id, utilisateur) {
  const rows = read();
  const r = rows.find((x) => x.id === id);
  if (!r) return { error: 'Réception introuvable.' };

  // Sécurité de contre-passation : un bon payé ne peut pas être annulé tant que
  // l'écriture financière rattachée n'a pas été annulée.
  const fin = readFin();
  const lies = [
    ...fin.reglements.filter((x) => x.piece === id || x.id === r.regleRef),
    ...fin.mouvements.filter((x) => x.piece === id || x.id === r.regleRef),
  ];
  if (r.regle === true || lies.length > 0) {
    const detail = lies[0];
    return {
      error: `Annulation interdite : un règlement financier est rattaché à ${id}${
        detail ? ` (pièce ${detail.piece || detail.id}, ${Number(detail.montant || 0).toFixed(3)} TND)` : ''
      }. Annulez d’abord le paiement dans Caisse & Finances, puis recommencez.`,
    };
  }

  // Révocation des impacts physiques : huile versée en cuve (+ dette client) + retenue bonus.
  const retenue = Number(r.retenueHuilerie) || 0;
  const totalVerse = (r.cuves || []).reduce((s, l) => s + (Number(l.kg) || 0), 0);
  (r.cuves || []).forEach((l) => {
    const kg = Number(l.kg) || 0;
    const partClient = r.parcours === 'client' && totalVerse > 0 ? (kg - retenue * (kg / totalVerse)) : 0;
    majCuveVolume(l.cuveId, -kg, -Math.max(0, partClient));
  });
  if (retenue > 0) {
    const b = readBonus();
    const lampante = familleLot(r) === 'lampante';
    writeBonus({
      ...b,
      volume: Number(Math.max(0, b.volume - retenue).toFixed(3)),
      noble: Number(Math.max(0, b.noble - (lampante ? 0 : retenue)).toFixed(3)),
      lampante: Number(Math.max(0, b.lampante - (lampante ? retenue : 0)).toFixed(3)),
      mouvements: [
        {
          id: `B-${Date.now()}`,
          date: new Date().toISOString().slice(0, 10),
          lots: [id],
          famille: lampante ? 'lampante' : 'noble',
          kg: -retenue,
          valeur: 0,
          motif: `Annulation de la retenue — suppression de la réception ${id}`,
        },
        ...b.mouvements,
      ].slice(0, 200),
    });
  }

  // Soft delete : le bon reste en base avec le statut « Annulé » (piste d'audit).
  const annule = { ...r, statut: 'Annulé', statutAvant: r.statut, annuleLe: new Date().toISOString(), annulePar: utilisateur ?? null };
  write(rows.map((x) => (x.id === id ? annule : x)));
  tracer({
    action: 'Annulation',
    entite: 'Réception',
    refId: id,
    resume: `Réception ${id} annulée (${nomTiers(r.tiersId)}) — conservée en historique, impacts cuves et retenue annulés`,
    utilisateur,
    avant: r,
    apres: annule,
  });
  return { error: null };
}

// -- Pointages --
export async function adminModifierPointage(id, patch, utilisateur) {
  const rows = readPointages();
  const avant = rows.find((p) => p.id === id);
  if (!avant) return { error: 'Pointage introuvable.' };
  const apres = { ...avant, ...patch, montant: Number(patch.montant ?? avant.montant) || 0 };
  const confirmation = await writePointages(rows.map((p) => (p.id === id ? apres : p)));
  if (confirmation.error) return confirmation;
  tracer({ action: 'Modification', entite: 'Pointage', refId: id, resume: `Pointage ${id} corrigé`, utilisateur, avant, apres });
  return { error: null, row: apres };
}

export async function adminSupprimerPointage(id, utilisateur) {
  const rows = readPointages();
  const p = rows.find((x) => x.id === id);
  if (!p) return { error: 'Pointage introuvable.' };
  const confirmation = await writePointages(rows.filter((x) => x.id !== id));
  if (confirmation.error) return confirmation;
  tracer({
    action: 'Suppression',
    entite: 'Pointage',
    refId: id,
    resume: `Pointage ${id} supprimé — ${p.montant.toFixed(3)} TND retirés du compte de ${nomTiers(p.tiersId)}`,
    utilisateur,
    avant: p,
  });
  return { error: null };
}

// -- Journal de caisse (mouvements) --
export async function adminModifierMouvement(id, patch, utilisateur) {
  const fin = readFin();
  const avant = fin.mouvements.find((m) => m.id === id);
  if (!avant) return { error: 'Mouvement introuvable.' };
  const champs = ligneFiltree(patch, CHAMPS_MOUVEMENT);
  if (champs.montant !== undefined) champs.montant = Number(champs.montant) || 0;
  const res = await envoyerCommande('mouvement.modifier', {
    resume: `Correction du mouvement ${id}`,
    maj: [{ bucket: 'mouvements', id, champs }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const apres = { ...avant, ...champs };
  tracer({ action: 'Modification', entite: 'Mouvement de caisse', refId: id, resume: `Mouvement ${id} corrigé`, utilisateur, avant, apres });
  return { error: null, row: apres };
}

export async function adminSupprimerMouvement(id, utilisateur) {
  const fin = readFin();
  const m = fin.mouvements.find((x) => x.id === id);
  if (!m) return { error: 'Mouvement introuvable.' };
  const res = await envoyerCommande('mouvement.supprimer', {
    resume: `Suppression du mouvement ${id} (${Number(m.montant).toFixed(3)} TND)`,
    suppressions: [{ bucket: 'mouvements', id }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  restaurerBons(res.receptions_restaurees);
  tracer({
    action: 'Suppression',
    entite: 'Mouvement de caisse',
    refId: id,
    resume: `${m.type} de ${m.montant.toFixed(3)} TND supprimée — solde de caisse recalculé${
      res.receptions_restaurees?.length ? ` · bon(s) repassé(s) NON SOLDÉ : ${res.receptions_restaurees.join(', ')}` : ''
    }`,
    utilisateur,
    avant: m,
  });
  return { error: null, receptions_restaurees: res.receptions_restaurees ?? [] };
}

// -- Règlements --
export async function adminModifierReglement(id, patch, utilisateur) {
  const fin = readFin();
  const avant = fin.reglements.find((r) => r.id === id);
  if (!avant) return { error: 'Règlement introuvable.' };
  const champs = ligneFiltree(patch, CHAMPS_REGLEMENT);
  if (champs.montant !== undefined) champs.montant = Number(champs.montant) || 0;
  const res = await envoyerCommande('reglement.modifier', {
    resume: `Correction du règlement ${id}`,
    maj: [{ bucket: 'reglements', id, champs }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const apres = { ...avant, ...champs };
  tracer({ action: 'Modification', entite: 'Règlement', refId: id, resume: `Règlement ${id} corrigé`, utilisateur, avant, apres });
  return { error: null, row: apres };
}

export async function adminSupprimerReglement(id, utilisateur) {
  const fin = readFin();
  const r = fin.reglements.find((x) => x.id === id);
  if (!r) return { error: 'Règlement introuvable.' };
  const res = await envoyerCommande('reglement.supprimer', {
    resume: `Suppression du règlement ${id} (${Number(r.montant).toFixed(3)} TND)`,
    suppressions: [{ bucket: 'reglements', id }],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  restaurerBons(res.receptions_restaurees);
  tracer({
    action: 'Suppression',
    entite: 'Règlement',
    refId: id,
    resume: `Règlement de ${r.montant.toFixed(3)} TND (${r.beneficiaire}) supprimé — dette du tiers rétablie${
      res.receptions_restaurees?.length ? ` · bon(s) repassé(s) NON SOLDÉ : ${res.receptions_restaurees.join(', ')}` : ''
    }`,
    utilisateur,
    avant: r,
  });
  return { error: null, receptions_restaurees: res.receptions_restaurees ?? [] };
}

// -- Ventes --
// C09 : la correction d'une vente et le recalage de son encaissement sont UNE SEULE
// opération serveur. Le total est recalculé par le serveur ; si l'encaissement de la
// vente ne peut pas être identifié avec certitude, la correction est refusée.
export async function adminModifierVente(id, patch, utilisateur) {
  const rows = readVentes();
  const avant = rows.find((v) => v.id === id);
  if (!avant) return { error: 'Vente introuvable.' };
  const champs = ligneFiltree(patch, CHAMPS_VENTE);
  ['kg', 'litres', 'unites', 'prixKg', 'prixUnitaire', 'emballages'].forEach((c) => {
    if (champs[c] !== undefined) champs[c] = Number(champs[c]) || 0;
  });
  if (!Object.keys(champs).length) return { error: 'Aucune correction à enregistrer.' };
  const res = await envoyerCommande('vente.modifier', {
    resume: `Correction de la vente ${id}`,
    liees: [cleLiee(VENTES_KEY, [opMaj(id, champs)])],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const total = res.vente?.total ?? (Number(avant.total) || 0);
  const apres = { ...avant, ...champs, total };
  patcherItems(VENTES_KEY, { [id]: { ...champs, total } });
  tracer({
    action: 'Modification',
    entite: 'Vente',
    refId: id,
    resume: `Vente ${id} corrigée — total ${Number(total).toFixed(3)} TND, encaissement recalé`,
    utilisateur,
    avant,
    apres,
  });
  return { error: null, row: apres };
}

export async function adminSupprimerVente(id, utilisateur) {
  const rows = readVentes();
  const v = rows.find((x) => x.id === id);
  if (!v) return { error: 'Vente introuvable.' };

  // UNE SEULE transaction serveur : retrait de l'encaissement, remise en stock et
  // suppression de la vente. Jamais de stock remis sans caisse corrigée, et l'inverse
  // n'est pas possible non plus (audit C02).
  const cuves = readCuves();
  const liees = [cleLiee('oliva.ventes', [{ op: 'supprimer_item', id }])];
  const patchsCuves = {};
  if (v.format === 'vrac') {
    (v.cuves || []).forEach((l) => {
      const c = cuves.find((x) => x.id === l.cuveId);
      if (!c) return;
      const base = patchsCuves[l.cuveId]?.volume ?? (Number(c.volume) || 0);
      patchsCuves[l.cuveId] = { volume: Number((base + (Number(l.kg) || 0)).toFixed(3)) };
    });
    if (Object.keys(patchsCuves).length)
      liees.push(cleLiee('oliva.cuves', Object.entries(patchsCuves).map(([cid, champs]) => opMaj(cid, champs))));
  }
  let patchPF = null;
  if (v.format !== 'vrac' && v.unites > 0) {
    const sku = readPF().find((x) => x.id === (v.sku ?? v.format));
    if (sku) {
      patchPF = { id: sku.id, champs: { stock: Number(sku.stock) + Number(v.unites) } };
      liees.push(cleLiee('oliva.produits_finis', [opMaj(sku.id, patchPF.champs)]));
    }
  }
  // C09 : l'encaissement est retrouvé par son LIEN IMMUABLE (`venteId`), avec le
  // numéro de bon de vente en repli pour les ventes antérieures. Si la ligne de
  // caisse n'est pas identifiée de façon certaine, le serveur REFUSE toute la
  // suppression — jamais de vente annulée avec un encaissement conservé.
  const comptant = Boolean(v.compteId) && Number(v.total) > 0;
  const suppressions = comptant
    ? [{ bucket: 'mouvements', venteId: v.id, ...(v.piece ? { piece: v.piece } : {}) }]
    : [];
  const res = await envoyerCommande('vente.supprimer', {
    resume: `Annulation de la vente ${id}`,
    suppressions,
    liees,
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };

  if (Object.keys(patchsCuves).length) patcherItems(CUVES_KEY, patchsCuves);
  if (patchPF) patcherItems(PF_KEY, { [patchPF.id]: patchPF.champs });
  patcherCache(VENTES_KEY, (liste) => liste.filter((x) => x.id !== id));
  tracer({
    action: 'Suppression',
    entite: 'Vente',
    refId: id,
    resume: `Vente ${id} annulée — huile/emballages remis en stock et encaissement retiré de la caisse`,
    utilisateur,
    avant: v,
  });
  return { error: null };
}

// -- Achats d'huile --
export async function adminModifierAchatHuile(id, patch, utilisateur) {
  const rows = readAchatsHuile();
  const avant = rows.find((a) => a.id === id);
  if (!avant) return { error: 'Achat introuvable.' };
  const prixKg = Number(patch.prixKg ?? avant.prixKg) || 0;
  const kg = Number(patch.kg ?? avant.kg) || 0;
  const apres = { ...avant, ...patch, kg, prixKg, montant: Number((kg * prixKg).toFixed(3)) };
  if (kg !== avant.kg) majCuveVolume(avant.cuveId, kg - avant.kg);
  writeAchatsHuile(rows.map((a) => (a.id === id ? apres : a)));
  tracer({ action: 'Modification', entite: 'Achat d’huile', refId: id, resume: `Achat ${id} corrigé`, utilisateur, avant, apres });
  return { error: null, row: apres };
}

export async function adminSupprimerAchatHuile(id, utilisateur) {
  const rows = readAchatsHuile();
  const a = rows.find((x) => x.id === id);
  if (!a) return { error: 'Achat introuvable.' };
  if (a.type === 'externe' || a.destination === 'transferer') majCuveVolume(a.cuveId, -(Number(a.kg) || 0));
  writeAchatsHuile(rows.filter((x) => x.id !== id));
  tracer({
    action: 'Suppression',
    entite: 'Achat d’huile',
    refId: id,
    resume: `Achat ${id} (${nomTiers(a.tiersId)}) supprimé — huile retirée de la cuve et dette annulée`,
    utilisateur,
    avant: a,
  });
  return { error: null };
}

// -- Conditionnements --
export async function adminSupprimerConditionnement(id, utilisateur) {
 const rows=readCond(),c=rows.find(x=>x.id===id);if(!c)return {error:'Conditionnement introuvable.'};
 const cuves=readCuves(),cuve=cuves.find(x=>x.id===c.cuveId);if(!cuve)return {error:'Cuve source introuvable.'};
 const formats=readFormats(),pf=readPF();
 const nextCuves=cuves.map(x=>x.id===c.cuveId?{...x,volume:Number((x.volume+c.kg).toFixed(3))}:x);
 const nextFmt=formats.map(f=>{const l=c.lignes.find(x=>x.formatId===f.id);return l?{...f,stock:f.stock+l.unites}:f;});
 const nextPF=pf.map(p=>{const l=c.lignes.find(x=>x.sku===p.id);return l?{...p,stock:p.stock-l.unites}:p;});
 const res=await envoyerCommande('stock.deconditionner',{resume:`Annulation ${id}`,liees:[
   cleLiee(CUVES_KEY,[opMaj(c.cuveId,{volume:nextCuves.find(x=>x.id===c.cuveId).volume})]),
   cleLiee(FMT_KEY,nextFmt.filter(f=>c.lignes.some(l=>l.formatId===f.id)).map(f=>opMaj(f.id,{stock:f.stock}))),
   cleLiee(PF_KEY,nextPF.filter(p=>c.lignes.some(l=>l.sku===p.id)).map(p=>opMaj(p.id,{stock:p.stock}))),
   cleLiee(COND_KEY,[{op:'supprimer_item',id}])
 ]});
 if(res.error)return {error:res.error,indetermine:res.indetermine};
 patcherCache(CUVES_KEY,()=>nextCuves);patcherCache(FMT_KEY,()=>nextFmt);patcherCache(PF_KEY,()=>nextPF);patcherCache(COND_KEY,()=>rows.filter(x=>x.id!==id));
 return {error:null};
}

// --- Rapprochement bancaire : import de relevé (CSV/Excel) et lettrage manuel ---
// Sécurité : aucune connexion API/scraping vers les banques. Import de fichier uniquement.

const RAPP_KEY = 'oliva.rapprochement';
const readRapp = () => JSON.parse(localStorage.getItem(RAPP_KEY) ?? '[]');
const writeRapp = (v) => localStorage.setItem(RAPP_KEY, JSON.stringify(v));

export async function fetchRapprochements() {
  return readRapp();
}

// Montant signé d'une opération vue depuis un compte : + crédit (entrée), − débit (sortie).
// Un transfert sortant (Banque → Coffre) est un DÉBIT du compte bancaire.
export function montantSigne(compteId, op) {
  const m = Number(op.montant) || 0;
  if (op.type === 'Alimentation') return op.compteId === compteId ? m : 0;
  if (op.type === 'Transfert') {
    if (op.compteCibleId === compteId && op.compteId !== compteId) return m;
    return -m;
  }
  return -m; // Dépense, règlement
}

// Solde réel d'un compte : initial + uniquement les opérations pointées sur le relevé.
export function soldeRapproche(compte, fin = readFin()) {
  const pointes = readRapp().filter((p) => p.compteId === compte.id);
  const signe = (ref) => {
    const mv = fin.mouvements.find((m) => m.id === ref);
    if (mv) return montantSigne(compte.id, mv);
    const rg = fin.reglements.find((r) => r.id === ref);
    return rg ? -rg.montant : 0;
  };
  return Number(((Number(compte.initial) || 0) + pointes.reduce((s, p) => s + signe(p.refErp), 0)).toFixed(3));
}

const norm = (v) => String(v ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
const joursEcart = (a, b) =>
  Math.abs((new Date(a).getTime() - new Date(b).getTime()) / 86400000) || 0;

// --- Initialisation de campagne (reprise des à-nouveaux) et lignes ignorées ---
const IGN_KEY = 'oliva.rapprochement_ignores';
const INIT_KEY = 'oliva.initialisation_campagne';
const readIgnores = () => JSON.parse(localStorage.getItem(IGN_KEY) ?? '[]');
const writeIgnores = (v) => localStorage.setItem(IGN_KEY, JSON.stringify(v));
const readInit = () => JSON.parse(localStorage.getItem(INIT_KEY) ?? 'null');

export async function fetchInitialisationCampagne() {
  return readInit();
}

export async function fetchIgnores() {
  return readIgnores();
}

// Reprise des à-nouveaux : le solde d'ouverture de chaque compte est forcé au solde
// réel constaté à la date de début de campagne, et tout l'exercice antérieur est
// neutralisé d'un bloc (écart théorique / banque ramené à 0,000).
export async function initialiserCampagneTresorerie({ date, soldes = [], utilisateur }) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(date ?? ''))) return { error: 'Saisissez la date de début de campagne.' };
  if (readInit()) return { error: 'Une initialisation est déjà en place : annulez-la avant d’en refaire une.' };
  const fin = readFin();
  const avant = fin.comptes.map((c) => ({ id: c.id, initial: Number(c.initial) || 0, dateOuverture: c.dateOuverture || '' }));
  const res = await envoyerCommande('campagne.initialiser', {
    resume: `À-nouveaux de campagne au ${date} (${soldes.length} compte(s))`,
    comptes: soldes
      .filter((s) => fin.comptes.some((c) => c.id === s.id))
      .map((s) => ({
        id: s.id,
        champs: {
          initial: Number(s.solde) || 0,
          dateOuverture: date,
          noteOuverture: `À-nouveau de campagne au ${date}${s.note ? ` — ${s.note}` : ''}`,
        },
      })),
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };

  // Toutes les écritures antérieures à la date sont sorties du rapprochement.
  const concernes = new Set(soldes.map((s) => s.id));
  const anterieures = [
    ...fin.mouvements
      .filter((m) => String(m.date) < date && (concernes.has(m.compteId) || concernes.has(m.compteCibleId)))
      .map((m) => ({ refErp: m.id, compteId: concernes.has(m.compteId) ? m.compteId : m.compteCibleId, date: m.date, libelle: `${m.type} — ${m.libelle}`, montant: m.montant })),
    ...fin.reglements
      .filter((r) => String(r.date) < date && concernes.has(r.compteId) && r.statut === 'Payé')
      .map((r) => ({ refErp: r.id, compteId: r.compteId, date: r.date, libelle: `Règlement ${r.beneficiaire}`, montant: r.montant })),
  ];
  const deja = new Set(readIgnores().map((x) => x.refErp));
  const nouveaux = anterieures
    .filter((x) => !deja.has(x.refErp))
    .map((x) => ({ ...x, motif: 'Exercice antérieur / Ignoré', le: new Date().toISOString(), par: utilisateur || '—' }));
  writeIgnores([...nouveaux, ...readIgnores()]);

  const initialisation = {
    date,
    le: new Date().toISOString(),
    par: utilisateur || '—',
    comptes: soldes.map((s) => ({ id: s.id, solde: Number(s.solde) || 0 })),
    avant,
    refsIgnorees: nouveaux.map((x) => x.refErp),
  };
  localStorage.setItem(INIT_KEY, JSON.stringify(initialisation));
  tracer({
    action: 'Initialisation',
    entite: 'Campagne — trésorerie',
    refId: date,
    resume: `À-nouveaux au ${date} : ${soldes.length} compte(s) recalés, ${nouveaux.length} écriture(s) antérieure(s) passées en « Exercice antérieur / Ignoré »`,
    utilisateur,
    avant,
    apres: initialisation.comptes,
  });
  return { error: null, ignorees: nouveaux.length, comptes: soldes.length };
}

export async function annulerInitialisationCampagne({ utilisateur } = {}) {
  const init = readInit();
  if (!init) return { error: 'Aucune initialisation de campagne à annuler.' };
  const fin = readFin();
  const res = await envoyerCommande('campagne.annuler', {
    resume: `Annulation de l’initialisation de campagne du ${init.date}`,
    comptes: (init.avant ?? [])
      .filter((a) => fin.comptes.some((c) => c.id === a.id))
      .map((a) => ({
        id: a.id,
        champs: { initial: Number(a.initial) || 0, dateOuverture: a.dateOuverture || '', noteOuverture: '' },
      })),
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const refs = new Set(init.refsIgnorees ?? []);
  writeIgnores(readIgnores().filter((x) => !refs.has(x.refErp)));
  localStorage.removeItem(INIT_KEY);
  tracer({
    action: 'Annulation',
    entite: 'Campagne — trésorerie',
    refId: init.date,
    resume: `Initialisation du ${init.date} annulée : soldes d’ouverture restaurés, ${refs.size} écriture(s) réintégrée(s)`,
    utilisateur,
  });
  return { error: null };
}

// Classification IA (avec repli mots-clés) des lignes de relevé sans correspondance ERP.
export async function classerLignesBanque(lignes) {
  const utiles = (lignes ?? []).filter((l) => Number(l.montant) < 0);
  if (utiles.length === 0) return { classements: [], mode: 'vide' };
  try {
    const r = await fetch(`${API_FIN}/finance/classer-lignes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lignes: utiles.map((l) => ({ id: l.id, date: l.date, libelle: l.libelle, montant: Number(l.montant) })) }),
    });
    if (!r.ok) return { classements: [], mode: 'indisponible' };
    return await r.json();
  } catch {
    return { classements: [], mode: 'indisponible' };
  }
}

// Création automatique de la dépense « frais bancaires » puis pointage de la ligne.
export async function creerFraisBancaire({ compteId, ligne, categorie, libelle, utilisateur }) {
  const montant = Math.abs(Number(ligne.montant) || 0);
  if (montant <= 0) return { error: 'Montant de la ligne bancaire invalide.' };
  if (!categorie) return { error: 'Catégorie de frais manquante.' };
  const { error, row } = await ajouterMouvement({
    date: ligne.date,
    type: 'Dépense',
    compteId,
    categorie,
    libelle: String(libelle || ligne.libelle || categorie).trim(),
    piece: '',
    justificatifRef: `Relevé bancaire — ${ligne.libelle}`,
    montant,
  });
  if (error) return { error };
  tracer({
    action: 'Création',
    entite: 'Frais bancaire (IA)',
    refId: row.id,
    resume: `${categorie} — ${montant.toFixed(3)} TND générés depuis la ligne « ${ligne.libelle} » du relevé`,
    utilisateur,
  });
  return pointerOperation({ compteId, ligne, refErp: row.id, utilisateur });
}

// Transactions ERP du compte, non encore pointées.
export function transactionsErp(compteId) {
  const fin = readFin();
  const dejaPointes = new Set([...readRapp().map((p) => p.refErp), ...readIgnores().map((x) => x.refErp)]);
  const mvts = fin.mouvements
    .filter((m) => m.compteId === compteId || m.compteCibleId === compteId)
    .map((m) => ({
      ref: m.id,
      type: 'mouvement',
      date: m.date,
      libelle: `${m.type} — ${m.libelle}`,
      piece: m.piece,
      montant: montantSigne(compteId, m),
    }));
  const rgs = fin.reglements
    .filter((r) => r.compteId === compteId && r.statut === 'Payé')
    .map((r) => ({
      ref: r.id,
      type: 'reglement',
      date: r.date,
      libelle: `Règlement ${r.beneficiaire}${r.mode ? ` (${r.mode})` : ''}`,
      piece: r.piece,
      montant: -r.montant,
    }));
  return [...mvts, ...rgs].filter((t) => !dejaPointes.has(t.ref));
}

// Suggestion automatique : montant identique, proximité de date, n° de pièce/chèque dans le libellé.
export function suggererCorrespondance(ligne, candidats) {
  const montant = Math.abs(Number(ligne.montant) || 0);
  const libelle = norm(ligne.libelle);
  const scores = candidats
    .map((t) => {
      let score = 0;
      const ecartMontant = Math.abs(Math.abs(t.montant) - montant);
      if (ecartMontant < 0.01) score += 60;
      else if (ecartMontant <= montant * 0.01) score += 35;
      else return { t, score: 0 };
      const j = joursEcart(t.date, ligne.date);
      if (j === 0) score += 25;
      else if (j <= 3) score += 18;
      else if (j <= 7) score += 8;
      const piece = norm(t.piece);
      if (piece && piece.length >= 4 && libelle.includes(piece)) score += 15;
      return { t, score: Math.min(100, score) };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score);
  return scores[0] ? { ...scores[0].t, score: scores[0].score } : null;
}

export async function pointerOperation({ compteId, ligne, refErp, utilisateur }) {
  if (!refErp) return { error: 'Sélectionnez la transaction ERP correspondante.' };
  const rows = readRapp();
  if (rows.some((p) => p.refErp === refErp)) return { error: 'Cette transaction est déjà pointée.' };
  const row = {
    id: `RB-${Date.now()}`,
    compteId,
    refErp,
    dateBanque: ligne.date,
    libelleBanque: ligne.libelle,
    montantBanque: Number(ligne.montant) || 0,
    horodatage: new Date().toISOString(),
    utilisateur: utilisateur || '—',
  };
  writeRapp([row, ...rows]);
  return { error: null, row };
}

// Ligne du relevé sans équivalent ERP : on crée l'écriture de justification puis on la pointe.
// Sert typiquement aux vieux chèques de la saison précédente (« Règlement exercice antérieur »).
export async function justifierLigneBanque({ compteId, ligne, categorie, utilisateur }) {
  const montant = Math.abs(Number(ligne.montant) || 0);
  if (montant <= 0) return { error: 'Montant de la ligne bancaire invalide.' };
  const { error, row } = await ajouterMouvement({
    date: ligne.date,
    type: Number(ligne.montant) < 0 ? 'Dépense' : 'Alimentation',
    compteId,
    categorie: Number(ligne.montant) < 0 ? categorie : null,
    libelle: `${ligne.libelle} — ${categorie}`,
    piece: '',
    justificatifRef: categorie,
    montant,
  });
  if (error) return { error };
  return pointerOperation({ compteId, ligne, refErp: row.id, utilisateur });
}

export async function depointerOperation(id) {
  writeRapp(readRapp().filter((p) => p.id !== id));
  return { error: null };
}

// --- Opérations saisies par le Coursier : workflow de validation stricte ---
// Toute saisie part en « En attente » : aucune imputation comptable avant validation par l'Administrateur.

const OPS_KEY = 'oliva.operations_coursier';
const readOps = () => JSON.parse(localStorage.getItem(OPS_KEY) ?? '[]');
const writeOps = (v) => localStorage.setItem(OPS_KEY, JSON.stringify(v));

export const TYPES_OPERATION = [
  { id: 'frais', label: 'Frais généraux', hint: 'Carburant, matériel, entretien…' },
  { id: 'tiers', label: 'Opération tiers', hint: 'Règlement fournisseur / avance client' },
  { id: 'personnel', label: 'Paiement personnel', hint: 'Avance sur salaire ou paie' },
];
export const SENS_TIERS = ['Règlement fournisseur', 'Avance client'];
export const MOTIFS_PAIE = ['Avance sur salaire', 'Paiement de salaire'];

export async function fetchOperationsCoursier() {
  return readOps();
}

export async function creerOperationCoursier({
  date,
  typeOperation,
  montant,
  categorie,
  libelle,
  tiersId,
  sensTiers,
  employeId,
  motifPaie,
  justificatif,
  saisiPar,
  compteId,
}) {
  const mt = Number(montant) || 0;
  if (mt <= 0) return { error: 'Saisissez un montant supérieur à zéro.' };
  if (!String(libelle || '').trim()) return { error: 'Saisissez le motif de l’opération.' };
  if (!compteId) return { error: 'Sélectionnez la caisse ou la source de trésorerie d’où sort l’argent.' };
  if (typeOperation === 'tiers' && !tiersId) return { error: 'Sélectionnez le tiers concerné.' };
  if (typeOperation === 'personnel' && !employeId) return { error: 'Sélectionnez l’employé concerné.' };

  const rows = readOps();
  // Capturé AVANT l'écriture locale : `publierMaintenant` s'en sert pour remettre le
  // cache dans son état d'origine si le serveur refuse la création.
  const avant = localStorage.getItem(OPS_KEY);
  const row = {
    id: `OP-${Date.now()}`,
    date,
    typeOperation,
    montant: Number(mt.toFixed(3)),
    categorie: categorie || null,
    libelle: String(libelle).trim(),
    tiersId: tiersId || null,
    sensTiers: typeOperation === 'tiers' ? sensTiers || SENS_TIERS[0] : null,
    employeId: employeId || null,
    motifPaie: typeOperation === 'personnel' ? motifPaie || MOTIFS_PAIE[0] : null,
    justificatif: justificatif || null,
    compteId,
    statut: 'En attente',
    saisiPar: saisiPar || '—',
    creeLe: new Date().toISOString(),
    refImputation: null,
    valideePar: null,
    motifRefus: null,
  };
  writeOps([row, ...rows]);
  // Validation automatique globale : l'opération est validée et imputée immédiatement,
  // exactement comme si le gérant l'avait approuvée.
  if (getAutoValidation()) {
    // La validation envoie au serveur un patch de CETTE opération, accompagné de
    // l'état local attendu (`cleLiee`). Elle doit donc arriver APRÈS la création,
    // or la file du store ne publie qu'au bout de 400 ms : on force ici la
    // publication CONFIRMÉE de la clé (version serveur à jour), sans aucun délai.
    try {
      await publierMaintenant(OPS_KEY, avant);
    } catch (e) {
      // Création non confirmée : on ne valide pas, on n'impute pas, et le cache a été
      // remis dans son état d'avant par `publierMaintenant`.
      return {
        error:
          `Opération NON ENREGISTRÉE : ${String(e.message || e)}. Rien n’a été validé ni imputé — ` +
          'vérifiez la base avant de ressaisir.',
        statut: 'creation_echouee',
      };
    }
    const auto = await validerOperationCoursier(row.id, {
      utilisateur: saisiPar ? `${AUTO_VALIDATION_AUTEUR} (${saisiPar})` : AUTO_VALIDATION_AUTEUR,
    });
    if (!auto.error) return { error: null, row: auto.row, statut: 'validee' };
    // La création est acquise côté serveur : l'opération existe et ne doit pas être
    // ressaisie. Seule la validation a échoué — elle reste à faire depuis Validations.
    return {
      error: null,
      row,
      statut: 'validation_echouee',
      detail: auto.error,
      indetermine: Boolean(auto.indetermine),
    };
  }
  return { error: null, row, statut: 'en_attente' };
}

export async function validerOperationCoursier(id, { utilisateur, compteId: compteChoisi, mode = 'Espèces' } = {}) {
  const rows = readOps();
  const op = rows.find((o) => o.id === id);
  if (!op) return { error: 'Opération introuvable.' };
  if (op.statut !== 'En attente') return { error: 'Cette opération est déjà traitée.' };
  // Source de trésorerie choisie à la saisie, sauf redirection explicite du valideur.
  const compteId = compteChoisi || op.compteId || 'crs';
  const montant = Number(op.montant) || 0;
  if (!(montant > 0)) return { error: 'Montant de l’opération invalide.' };
  const fin = readFin();
  const ref = fin.comptes.find((c) => c.id === compteId);
  if (!ref) return { error: 'Caisse de l’opération introuvable.' };
  const dispo = soldeCompte(ref, fin.mouvements, fin.reglements);
  if (montant > dispo && !ref.decouvertAutorise)
    return { error: `Solde insuffisant sur « ${ref.nom} » : ${dispo.toFixed(2)} TND.` };

  // Imputation financière, statut de l'opération et affectation aux bons du tiers :
  // une seule transaction serveur (audit C02), validation refusée aux profils sans
  // droit « validations » (audit C06 : plus d'auto-validation par le coursier).
  const champs = {
    statut: 'Validée',
    refImputation: '@ajout:0',
    valideePar: utilisateur || 'Administrateur',
    valideeLe: new Date().toISOString(),
  };
  let ajout;
  let imputation = { patchs: {} };
  if (op.typeOperation === 'frais') {
    ajout = {
      bucket: 'mouvements',
      ligne: {
        date: op.date,
        type: 'Dépense',
        compteId,
        compteCibleId: null,
        categorie: op.categorie ?? 'Divers',
        libelle: `${op.libelle} (coursier ${op.saisiPar})`,
        piece: op.id,
        justificatif: op.justificatif ?? null,
        montant,
      },
    };
  } else {
    const tiersId = op.typeOperation === 'tiers' ? op.tiersId : op.employeId;
    const compteTiers = await fetchCompteTiers(tiersId);
    const avance = montant > Math.max(0, compteTiers.solde);
    ajout = {
      bucket: 'reglements',
      ligne: {
        date: op.date,
        categorie: 'Tiers',
        beneficiaire: compteTiers.nom,
        tiersId,
        notes: `${op.typeOperation === 'tiers' ? op.sensTiers : op.motifPaie} — ${op.libelle} (coursier ${op.saisiPar})`,
        piece: op.id,
        mode,
        compteId,
        montant,
        acompte: avance,
        statut: 'Payé',
      },
    };
    imputation = calculerImputation({
      tiersId, parcours: 'fournisseur', montant, mode, date: op.date, surAvance: avance,
    });
  }
  const res = await envoyerCommande('coursier.valider', {
    resume: `Validation opération coursier ${op.id} — ${montant.toFixed(3)} TND`,
    ajouts: [ajout],
    liees: [cleLiee(OPS_KEY, [opMaj(id, champs)]), ...lieesImputation(imputation.patchs)],
  });
  if (res.error) return { error: res.error, indetermine: res.indetermine };
  const refImputation = res.ids?.[0] ?? null;
  appliquerImputation(imputation.patchs, refImputation);
  const apres = { ...op, ...champs, refImputation };
  patcherItems(OPS_KEY, { [id]: { ...champs, refImputation } });
  tracer({
    action: 'Modification',
    entite: 'Opération coursier',
    refId: op.id,
    resume: `Validation de ${montant.toFixed(3)} TND (${op.typeOperation}) — imputée sous ${refImputation ?? '—'}`,
    utilisateur,
    avant: op,
    apres,
  });
  return { error: null, row: apres };
}

export async function refuserOperationCoursier(id, { motif, utilisateur } = {}) {
  if (!String(motif || '').trim()) return { error: 'Indiquez le motif du refus.' };
  const rows = readOps();
  const op = rows.find((o) => o.id === id);
  if (!op) return { error: 'Opération introuvable.' };
  if (op.statut !== 'En attente') return { error: 'Cette opération est déjà traitée.' };
  const apres = {
    ...op,
    statut: 'Refusée',
    motifRefus: String(motif).trim(),
    valideePar: utilisateur || 'Administrateur',
    valideeLe: new Date().toISOString(),
  };
  writeOps(rows.map((o) => (o.id === id ? apres : o)));
  tracer({
    action: 'Modification',
    entite: 'Opération coursier',
    refId: op.id,
    resume: `Refus de ${op.montant.toFixed(3)} TND — motif : ${apres.motifRefus}`,
    utilisateur,
    avant: op,
    apres,
  });
  return { error: null, row: apres };
}

// --- Factures libres : diverses (hors stock) et groupées (sous-produits) ---
// Règle B2B : paiement différé — le total alimente la créance du client, jamais la caisse.

const FL_KEY = 'oliva.factures_libres';
const readFL = () => JSON.parse(localStorage.getItem(FL_KEY) ?? '[]');
const writeFL = (v) => localStorage.setItem(FL_KEY, JSON.stringify(v));
function lireFacturesLibres() {
  return JSON.parse(localStorage.getItem('oliva.factures_libres') ?? '[]');
}

export const UNITES_LIGNE = ['unité', 'kg', 'tonne', 'heure', 'voyage', 'forfait'];

const normaliserLignes = (lignes) =>
  (lignes || [])
    .map((l) => ({
      designation: String(l.designation || '').trim(),
      quantite: Number(l.quantite) || 0,
      unite: l.unite || 'unité',
      prixUnitaire: Number(l.prixUnitaire) || 0,
      total: Number(((Number(l.quantite) || 0) * (Number(l.prixUnitaire) || 0)).toFixed(3)),
      ref: l.ref ?? null,
    }))
    .filter((l) => l.designation && l.quantite > 0);

export async function fetchFacturesLibres() {
  return readFL();
}

export async function creerFactureLibre({ date, tiersId, type = 'diverse', lignes, notes, refs }) {
  const detail = normaliserLignes(lignes);
  if (detail.length === 0) return { error: 'Ajoutez au moins une ligne (désignation, quantité, prix).' };
  const client = nomTiers(tiersId);
  if (!tiersId || client === '—') return { error: 'Sélectionnez le client à facturer.' };

  const rows = readFL();
  const id = `FL-${rows.reduce((m, r) => Math.max(m, Number(String(r.id).split('-')[1]) || 0), 5000) + 1}`;
  const row = {
    id,
    numero: null, // le numéro officiel FAC- est attribué uniquement à l'émission explicite
    date,
    tiersId,
    client,
    type,
    lignes: detail,
    refs: refs ?? [],
    notes: String(notes || '').trim(),
    total: Number(detail.reduce((s, l) => s + l.total, 0).toFixed(3)),
    paiement: 'Différé',
  };
  writeFL([row, ...rows]);
  return { error: null, row };
}

export async function ajouterLigneFactureLibre(id, ligne) {
  const detail = normaliserLignes([ligne]);
  if (detail.length === 0) return { error: 'Ligne incomplète.' };
  const rows = readFL();
  const f = rows.find((x) => x.id === id);
  if (!f) return { error: 'Facture introuvable.' };
  const lignes = [...f.lignes, ...detail];
  const apres = { ...f, lignes, total: Number(lignes.reduce((s, l) => s + l.total, 0).toFixed(3)) };
  writeFL(rows.map((x) => (x.id === id ? apres : x)));
  return { error: null, row: apres };
}

// Ligne libre ajoutée en bas d'une facture de vente existante (ex. transport).
export async function ajouterLigneLibreVente(venteId, ligne) {
  const detail = normaliserLignes([ligne]);
  if (detail.length === 0) return { error: 'Ligne incomplète.' };
  const rows = readVentes();
  const v = rows.find((x) => x.id === venteId);
  if (!v) return { error: 'Vente introuvable.' };
  const lignesLibres = [...(v.lignesLibres ?? []), ...detail];
  const supplement = Number(lignesLibres.reduce((s, l) => s + l.total, 0).toFixed(3));
  const apres = {
    ...v,
    lignesLibres,
    supplement,
    total: Number((v.total - (v.supplement ?? 0) + supplement).toFixed(3)),
  };
  writeVentes(rows.map((x) => (x.id === venteId ? apres : x)));
  return { error: null, row: apres };
}

// Facture groupée : fusionne plusieurs voyages de sous-produits d'un même client.
export async function facturerVoyagesGroupes({ date, tiersId, grignons = [], noyaux = [], notes }) {
  const sp = readSp();
  const lignesGr = sp.grignons
    .filter((g) => grignons.includes(g.id))
    .map((g) => ({
      designation: `Grignons d’olive — voyage ${g.id} du ${g.date} (${g.camions} camion(s), transporteur ${g.transporteur})`,
      quantite: Number(g.tonnage) || 0,
      unite: 'tonne',
      prixUnitaire: Number(g.prix) || 0,
      ref: g.id,
    }));
  const lignesNo = sp.noyaux
    .filter((n) => noyaux.includes(n.id))
    .map((n) => ({
      designation: `Noyaux d’olive — lot ${n.id} du ${n.date} (BL ${n.bl}, matricule ${n.matricule})`,
      quantite: Number(n.poids) || 0,
      unite: 'tonne',
      prixUnitaire: Number(n.prix) || 0,
      ref: n.id,
    }));
  const lignes = [...lignesGr, ...lignesNo];
  if (lignes.length === 0) return { error: 'Sélectionnez au moins un voyage à facturer.' };

  const { error, row } = await creerFactureLibre({
    date,
    tiersId,
    type: 'groupee',
    lignes,
    notes,
    refs: [...grignons, ...noyaux],
  });
  if (error) return { error };

  writeSp({
    ...sp,
    grignons: sp.grignons.map((g) => (grignons.includes(g.id) ? { ...g, statut: 'Facturé', facture: row.id } : g)),
    noyaux: sp.noyaux.map((n) => (noyaux.includes(n.id) ? { ...n, facture: true, factureId: row.id } : n)),
  });
  return { error: null, row };
}

// --- Registre des retenues « Fonds des Calamités » (1 %) ---

// Récapitulatif des achats définitivement valorisés, avec ou sans retenue.
// Les provisions serveur constituent le sous-registre fiscal ; aucune caisse ici.
export async function fetchRegistreCalamites({ du, au } = {}) {
  const lignes = read()
    .filter((r) => r.parcours === 'fournisseur' && !['Annulé', 'Sur site'].includes(r.statut))
    .filter((r) => r.mode !== 'negocier' && !(r.mode === 'reel' && !r.rendementReel))
    .filter((r) => (!du || r.date >= du) && (!au || r.date <= au))
    .map((r) => {
      const c = decompte(r);
      return {
        ref: r.id,
        numero: numeroAttribue('bon_reception', r.id),
        date: r.date,
        tiersId: r.tiersId,
        tiers: nomTiers(r.tiersId),
        mf: readContacts().find((x) => x.id === r.tiersId)?.mf ?? '',
        qualite: r.qualite ? labelQualite(r.qualite) : '—',
        poidsNet: Number(c.poidsNet.toFixed(3)),
        montantBrut: Number(c.montantBrut.toFixed(3)),
        retenue: (Math.round(Number(c.montantBrut.toFixed(3)) * 1000) - Math.round(Number(c.montant.toFixed(3)) * 1000)) / 1000,
        provision: c.provisionCalamites,
        charge: c.chargeCalamites,
        net: Number(c.montant.toFixed(3)),
        statut: r.statut,
      };
    })
    .sort((a, b) => (a.date < b.date ? 1 : -1));

  const somme = (k) => Number(lignes.reduce((s, l) => s + l[k], 0).toFixed(3));
  return {
    taux: TAUX_CALAMITES,
    lignes,
    totaux: {
      bons: lignes.length,
      poidsNet: somme('poidsNet'),
      montantBrut: somme('montantBrut'),
      retenue: somme('retenue'),
      provision: somme('provision'),
      charge: somme('charge'),
      net: somme('net'),
    },
    parFournisseur: Object.values(
      lignes.reduce((acc, l) => {
        acc[l.tiersId] = acc[l.tiersId] ?? { tiers: l.tiers, mf: l.mf, bons: 0, montantBrut: 0, retenue: 0, provision: 0, charge: 0 };
        const groupe = acc[l.tiersId];
        groupe.provision = Number((groupe.provision + l.provision).toFixed(3));
        groupe.charge = Number((groupe.charge + l.charge).toFixed(3));
        acc[l.tiersId].bons += 1;
        acc[l.tiersId].montantBrut = Number((acc[l.tiersId].montantBrut + l.montantBrut).toFixed(3));
        acc[l.tiersId].retenue = Number((acc[l.tiersId].retenue + l.retenue).toFixed(3));
        return acc;
      }, {})
    ).sort((a, b) => b.retenue - a.retenue),
  };
}

// --- Facturier : hub consolidé de tous les documents émis ---

export async function fetchFacturier() {
  const rows = [];

  read().forEach((r) => {
    const d = decompte(r);
    rows.push({
      cle: `rec-${r.id}`,
      ref: r.id,
      numero: r.parcours === 'client' ? null : numeroAttribue('bon_reception', r.id),
      operationType: r.parcours === 'client' ? 'prestation_reception' : null,
      typeDoc: r.parcours === 'client' ? 'facture' : 'bon_reception',
      date: r.date,
      tiersId: r.tiersId,
      tiers: nomTiers(r.tiersId),
      categorie: r.parcours === 'client' ? 'Trituration (prestation)' : 'Achat d’olives',
      montant: Number((d.montant || 0).toFixed(3)),
      statut: r.statut === 'Payé' ? 'Payé' : r.parcours === 'client' ? 'Créance' : 'En attente',
      source: 'Réception',
      lignes: [
        ['Parcours', r.parcours === 'client' ? 'Client (trituration)' : 'Fournisseur (achat)'],
        ['Qualité', r.qualite ?? '—'],
        ['Poids net', `${d.poidsNet.toFixed(3)} kg`],
        // Minimum de facturation : complément présenté à part, le poids reste le poids réel.
        ...(r.parcours === 'client' && Number(d.minimumComplement) > 0
          ? [
              ['Trituration au poids réel', `${d.triturationBase.toFixed(3)} TND`],
              [
                `Complément minimum de facturation — seuil ${Number(d.minimum?.seuil || 0).toFixed(0)} kg`,
                `${d.minimumComplement.toFixed(3)} TND`,
              ],
            ]
          : []),
        ['Rendement', `${d.rendement} %`],
        ['Huile', `${d.huile.toFixed(3)} kg`],
        ['Emballages', `${d.emballages.toFixed(3)} TND`],
      ],
    });
    if ((r.emballagesMontant || 0) > 0) {
      rows.push({
        cle: `emb-${r.id}`,
        ref: `${r.id}-EMB`,
        numero: null,
        operationType: 'emballages_reception',
        typeDoc: 'facture',
        date: r.date,
        tiersId: r.tiersId,
        tiers: nomTiers(r.tiersId),
        categorie: 'Emballages fournis (atelier)',
        montant: Number(r.emballagesMontant),
        statut: r.emballagesRegle === true ? 'Payé' : 'Créance',
        source: 'Trituration',
        lignes: (r.emballagesFournis ?? []).map((e) => [
          e.nom,
          `${e.qte} × ${e.prixUnitaire.toFixed(3)} = ${e.total.toFixed(3)} TND`,
        ]),
      });
    }
  });

  readVentes().forEach((v) => {
    rows.push({
      cle: `vte-${v.id}`,
      ref: v.id,
      numero: null,
      operationType: 'vente',
      typeDoc: 'facture',
      date: v.date,
      tiersId: v.tiersId,
      tiers: v.client,
      categorie: v.format === 'vrac' ? 'Vente vrac (kg)' : 'Vente détail (produits finis)',
      montant: Number((v.total || 0).toFixed(3)),
      statut: v.paiement === 'Différé' ? 'Créance' : 'Payé',
      source: 'Ventes',
      lignes: [
        ['Désignation', v.denomination ?? 'Huile d’olive'],
        ['Poids livré', `${(v.kg || 0).toFixed(3)} kg`],
        ...(v.format === 'vrac' ? [] : [['Unités', String(v.unites ?? 0)]]),
        ['Origine', v.cuveNom ?? '—'],
        ...(v.lignesLibres ?? []).map((l) => [l.designation, `${l.total.toFixed(3)} TND`]),
      ],
    });
  });

  lireFacturesLibres().forEach((f) => {
    rows.push({
      cle: `fl-${f.id}`,
      ref: f.id,
      numero: f.numero,
      operationType: 'facture_libre',
      typeDoc: 'facture',
      date: f.date,
      tiersId: f.tiersId,
      tiers: f.client,
      categorie:
        f.type === 'groupee'
          ? 'Sous-produits (groupée)'
          : f.type === 'transport'
            ? 'Transport & logistique'
            : 'Services & prestations',
      montant: f.total,
      statut: 'Créance',
      source: f.type === 'groupee' ? 'Sous-produits' : f.type === 'transport' ? 'Transport' : 'Facturation libre',
      lignes: f.lignes.map((l) => [
        l.designation,
        `${l.quantite} ${l.unite} × ${l.prixUnitaire.toFixed(3)} = ${l.total.toFixed(3)} TND`,
      ]),
    });
  });

  const sp = readSp();
  sp.grignons.forEach((g) => {
    rows.push({
      cle: `gr-${g.id}`,
      ref: g.id,
      numero: numeroAttribue('bon_pesee', g.id),
      typeDoc: 'bon_pesee',
      date: g.date,
      tiersId: null,
      tiers: g.acheteur,
      categorie: 'Grignons (bon de pesée)',
      montant: Number(((g.tonnage || 0) * g.prix).toFixed(3)),
      statut: g.statut === 'Facturé' ? 'Payé' : 'En attente',
      source: 'Sous-produits',
      lignes: [
        ['Transporteur', g.transporteur],
        ['Camions', String(g.camions)],
        ['Tonnage', `${(g.tonnage || 0).toFixed(1)} T`],
        ['Prix', `${g.prix.toFixed(3)} TND/T`],
        ['Facture groupée', g.facture ?? '—'],
      ],
    });
  });
  sp.noyaux.forEach((n) => {
    rows.push({
      cle: `no-${n.id}`,
      ref: n.id,
      numero: numeroAttribue('bon_pesee', n.id),
      typeDoc: 'bon_pesee',
      date: n.date,
      tiersId: null,
      tiers: n.acheteur,
      categorie: 'Noyaux (bon de pesée)',
      montant: Number(((n.poids || 0) * n.prix).toFixed(3)),
      statut: n.facture ? 'Payé' : 'En attente',
      source: 'Sous-produits',
      lignes: [
        ['Transporteur', n.transporteur],
        ['Matricule', n.matricule],
        ['BL', n.bl],
        ['Poids', `${(n.poids || 0).toFixed(1)} T`],
        ['Prix', `${n.prix.toFixed(3)} TND/T`],
      ],
    });
  });

  readAppro().forEach((a) => {
    rows.push({
      cle: `ae-${a.id}`,
      ref: a.id,
      numero: a.piece || a.id,
      typeDoc: 'bon_reception',
      date: a.date,
      tiersId: a.tiersId,
      tiers: a.fournisseur,
      categorie: 'Emballages (consommables)',
      montant: a.total,
      statut: 'En attente',
      source: 'Approvisionnement',
      lignes: a.lignes.map((l) => [l.nom, `${l.unites} × ${l.prixUnitaire.toFixed(3)} = ${l.total.toFixed(3)} TND`]),
    });
  });

  return rows.sort((a, b) => String(b.date).localeCompare(String(a.date)));
}

// ---------------------------------------------------------------------------
// CONTRÔLE DE COHÉRENCE TRÉSORERIE : bons marqués réglés face aux mouvements de
// caisse réellement enregistrés. Le rapprochement par `regleRef` n'est PAS fiable
// (les identifiants `m6` / `r5` sont réattribués à partir de la liste courante : une
// écriture perdue libère son identifiant pour l'opération suivante, et une référence
// périmée peut « retomber » par hasard sur un mouvement sans rapport). On rapproche
// donc les MONTANTS : bon par bon (tiers + date de règlement), puis en cumul par tiers.
// ---------------------------------------------------------------------------
export async function auditCoherenceTresorerie() {
  const r = await fetch(`${API_FIN}/finances/coherence`, { cache: 'no-store' });
  const snapshot = await r.json().catch(() => null);
  if (!r.ok || !snapshot) throw new Error(snapshot?.detail || 'Contrôle serveur indisponible.');
  return calculerCoherence(snapshot, decompte);
}
